/* ============================================================
   FATHERS DAY QUIZ  -  FramedFantasy Father's Day 2026
   Quiz engine for sections/fathers-day-quiz.liquid.

   Built per FramedFantasy_FathersDay_Quiz_Spec_v4.md (Set 2,
   Fantasy World Broad), extended to five questions with a
   morphing question image.

   Flow. Intro, five questions, then one continuous ending screen.
   Each answer she picks sets the hero image shown on the next
   question's page. The ending screen carries the eight archetype
   personality reveal, the proof gallery, and the SMS opt in form.
   On a successful submit the form area swaps in place to the
   confirmation and the shareable card. Plain JavaScript.

   Q1 hobby and Q2 character knowledge inform Jan's first text.
   Q3 is the timing question. Q4 vibe and Q5 personality score
   the eight archetypes.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('ffq-root');
  if (!root) return;

  /* ---------- Config ---------- */
  var CONFIG = { images: {}, questionImages: {}, introThumbs: [], trust: {}, galleryUrls: '', klaviyo: {} };
  var CONFIG_OK = false;
  try {
    var cfgEl = document.getElementById('ffq-config');
    if (cfgEl) { CONFIG = JSON.parse(cfgEl.textContent); CONFIG_OK = true; }
  } catch (e) { /* keep defaults, CONFIG_OK stays false */ }
  var IMG = CONFIG.images || {};
  var Q_IMAGES = CONFIG.questionImages || {};
  var Q_VIDEOS = CONFIG.questionVideos || {};
  var TRUST = CONFIG.trust || {};
  var PRODUCT_URL = CONFIG.productUrl || '/products/fathers-day-portrait-from-photo';
  var INTRO_PROOF = CONFIG.introProof || 'I am Jan. I have painted over 1,000 of these by hand since 2022. More than 500 five star reviews.';
  var FD_CUTOFF = CONFIG.fathersDayCutoff || '2026-06-07';

  /* The proof gallery photos. These 15 are the built in safety net.
     The merchant's own photo list from the theme editor wins whenever
     they have one. Keeping a hardcoded default means the band never
     goes empty even if the config fails to load. */
  var GALLERY_DEFAULT = [
    'https://framedfantasy.com/cdn/shop/files/482512971_2017248132085394_2108276693120287940_n_1.jpg?v=1763790701&width=600',
    'https://framedfantasy.com/cdn/shop/files/ff_sample_2.png?v=1764921019&width=600',
    'https://framedfantasy.com/cdn/shop/files/processed-D1CE8CDD-77FD-457D-9DE9-6D5F757F1D00.jpg?v=1763790384&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7880789626_n2v32vv3.jpg?v=1775463989&width=600',
    'https://framedfantasy.com/cdn/shop/files/ff_sample_3_fb789b48-6b11-4b51-b29d-6fb1ff4603e5.png?v=1764921004&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7815610927_9eailaeq_43488e9b-e739-48a1-b4b5-17fd75a5c8c4.webp?v=1772598257&width=600',
    'https://framedfantasy.com/cdn/shop/files/ig_38136768-75e6-474e-a6fb-ac4f880c06f1.png?v=1763980842&width=600',
    'https://framedfantasy.com/cdn/shop/files/processed-5EFE38F2-53F5-4088-8EFC-1DA596ADCE5F.jpg?v=1763790358&width=600',
    'https://framedfantasy.com/cdn/shop/files/image0.jpg?v=1763789346&width=600',
    'https://framedfantasy.com/cdn/shop/files/GwdD7jy5P_mid_8e8b005c-587c-4fce-9d1a-9133e99f8d2e.jpg?v=1772598254&width=600',
    'https://framedfantasy.com/cdn/shop/files/IMG_4824.jpg?v=1763790297&width=600',
    'https://framedfantasy.com/cdn/shop/files/3image0_1.jpg?v=1763790310&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7395387079_ftfz826a_upscayl_2x_upscayl-standard-4x.png?v=1763790397&width=600',
    'https://framedfantasy.com/cdn/shop/files/FondlyFramed_Review_Image_2.png?v=1763790327&width=600',
    'https://framedfantasy.com/cdn/shop/files/20251030_101824_1.jpg?v=1763790504&width=600'
  ];
  /* Split the merchant's gallery URL list, one URL per line, into a
     clean array. Blank lines, stray whitespace, and any line that is
     not a URL are dropped. */
  function parseGalleryUrls(str) {
    var out = [];
    if (!str || typeof str.split !== 'function') return out;
    var lines = str.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var u = lines[i].replace(/^\s+|\s+$/g, '');
      if (u && /^(https?:)?\/\//.test(u)) out.push(u);
    }
    return out;
  }
  /* The live gallery. The merchant's photo list from the theme editor
     when they have one, the built in default otherwise. Recomputed on
     every editor reload so edits to the list update the band live. */
  function computeGallery() {
    var list = parseGalleryUrls(CONFIG.galleryUrls);
    return list.length ? list : GALLERY_DEFAULT;
  }
  var GALLERY = computeGallery();
  var KL = CONFIG.klaviyo || {};
  var KL_COMPANY = KL.companyId || 'UeMxA4';
  var KL_LIST = KL.listId || 'W8Unvq';
  var KL_REVISION = KL.revision || '2025-10-15';

  /* v36 portrait sizes shown on the reveal as a product-style picker. The
     section settings fill these in (label, descriptor, price, and the
     Shopify variant id Jan pastes). Built-in defaults mirror the D&D
     portrait sizes so the picker works before anything is configured; a
     size with no variantId falls back to the gift product at checkout. */
  /* v38.9 the defaults carry the REAL FramedFantasy gift card variant ids (verified
     live: $99=51803991146813, $139=51803991179581, $199=51803991212349, all in stock).
     So the buy checks out the correct gift card variant even if the section config
     fails to parse (e.g. a Liquid error in another setting) and SIZES falls back here.
     The section settings still override these when the config loads. */
  var DEFAULT_SIZES = [
    { key: 'half',  name: 'Half body', desc: 'face and upper body',    price: '$99',  variantId: '51803991146813', image: '', qty: 22, popular: false },
    { key: 'thigh', name: 'Thigh up',  desc: 'full outfit and stance', price: '$139', variantId: '51803991179581', image: '', qty: 14, popular: true },
    { key: 'full',  name: 'Full body', desc: 'the whole character',    price: '$199', variantId: '51803991212349', image: '', qty: 7,  popular: false }
  ];
  var SIZES = (CONFIG.sizes && CONFIG.sizes.length) ? CONFIG.sizes : DEFAULT_SIZES;
  /* v36.8 the review carousel. A scrolling loop of customer review photos, each
     linking to its Loox review. Editor: review{1..15}_img + _link, plus a
     fallback link. Until Jan adds her own, these placeholders (real customer
     photos) loop, all pointing at the fallback review link she gave. */
  var REVIEW_FALLBACK_LINK = 'https://framedfantasy.com/pages/fathers-day-quiz#qvMP5deEXUB-H';
  var REVIEW_PLACEHOLDERS = [
    'https://framedfantasy.com/cdn/shop/files/20251030_101824_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/3image0_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/482512971_2017248132085394_2108276693120287940_n_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/IMG_4824.jpg',
    'https://framedfantasy.com/cdn/shop/files/processed-5EFE38F2-53F5-4088-8EFC-1DA596ADCE5F.jpg',
    'https://framedfantasy.com/cdn/shop/files/processed-D1CE8CDD-77FD-457D-9DE9-6D5F757F1D00.jpg',
    'https://framedfantasy.com/cdn/shop/files/image0.jpg',
    'https://framedfantasy.com/cdn/shop/files/ig_38136768-75e6-474e-a6fb-ac4f880c06f1.png'
  ];
  /* The review list shown in the carousel. Reads the editor (CONFIG.reviews:
     [{img, link}]), drops slots with no image, and falls back to each review's
     own link, then the editor fallback link, then the built-in one. With nothing
     set it returns the placeholder photos (all using the fallback link). */
  function reviewsList() {
    var cfg = (CONFIG && CONFIG.reviews) || [];
    var fallback = (CONFIG && CONFIG.reviewsLinkFallback) || REVIEW_FALLBACK_LINK;
    var out = [];
    for (var i = 0; i < cfg.length; i++) {
      if (cfg[i] && cfg[i].img) out.push({ img: cfg[i].img, link: cfg[i].link || fallback });
    }
    if (out.length) return out;
    return REVIEW_PLACEHOLDERS.map(function (src) { return { img: src, link: fallback }; });
  }

  var TEST_NAME = 'jangela';
  /* v10 bump: v7 cut character_knowledge entirely and moved timing
     from Q10 to Q3. state.answers shrank from 10 to 9. Old v9 saves
     are silently discarded on next load. */
  var STORE_KEY = 'ffq_progress_v14';
  var AUDIO_MUTE_KEY = 'ffq_audio_muted_v1';

  /* ---------- Background music ----------
     One looping track (Quiet Alehouse Loop). Browsers block autoplay
     until the page has had a user gesture, so the first intro CTA tap
     is what unlocks it. The unlock pattern (create Audio muted, fire
     a no-op play, then unmute) mirrors the character quest engine, and
     it is what lets the subsequent playBGM call actually produce
     sound on iOS Safari and modern Chrome. A small mute toggle lives
     in the top bar; the choice is persisted to localStorage so the
     visitor's preference survives a refresh. */
  var BGM_URL = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Quiet_Alehouse_Loop.mp3?v=1775559877';
  var audioMgr = {
    audio: null,
    unlocked: false,
    /* Once we've ever started the BGM in this page session it must
       NEVER be started again — retake, second CTA click, page mid-
       session navigation. Two latches catch this:
         1. started — flips to true on the first successful play() and
            never resets, so playBGM is permanently no-op after that.
         2. !audio.paused — even if started somehow lied, the live
            audio state is the second line of defense.
       The user reported hearing two desynced loops after Retake; this
       structure makes that impossible. */
    started: false,
    muted: false,
    vol: 0.4,
    isMuted: function () {
      try { return localStorage.getItem(AUDIO_MUTE_KEY) === '1'; }
      catch (e) { return false; }
    },
    setMuted: function (m) {
      this.muted = !!m;
      try { localStorage.setItem(AUDIO_MUTE_KEY, m ? '1' : '0'); } catch (e) {}
      if (this.audio) {
        try { this.audio.muted = !!m; } catch (e) {}
      }
    },
    unlock: function () {
      if (this.unlocked) return;
      this.unlocked = true;
      try {
        var a = new Audio(BGM_URL);
        a.preload = 'auto';
        a.loop = true;
        a.muted = true;
        var p = a.play();
        if (p && p.catch) p.catch(function () {});
        a.pause();
        try { a.currentTime = 0; } catch (e) {}
        a.muted = false;
        this.audio = a;
      } catch (e) { /* swallow, silent quiz is still a working quiz */ }
    },
    playBGM: function () {
      /* Hard guard 1: ever-started latch. */
      if (this.started) return;
      /* Hard guard 2: live audio state. If somehow the latch was reset
         but the audio is already running, bail before play()ing again. */
      if (this.audio && !this.audio.paused) { this.started = true; return; }
      var self = this;
      this.muted = this.isMuted();
      if (!this.audio) {
        try {
          this.audio = new Audio(BGM_URL);
          this.audio.preload = 'auto';
          this.audio.loop = true;
        } catch (e) { return; }
      }
      /* Flip the latch BEFORE play() so any synchronous re-entry from
         a duplicate click or hot path lands in the guard above. */
      this.started = true;
      try {
        this.audio.loop = true;
        this.audio.muted = this.muted;
        this.audio.volume = 0;
        var pp = this.audio.play();
        if (pp && pp.catch) pp.catch(function () {});
        /* Soft fade in so the track does not slam in. */
        var v = 0;
        var iv = setInterval(function () {
          v += 0.04;
          if (v >= self.vol) {
            try { self.audio.volume = self.vol; } catch (e) {}
            clearInterval(iv);
          } else {
            try { self.audio.volume = v; } catch (e) {}
          }
        }, 60);
      } catch (e) {}
    }
  };

  /* Timing constants. Named so the jsdom harness can speed them up. */
  var T_FADE = 190;     /* screen transition */
  var T_CONFIRM = 250;  /* answer confirm beat before advancing */
  var T_BEAT = 1900;    /* reveal reading beat */
  var T_BREATH = 5000;  /* breath screen auto advance, additive on top of T_FADE */

  /* Breath screens. Two transitional content moments between questions.
     Reframe sits between Q2 and Q3. Heirloom sits between Q4 and Q5.
     Each is shown at most once per session, and back navigation from
     the next question skips them. Everything below is overridable from
     the theme editor via the breath block in the Liquid config. */
  /* v24: one pause now, the hinge. It fires between his_character (Q2)
     and the_notice (Q3) and does the heavy lifting of the whole funnel.
     It installs three beliefs at once without naming any of them: that
     this is easy, that it is barely any work, and that it is for his
     own character. The earlier intro / reframe / heirloom pauses were
     removed with the question restructure. */
  var BREATH_DEFAULTS = {
    hinge: {
      label: 'THE EASY PART',
      headline: 'You do not have to know his character.',
      subline: 'He brings it to life himself.',
      prompt: 'continue',
      image: { full: '' },
      video: { src: '', sources: [] }
    }
  };
  var BREATH = mergeBreathConfig(CONFIG.breath);
  function mergeBreathConfig(src) {
    src = src || {};
    var out = {};
    var keys = ['hinge'];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var d = BREATH_DEFAULTS[k];
      var s = src[k] || {};
      out[k] = {
        label: s.label || d.label,
        headline: s.headline || d.headline,
        subline: s.subline || d.subline,
        prompt: s.prompt || d.prompt,
        image: s.image || d.image,
        video: s.video || d.video
      };
    }
    return out;
  }

  /* ---------- Static copy ---------- */
  var TCPA_TEXT = 'By saving your spot you agree to receive text messages from Jan at FramedFantasy at the number provided, including messages sent by autodialer. Consent is not a condition of any purchase. Message and data rates may apply. Message frequency varies. Reply STOP to opt out or HELP for help.';
  var CHECK_SVG = '<svg viewBox="0 0 20 20" fill="none"><path d="M4 10.5l4 4 8-9" stroke="#241b06" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- Headlines, A/B ----------
     Variant A carries an italic gold accent word (modeled on the
     character quest hookEm treatment). The shape is { lead, em, tail }
     so the renderer can wrap the accent in a span. Variant B stays as
     a plain string fallback. headlineHTML below handles either form. */
  /* v22 headline. The quiz is now a gift finder, not a personality
     test. The gold accent lands on the opening word "Finally" so the
     promise (a gift that finally lands) reads from the first glance. The
     em can sit at the head of the line, so the render helper omits the
     lead and the space before a tail that starts with punctuation. */
  var HEADLINES = {
    A: { lead: '', em: 'Finally', tail: ', a gift that proves you get him.' }
  };
  /* Variant B previously held an alternate copy for an A/B test. The
     test was retired in favor of variant A; B now aliases A so any
     visitor whose localStorage saved 'B' still renders the new copy
     instead of falling back to a stale string. */
  HEADLINES.B = HEADLINES.A;
  function headlineHTML(h) {
    if (typeof h === 'string') return esc(h);
    var lead = h.lead ? esc(h.lead) + ' ' : '';
    var em = '<span class="ffq-em">' + esc(h.em) + '</span>';
    /* No space between the gold word and a tail that opens with
       punctuation, so "Finally" + ", a gift…" reads as one clean line. */
    var gap = /^[\s,.;:!?]/.test(h.tail || '') ? '' : ' ';
    var tail = h.tail ? gap + esc(h.tail) : '';
    return lead + em + tail;
  }
  /* HTML (rendered without esc, trusted constant) so "personalized" can be bold. */
  var SUBHEAD = 'Answer a few questions about him, and I will make you a free, <strong>personalized</strong> card.';
  /* Eyebrow label above the headline. Editor-overridable via config. */
  var EYEBROW_LABEL = (CONFIG.eyebrowLabel || 'FATHER\'S DAY 2026');
  /* Small note under the primary CTA. */
  var CTA_NOTE = 'No email required, takes 2 minutes.';
  /* Final proof line below the photo strip. */
  /* HTML (rendered without esc): "Yours is next." gets a subtle gold highlight. */
  var FINAL_PROOF = 'Over 1,000 already gave the gift he never forgot. <span class="ffq-intro__proof-hl">Yours is next.</span>';
  /* Small prelude above the bottom CTA. */
  var BOTTOM_CTA_PRELUDE = 'Let\'s find the one for him.';

  /* ---------- Archetypes ---------- */
  /* Final tiebreak priority order. This is the LAST fallback after
     moral_signature → personality → hobby_vibe all also tie. Sorted
     so the archetypes with the FEWEST total points available across
     the quiz come first, which means ties resolve in favor of the
     under-represented archetype rather than the over-represented one.
     After the v11 rebalance: rogue/bard/barbarian all sit at ~8 total
     points available, ranger/knight at ~9, arcane/DM at ~10, cleric
     at ~12. Cleric sits last because it's the natural "obvious good
     guy" winner and shouldn't also collect free tiebreaks. */
  var ARCH_ORDER = ['sneaky_rogue', 'mighty_barbarian', 'charismatic_bard', 'wild_ranger', 'noble_knight', 'dungeon_master', 'arcane_spellcaster', 'devoted_cleric'];

  /* The bridge line is a universal transition between the heading-
     tagline pair and the three paragraph read. All eight archetypes
     share the same bridge; Family uses a slightly shorter variant. */
  var ARCH_BRIDGE = 'Here\'s what that means about him.';
  /* v5 reveal rewrites. Each read applies the four-part framework:
     P1 hedged opener, P2 specific behavior + universal + Q4 trait
     reference + strange concrete detail + bi-directional pair,
     P3 one rainbow ruse line + one honest unfavorable note + an
     explicit contradiction line, P4 painting placed in a specific
     location triggering a specific behavior in him. Target ~285
     words. Third person throughout. */
  var ARCH = {
    noble_knight: {
      name: 'Noble Knight',
      heading: 'He is the Noble Knight.',
      tagline: 'The one who stands in front of the people he loves.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'ll do the right thing even when no one will know he did. Especially then.',
      read: [
        'You already knew. Years of watching him get quiet when something needs handling, pick up the phone at midnight without complaining. You just didn\'t have a name for it. Now you do.',
        'The Noble Knight is the man who shows up. He\'s the one who does the right thing when no one\'s watching, and you stopped counting how often years ago. He stands quietly between you and whatever\'s coming, before he even thinks about it. He\'ll answer the phone at midnight and not say much, just drive. He remembers the year your grandmother died. He keeps the spare key on a hook by the door because somebody might need it.',
        'The Knight carries a lot. He\'s the one people lean on, because he lets them. That\'s the gift and that\'s the cost. He doesn\'t always know how to put it down. He\'ll carry hard news for a day before he tells you, working out how to say it so it lands the right way. He\'s somebody who needs to be the steady one, and somebody who needs to be allowed not to be. That contradiction is most of him. He apologizes when he\'s wrong, which most people only claim to do.'
      ]
    },
    sneaky_rogue: {
      name: 'Sneaky Rogue',
      heading: 'He is the Sneaky Rogue.',
      tagline: 'He already found the exit and the better way in.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s patient in a way that looks like distraction. He\'ll let you think you\'re winning.',
      read: [
        'You already knew. The smirk before the line lands. The way he clocks a room before he sits down. You\'ve been watching this version of him the whole time. It just didn\'t have a name.',
        'The Sneaky Rogue is the man who notices everything before anyone notices him. He\'s the one who already knows where the back exit is. He clocked the room before he sat down, and you\'ve watched him do it a hundred times. There\'s a smirk he does right before he says something that lands, and you\'ve learned to watch for it. He\'s the one who orders for the table and gets every order right. He\'s the one who picks up the check before you see him.',
        'The Rogue keeps a little of himself back. There\'s a door in him that even you only get through some of the time, and you stopped taking it personally years ago because he lets you in further than he lets anyone. He\'s somebody who lives a step ahead of the room and somebody who\'s quietly counting on you to slow him down. That contradiction runs underneath everything. There\'s a menace to him, and there\'s also more care with the people he picks than anyone gives him credit for.'
      ]
    },
    arcane_spellcaster: {
      name: 'Arcane Spellcaster',
      heading: 'He is the Arcane Spellcaster.',
      tagline: 'He read the manual nobody else bothered to open.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s the one with the question nobody else thought to ask.',
      read: [
        'You already knew. The pause before he answers, the way he remembers small things about people. You\'ve been living with this version of him for years. It just didn\'t have a name.',
        'The Arcane Spellcaster is the man with the question nobody else thought to ask. He\'s the one who read the manual before the box was open, and he\'ll happily explain why the manual is also slightly wrong. He thinks for a living. He pauses before he answers, because he\'s actually thinking, and the room learns to wait for it. He notices when something\'s off in the room before anyone else has named it. He\'ll remember the brand of car your dad drove.',
        'The Spellcaster lives one step ahead of the conversation. It can read as distance. It isn\'t distance. His attention is a real resource and he spends it carefully, and on the days he spends it on you, you can feel the difference. He\'d rather understand a thing than win the argument about it. He\'s also wrong sometimes and takes a beat too long to admit it. That contradiction is most of him. The patience and the pride.'
      ]
    },
    charismatic_bard: {
      name: 'Charismatic Bard',
      heading: 'He is the Charismatic Bard.',
      tagline: 'The party face who is secretly running the table.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s loud at the table and quiet in the car on the way home.',
      read: [
        'You already knew. The way the room shifts when he walks in. The quieter version that surfaces in the kitchen at the end of the night. Both versions are him. You\'ve seen both.',
        'The Charismatic Bard is the man other people end up telling stories about. He\'s the one who comes home with a friend he met at a gas station, and you stopped noticing how often he does it. He laughs at his own jokes a beat before anyone else does. That beat is him deciding the joke is funny, and the rest of the room follows. He remembers names. He remembers the dog\'s name. He\'ll talk to a stranger at the next pump the way he talks to his oldest friend.',
        'The Bard runs on people. The warmth he gives off is real, and it costs him something. He\'s the hardest one to actually reach when he\'s worn out. He\'s somebody who needs the room and somebody who needs the door to close. That contradiction is most of him. The people who think they know him have only met one half. You\'ve met both, and you\'ve seen the quieter face surface in the kitchen at the end of the night.'
      ]
    },
    mighty_barbarian: {
      name: 'Mighty Barbarian',
      heading: 'He is the Mighty Barbarian.',
      tagline: 'The loudest person you love, and the warmest.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s softer than he looks. He\'d be embarrassed if you said it out loud.',
      read: [
        'You already knew. The hugs that crush, the food made for a crowd of twenty when there\'s eight people coming. You\'ve been watching the big version and the quiet one underneath for years.',
        'The Mighty Barbarian is the loudest person you love. He\'s the one who walks into a room and changes the temperature. He laughs a beat before anyone else gets the joke. The kids hear the door and come running before they\'ve even seen him. He hugs too hard. He grills too much food. He says the thing the table was thinking and somehow it lands instead of stinging. He shows up early and stays late, and that\'s most of what he means by love.',
        'The size of him is mostly heart. He runs hot. He\'ll tell you he\'s fine in a voice that\'s plainly not, and twenty minutes later he\'ll tell you the real thing. He\'s louder when he\'s hurting than when he\'s happy, and you learned to watch for that years ago. He\'s somebody who needs to be the biggest person in the room and somebody who tears up at songs from his childhood. That contradiction is most of him. The quiet half is the one you live with. Most people only ever meet the first half.'
      ]
    },
    devoted_cleric: {
      name: 'Devoted Cleric',
      heading: 'He is the Devoted Cleric.',
      tagline: 'Softer than he looks, steadier than he says.',
      bridge: ARCH_BRIDGE,
      pull: 'He notices what people need before they ask. He doesn\'t need anyone to notice.',
      read: [
        'You already knew. The text the day after the hard thing. The chair moved so it\'s easier for someone to sit. You\'ve been watching him take care of people quietly for years.',
        'The Devoted Cleric is the man people call when something has gone wrong. He\'s the one who shows up with food after the funeral. He texts the day after the hard thing to ask how you are really doing. He has done it for years and never made a thing of it. He\'ll refill your glass before you notice it\'s empty. He\'ll move a chair so it\'s easier for someone to sit down. He notices when someone has gone quiet at a table of ten and asks them a small question that lets them back in.',
        'The Cleric gives more than he asks for. When you try to give it back he gets a little awkward, as if care is only supposed to move in one direction. It isn\'t. He\'s somebody who carries the weight for the people he loves and somebody who rarely puts it down where anyone can see. That contradiction is the whole shape of him. He doesn\'t need anyone to notice. You wish, sometimes, that he would let himself be noticed anyway.'
      ]
    },
    wild_ranger: {
      name: 'Wild Ranger',
      heading: 'He is the Wild Ranger.',
      tagline: 'Happiest where the map runs out.',
      bridge: ARCH_BRIDGE,
      pull: 'He keeps his attention small. He tries to know one thing well.',
      read: [
        'You already knew. The way he reads the weather before the radio does. The short list of people he lets all the way in. You\'ve been on that list a long time.',
        'The Wild Ranger is the man who\'s most himself when he\'s a little outside. He\'s the one who reads the manual nobody else opens, then closes it and goes out to look at the thing himself. You\'ve watched him do it for years. He keeps his attention small. One project. One stretch of trees he\'s been walking for years. One short list of people he\'s let all the way in. He\'ll notice the weather changing before the radio does.',
        'The Ranger is a slow open. He warms up the way a fire does. He\'s a bit awkward at first, and then he\'s the one who walks you all the way back to the car. He doesn\'t try to know everything. He tries to know one thing well. He\'s somebody who needs the door open and somebody who locks every door behind him at night. That contradiction is most of him. The people on his short list don\'t always know how rare it is to be on it.'
      ]
    },
    dungeon_master: {
      name: 'Dungeon Master',
      heading: 'He is the Dungeon Master.',
      tagline: 'He built the whole world so you would have somewhere to play.',
      bridge: ARCH_BRIDGE,
      pull: 'He runs the room without anyone realizing he\'s running it.',
      read: [
        'You already knew. The six hours of prep so Friday night feels effortless. The dog\'s name remembered at someone else\'s house. You\'ve been watching him build things for other people for years.',
        'The Dungeon Master is the man who builds things so other people can have somewhere to be. He\'s the one who runs the whole thing without anyone realizing he\'s running it. He prepped for six hours so Friday night would feel effortless. He remembers the dog\'s name at someone else\'s house. He remembers what everyone ordered last time. He asks one good question and pulls the answer back out six months later, exactly when someone needs to be reminded he was actually listening.',
        'The DM doesn\'t need to be the hero. He\'d rather watch the people he loves get the good moments, and set up a few more of those moments than anyone realizes. He\'s quiet in the room he\'s running. He\'s the one moving the table itself, while everyone has fun on top of it. He\'s somebody who loves making things for other people and somebody who forgets he\'s allowed to be made things for. That contradiction is most of him.'
      ]
    }
  };

  var FAMILY = {
    heading: 'Your family is an adventuring party.',
    tagline: 'The shape of you is the shape of a group that decided to stay in this together.',
    bridge: 'Here\'s what that means.',
    pull: 'Some families are built. Yours has been built deliberately, by people who pay attention.',
    read: [
      'You already saw it. The way you operate as a group. The way you cover for each other without anyone asking. You\'ve been the heart of this for years.',
      'Your family is an adventuring party. The shape of you is the shape of a group that decided to stay in this together. Some families happen. Yours has been chosen, year after year.',
      'You see who he becomes when the kids are at the table. You see the small ways he protects them. You see the bits of himself he passes on without making a thing of it. Some families are built. Yours has been built deliberately, by people who pay attention. He\'s a big part of that and he probably doesn\'t say so out loud.'
    ]
  };

  /* ---------- The seven questions ----------
     v3 order:
       Q1 recipient (segmentation, was on homepage)
       Q2 hobby (segmentation)
       Q3 hobby_vibe (SCORED, moved up from Q4 to land the engagement
                      hook earlier)
       [Reframe breath]
       Q4 character_knowledge (segmentation)
       Q5 personality (SCORED)
       [Heirloom breath]
       Q6 moral_signature (SCORED, most differentiating)
       Q7 timing (segmentation, moved to end)
     Tiebreakers run by semantic key (moral_signature first, then
     personality, then hobby_vibe), so this order can move without
     breaking scoring. Each option image (in the config) sets the
     hero on the next page. */
  /* v24 question set. The quiz is no longer a personality test that
     scores an archetype. It is a short belief ladder dressed as warm
     questions about him. Four screens only: recipient, his world, his
     character, the thing only she notices. No score is computed. The
     route (his character vs portrait from photo) and the card content
     are derived from these answers in computeRoute and seedCardFrom-
     Answers. The single hinge pause fires between his_character and
     the_notice. Insider warmth, never explain what D&D is, and every
     question offers a range from "knows it cold" to "knows the shape
     of it" so no answer makes her feel dumb. */
  /* v33 seven steps. Q1 splits her stance (insider vs outsider) and sets
     the voice of the breath and the read. Then recipient, name, world,
     character, the breath, the notice (the emotional peak), and finally
     where to send his card (the email capture). Every answer becomes a
     piece of the card or the read. The breath fires after his_character,
     right before the_notice. */
  var QUESTIONS = [
    /* v38 occasion question removed: this funnel is Father's Day only now. The
       occasion helpers below (occasionKey/Greet/Stamp/GiveStep/Label) all default
       to Father's Day, so the card greeting, stamp, and buyer step stay FD without
       any question. Do not re-add an occasion question without restoring those.
       Q1 stance. The opener. Branches the voice everywhere after. */
    {
      key: 'stance',
      stem: 'First, are you in his world too, or is this his thing?',
      micro: '',
      options: [
        { label: 'I roll dice with him', store: 'insider' },
        { label: 'I am around it, I know his world', store: 'semi' },
        { label: 'It is his thing, I just love him', store: 'outsider' }
      ]
    },
    /* Q2 recipient. Drives the sign-off and the route. */
    {
      key: 'recipient',
      stem: 'Who are you making this for?',
      micro: 'Pick the person.',
      options: [
        { label: 'My husband', store: 'Husband' },
        { label: 'My partner', store: 'Partner' },
        { label: 'My dad', store: 'Dad' },
        { label: 'My whole family', store: 'Whole family' }
      ]
    },
    /* Q3 his_name. Two text fields now: his name for the greeting on the
       front of the card, and her name for the sign-off at the bottom. Both
       optional, each with a graceful fallback, so neither blocks. */
    {
      key: 'his_name',
      type: 'names',
      stem: 'What do you call him, and who is it from?',
      micro: 'His name goes on the front. Yours signs the bottom.',
      placeholder: 'His name',
      fromPlaceholder: 'Your name'
    },
    /* Q4 his_world. Picks the card scene and leans the route. */
    {
      key: 'his_world',
      stem: 'What world does he disappear into?',
      micro: '',
      options: [
        { label: 'A table with his crew and a pile of dice', store: 'DnD' },
        { label: 'A game he disappears into for hours', store: 'VideoGame' },
        { label: 'The books and worlds he keeps in his head', store: 'Reading' },
        { label: 'Honestly, a bit of everything', store: 'Mix' }
      ]
    },
    /* Q5 his_character. Locks the route, feeds the read. */
    {
      key: 'his_character',
      stem: 'Has he got a character he keeps coming back to?',
      micro: '',
      options: [
        { label: 'Yeah, the same one for years', store: 'same' },
        { label: 'He is always rolling up new ones', store: 'several' },
        { label: 'He talks about someone, but I do not know the details', store: 'someone' },
        { label: 'Not sure, but he is always in that world', store: 'unsure' }
      ]
    },
    /* Q6 the_notice. The emotional peak. Becomes the message on the card
       and the heart of the read. The breath fires just before it. */
    {
      key: 'the_notice',
      stem: 'What is the thing only you would notice about him?',
      micro: '',
      options: [
        { label: 'He puts himself between us and trouble without thinking', store: 'protector' },
        { label: 'He takes care of everyone before himself', store: 'caretaker' },
        { label: 'He is softer than he lets anyone see', store: 'softer' },
        { label: 'He goes quiet, then says the one thing that matters', store: 'quiet' },
        { label: 'He is the reason everyone at the table is laughing', store: 'funny' },
        { label: 'He is three moves ahead and lets you think you are winning', store: 'clever' }
      ]
    }
    /* v35 the send_to email page was removed. Email is now harvested at the
       reveal, gated on the free card download (see downloadBlock). The quiz
       is six questions and answering the_notice goes straight to the loader. */
  ];
  var RECIPIENTS = [
    { value: 'husband', label: 'My husband', map: 'Husband', phrase: 'your husband' },
    { value: 'boyfriend', label: 'My boyfriend or partner', map: 'Boyfriend or partner', phrase: 'your partner' },
    { value: 'dad', label: 'My dad', map: 'Dad', phrase: 'your dad' },
    { value: 'whole_family', label: 'My whole family', map: 'Whole family', phrase: 'your family' }
  ];

  /* ---------- State ---------- */
  var state = {
    view: 'intro',
    step: 0,
    recipient: '',
    branch: 'Standard',
    answers: [null, null, null, null, null, null],
    /* v33 her stance from Q1: insider, semi, or outsider. Branches the
       breath voice and the reveal read. */
    stance: '',
    archetype: '',
    scores: {},
    headlineVariant: '',
    firstName: '',
    email: '',
    phone: '',
    country: 'US',
    hisName: '',
    /* v29 her name for the sign-off, optional. Blank falls back to the
       relationship sign-off from question one. */
    fromName: '',
    cardAspect: '4x5',
    /* v23 invitation builder state. cardMessage is the line she picks
       or writes for the invitation. cardMsgPreset tracks which preset
       chip is active (for the selected highlight) or 'custom' when she
       has typed her own. cardTheme defaults from her hobby answer (his
       world) but she can change it in the builder. */
    cardMessage: '',
    cardMsgPreset: '',
    cardTheme: '',
    /* v34.1 in-place edits of the card text. Each holds her override of the
       computed line. Empty means use the value built from her answers. */
    cardGreeting: '',
    cardSummons: '',
    cardSignoff: '',
    /* v37.6 (Change 5) his character's name, captured on Q6 only when she
       says he keeps coming back to the same one. Optional. Prefills the
       editable "your character" words on the card (Change 4). */
    characterName: '',
    /* v37.6 (Change 4) her in-place edit of the "your character" words on the
       card. Empty means use the captured quiz name, or the default. */
    cardCharacter: '',
    /* v36 the portrait size she picked on the reveal. Blank resolves to the
       most popular size. Drives the card size line and the checkout variant. */
    sizeKey: '',
    /* v34.1 set once she has seen the how-the-code-works lightbox, so it
       auto-opens only the first time she touches the code area. */
    stepsSeen: false,
    /* v39 (Rebuild 4) true once the post-confirm reveal prompt has shown or
       she has opened the reveal herself, so it only ever leads her in once.
       Persisted. */
    presentPromptSeen: false,
    /* Her optional written line about him (legacy capture field, retained
       for saved-state compatibility). Unused by the live flow. */
    notesText: '',
    /* v24 gift route, set by computeRoute from her answers. 'character'
       (default, the higher want) or 'portrait' (the photo fallback). */
    giftRoute: '',
    /* v27 paste-to-unlock. After she buys the gift, she pastes the code
       Shopify gave her here. The invitation then renders with his code
       on it and that finished version becomes the download. Persisted so
       a reload after purchase keeps the finished card. Empty before
       purchase, where the card shows the locked, empty panel. */
    unlockCode: '',
    /* Per-session flags so each breath screen fires at most once and
       back-navigation from the next question skips it cleanly. Not
       persisted: a fresh page load gives the breath a chance again. */
    breathShown: { hinge: false },
    /* v17: timing moved out of the quiz body and into the SMS opt-in
       form. Stored as its own state field instead of an answers[]
       index because the form drives it, not the question engine. */
    timing: ''
  };
  var tracked = {};
  /* Module-scoped handle for the active breath auto-advance timer so
     navigation away from a breath screen (back button, retake, refresh)
     never leaves an orphaned timeout running. */
  var breathTimer = null;
  function clearBreathTimer() {
    if (breathTimer) { clearTimeout(breathTimer); breathTimer = null; }
  }
  /* v28.1 guard so the collapsed message picker's document-level
     outside-click and Escape handlers are attached only once, never
     restacked across builder re-renders. */
  var msgpickDocBound = false;
  /* v34.1 guard so the lightbox Escape-to-close handler is attached once. */
  var stepsDocBound = false;

  /* ---------- Small helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) { try { return crypto.randomUUID(); } catch (e) {} }
    return 'ffq-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function h(html) {
    var t = document.createElement('template');
    t.innerHTML = String(html).trim();
    return t.content.firstChild;
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function recipientObj() {
    for (var i = 0; i < RECIPIENTS.length; i++) {
      if (RECIPIENTS[i].value === state.recipient) return RECIPIENTS[i];
    }
    return RECIPIENTS[0];
  }


  /* ---------- Storage ---------- */
  function save() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({
        view: state.view, step: state.step, recipient: state.recipient,
        branch: state.branch, answers: state.answers,
        timing: state.timing,
        /* v23 invitation builder fields. v24 adds giftRoute. */
        stance: state.stance, email: state.email, phone: state.phone,
        hisName: state.hisName, fromName: state.fromName, cardMessage: state.cardMessage,
        cardGreeting: state.cardGreeting, cardSummons: state.cardSummons,
        cardSignoff: state.cardSignoff, stepsSeen: state.stepsSeen,
        presentPromptSeen: state.presentPromptSeen,
        characterName: state.characterName, cardCharacter: state.cardCharacter,
        sizeKey: state.sizeKey,
        notesText: state.notesText,
        cardMsgPreset: state.cardMsgPreset, cardTheme: state.cardTheme,
        giftRoute: state.giftRoute, unlockCode: state.unlockCode,
        headlineVariant: state.headlineVariant, ts: Date.now()
      }));
    } catch (e) {}
  }
  function loadSaved() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      /* v34 keep her card for 60 days, not 24 hours, so she can buy, get a
         code, come back days later, and her finished card and answers are
         still here to paste into without retaking the quiz. */
      if (!d || !d.ts || Date.now() - d.ts > 60 * 24 * 3600 * 1000) return null;
      return d;
    } catch (e) { return null; }
  }
  function clearSaved() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }

  /* ---------- Scoring ---------- */
  function answersComplete() {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (state.answers[i] == null) return false;
    }
    return true;
  }
  function answerStore(idx) {
    var ai = state.answers[idx];
    if (ai == null) return '';
    var q = QUESTIONS[idx];
    if (!q || !q.options) return '';
    /* Multi-select questions store an array of selected indices, not
       a single index. For these, return the joined store values.
       answerMulti() returns the array form for callers that need it. */
    if (q.type === 'multi') {
      if (!Array.isArray(ai)) return '';
      var parts = [];
      for (var m = 0; m < ai.length; m++) {
        var o = q.options[ai[m]];
        if (o && o.store) parts.push(o.store);
      }
      return parts.join(', ');
    }
    var opt = q.options[ai];
    return opt ? opt.store : '';
  }
  /* v37.6 (Change 5) index of the option carrying a given store value on a
     question, or -1. Lets the his_character handler find the "same one for
     years" option by meaning instead of a hardcoded position. */
  function storeIndex(q, store) {
    if (!q || !q.options) return -1;
    for (var i = 0; i < q.options.length; i++) {
      if (q.options[i] && q.options[i].store === store) return i;
    }
    return -1;
  }
  /* Multi-select sibling of answerStore. Returns the array of
     selected store strings (or empty array if not yet picked). Used
     by buildProperties to JSON-stringify trait_curation. */
  function answerMulti(key) {
    var i = indexByKey(key);
    if (i < 0) return [];
    var ai = state.answers[i];
    if (!Array.isArray(ai)) return [];
    var q = QUESTIONS[i];
    if (!q || !q.options) return [];
    var out = [];
    for (var m = 0; m < ai.length; m++) {
      var o = q.options[ai[m]];
      if (o && o.store) out.push(o.store);
    }
    return out;
  }
  /* ---------- Semantic lookups ----------
     v3 refactor. Anywhere we used to reference a question by its
     position in the array (e.g. "the question at index 4 is the
     scored personality one") now goes through these helpers. Lets us
     reorder QUESTIONS without breaking scoring, image lookup, breath
     insertion, or Klaviyo property writes. */
  function indexByKey(key) {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (QUESTIONS[i].key === key) return i;
    }
    return -1;
  }
  function answerByKey(key) {
    var i = indexByKey(key);
    return i >= 0 ? answerStore(i) : '';
  }
  /* Map a semantic question key to the legacy editor image slot. The
     Liquid theme settings (q1_image, q2_image, etc.) were authored
     before the v3 reorder; rather than renaming all the editor
     settings (which would orphan Jan's existing uploads) we map by
     intent here. New questions get new slots. */
  var IMG_SLOT = {
    /* v38.8 every one of the six questions maps to its own editor image slot, so
       each question's image is editable on its own from the theme editor. Existing
       slot ids (recipient/q1/q3/q4/q6) are kept so prior uploads still show; only
       the opener got a new dedicated slot (was sharing the recipient image). */
    stance: 'stance',                /* Q1  In his world?            -> q_stance_image */
    recipient: 'recipient',          /* Q2  Who is it for?           -> recipient_picker_image */
    his_name: 'q3',                  /* Q3  His name + yours         -> q3_image */
    his_world: 'q1',                 /* Q4  Where does he go?        -> q1_image (+ family) */
    his_character: 'q4',             /* Q5  His character            -> q4_image */
    the_notice: 'q6'                 /* Q6  What only you notice     -> q6_image */
  };
  /* v33 a visible placeholder for any screen that has no uploaded image,
     so the image area is always present and obvious to fill. */
  function heroPlaceholderHTML() {
    return '<div class="ffq-qhero ffq-qhero--ph" aria-hidden="true"></div>';
  }
  /* v37.2 Jan wants a real placeholder image on every question + pause screen
     (not just an empty frame) so the funnel never looks unfinished, even before
     he uploads the exact image for each one. We deal them from the portfolio
     pool by index so each screen gets a stable, different portrait. Falls back
     to the empty frame only if the pool is somehow empty. */
  function placeholderFromGallery(n) {
    var pool = GALLERY_DEFAULT;
    if (!pool.length) return '';
    return pool[((n % pool.length) + pool.length) % pool.length];
  }
  function questionPlaceholderImgHTML(idx) {
    var src = placeholderFromGallery(idx);
    if (!src) return heroPlaceholderHTML();
    return '<div class="ffq-qhero ffq-qhero--phimg">' +
      '<img src="' + esc(src) + '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  function breathPlaceholderImgHTML() {
    /* offset 7 so the pause portrait differs from the early-question ones */
    var src = placeholderFromGallery(7);
    if (!src) return '<div class="ffq-breath__media ffq-breath__media--ph" aria-hidden="true"></div>';
    return '<div class="ffq-breath__media ffq-breath__media--phimg">' +
      '<img src="' + esc(src) + '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  /* v24: archetype scoring removed. The quiz computes a gift ROUTE,
     not an archetype. Two routes: 'character' (the higher want, the
     thing a cheap tool cannot fake, the default) and 'portrait' (turn
     him into the hero from a photo she already has). Lean hard toward
     character. Fall back to portrait only when there is clearly no
     character to bring to life: the whole-family recipient, or a pure
     video-game fan who has not made a character. The hinge pause means
     she never has to describe a character she only half knows, so the
     character route is safe even when she picked "I do not know the
     details" or "I am not sure." */
  function computeRoute() {
    if (state.recipient === 'whole_family') { state.giftRoute = 'portrait'; return; }
    var world = answerByKey('his_world');
    var character = answerByKey('his_character');
    /* The only non-family fallback: a video-game world with no
       character he has made. Everyone else gets the character route. */
    if (world === 'VideoGame' && character === 'unsure') { state.giftRoute = 'portrait'; return; }
    state.giftRoute = 'character';
  }
  /* Seed the invitation card from her answers so a finished, beautiful
     card is waiting with nothing to build. She can still change the
     message, but she should not have to. World sets the scene theme,
     the_notice sets which care line surfaces as the message. */
  var NOTICE_TO_PRESET = {
    protector: 4,
    caretaker: 1,
    softer: 0,
    carries: 2,
    quiet: 3,
    funny: 5,
    clever: 6
  };
  function seedCardFromAnswers() {
    if (!state.cardTheme) state.cardTheme = defaultThemeForHobby();
    /* Only seed the message if she has not already written or picked
       one (so re-entering the builder does not overwrite her edit). */
    if (!state.cardMessage) {
      var notice = answerByKey('the_notice');
      var idx = NOTICE_TO_PRESET[notice];
      if (idx == null) idx = 0;
      state.cardMessage = INVITE_PRESETS[idx] || INVITE_PRESETS[0];
      state.cardMsgPreset = String(idx);
    }
  }
  function firstTextTemplate() {
    /* v7: character_knowledge cut, so Template 1 now triggers on
       hobby = DnD alone (no character-knowledge dependency). */
    if (state.branch === 'Family') return 'Template 5';
    /* v17: timing reads from state.timing (form data) instead of
       the answers[] array since it's no longer a quiz question. */
    if (state.timing === 'ASAP') return 'Template 4';
    if (answerByKey('his_world') === 'DnD') return 'Template 1';
    return 'Template 2';
  }

  /* ---------- Reveal data ---------- */
  /* Returns the cleaned full label of the picked trait_curation
     option: leading emoji stripped, first letter lowercased so it
     reads naturally inside "You said it's [...]", trailing period
     removed (the sentence adds its own). Empty string if no pick. */
  function pickedTraitLabel() {
    var idx = indexByKey('trait_curation');
    if (idx < 0) return '';
    var ai = state.answers[idx];
    if (ai == null) return '';
    var q = QUESTIONS[idx];
    if (!q || !q.options || !q.options[ai]) return '';
    var label = q.options[ai].label || '';
    /* Skip leading non-letter characters (emoji + variation
       selectors + whitespace) by finding the first ASCII letter. */
    var m = label.match(/[A-Za-z]/);
    if (m) label = label.slice(m.index);
    if (label.length) label = label.charAt(0).toLowerCase() + label.slice(1);
    label = label.replace(/\.\s*$/, '');
    return label;
  }
  /* Builds the reveal-screen sentence above the archetype heading.
     Standard: "You said it's [trait]. Here's the rest of him."
     Family:   "You said it's [trait]. That's the shape of this family."
     Returns empty string if she somehow didn't pick a trait. */
  /* "Save your [relationship]'s archetype" label for the reveal-page
     card download button. Keyed off state.recipient (set by the Q1
     pick). Falls back to a generic label when recipient is missing
     or unrecognized, so the button never shows broken copy. */
  function cardButtonLabel() {
    var rel = ({
      husband:      'HUSBAND',
      boyfriend:    'PARTNER',
      dad:          'DAD',
      whole_family: 'FAMILY'
    })[state.recipient];
    if (!rel) return 'SAVE YOUR ARCHETYPE CARD';
    return 'SAVE YOUR ' + rel + '\'S ARCHETYPE CARD';
  }
  function traitPicksSentence() {
    var trait = pickedTraitLabel();
    if (!trait) return '';
    if (state.branch === 'Family') {
      return 'You said it\'s ' + trait + '. That\'s the shape of this family.';
    }
    return 'You said it\'s ' + trait + '. Here\'s the rest of him.';
  }
  function revealData() {
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    if (state.branch === 'Family') {
      /* v5: Family reveal opens with the trait-picks sentence (was
         the dynamic "He is the [archetype name] at the center of it"
         prepend in v3). The three Family paragraphs that follow are
         unchanged. If she somehow reached Family without picking 3
         traits, fall back to the v3 archetype prepend so the read is
         never broken. */
      var fOpen = traitPicksSentence();
      if (!fOpen) fOpen = 'He is the ' + a.name + ' at the center of it.';
      return {
        heading: FAMILY.heading,
        tagline: FAMILY.tagline,
        imageKey: 'family',
        read: [fOpen].concat(FAMILY.read),
        bridge: FAMILY.bridge,
        pull: FAMILY.pull,
        cardLabel: 'YOUR FAMILY IS',
        cardName: 'AN ADVENTURING PARTY',
        cardTagline: FAMILY.tagline
      };
    }
    return {
      heading: a.heading,
      tagline: a.tagline,
      imageKey: state.archetype,
      read: a.read,
      bridge: a.bridge,
      pull: a.pull,
      cardLabel: 'HE IS THE',
      cardName: a.name.toUpperCase(),
      cardTagline: a.tagline
    };
  }

  /* ---------- Tracking ---------- */
  function fbTrack(name, custom) {
    if (typeof window.fbq !== 'function') return;
    try {
      var params = { eventID: uuid() };
      if (name === 'Lead') window.fbq('track', 'Lead', custom || {}, params);
      else window.fbq('trackCustom', name, custom || {}, params);
    } catch (e) {}
  }
  function gaTrack(name, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch (e) {}
  }
  function trackOnce(key, fn) { if (tracked[key]) return; tracked[key] = true; fn(); }

  /* ---------- Meta CompleteRegistration (browser pixel + Conversions API) ----------
     Mirrors the Fantasy Portrait from Photo product page. Fires a
     CompleteRegistration event when someone finishes the quiz and submits
     their name and number, so a Meta custom conversion can optimize ad
     delivery toward quiz finishers who leave a contact.

     Browser fbq and the server-side Conversions API POST share one
     event_id, so Meta dedupes them into a single conversion. The CAPI
     half is what guarantees the event lands even when the browser pixel
     is blocked. user_data is SHA-256 hashed (phone, first name) per
     Meta's requirement. event_source_url is the live quiz page path with
     query params stripped, so a URL-rule custom conversion never breaks
     on ?utm or ?fbclid. Same dataset (1018487760235510) and token as the
     PFP page. Errors are swallowed so this can never break the quiz. */
  function capiCompleteRegistration(e164, first) {
    var eventId = 'FDQSubmit_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    var eventTime = Math.floor(Date.now() / 1000);
    var sourceUrl;
    try { sourceUrl = window.location.origin + window.location.pathname; }
    catch (e) { sourceUrl = 'https://framedfantasy.com/pages/fathers-day-quiz'; }
    var customData = {
      content_name: 'Fathers Day Quiz Signup',
      content_category: 'Fathers Day Quiz 2026'
    };

    /* Browser-pixel half of the dedupe pair. */
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', 'CompleteRegistration', customData, { eventID: eventId }); } catch (e) {}
    }

    /* Server (Conversions API) half. */
    try {
      if (!window.crypto || !window.crypto.subtle || typeof window.TextEncoder === 'undefined') return;
      function sha256(str) {
        var buf = new window.TextEncoder().encode(String(str));
        return window.crypto.subtle.digest('SHA-256', buf).then(function (hash) {
          var bytes = new Uint8Array(hash);
          var out = '';
          for (var i = 0; i < bytes.length; i++) {
            out += bytes[i].toString(16).padStart(2, '0');
          }
          return out;
        });
      }
      var cleanPhone = String(e164 || '').replace('+', '').toLowerCase();
      var cleanName = String(first || '').toLowerCase().trim();
      Promise.all([sha256(cleanPhone), sha256(cleanName)]).then(function (hashes) {
        var payload = {
          data: [{
            event_name: 'CompleteRegistration',
            event_time: eventTime,
            event_id: eventId,
            event_source_url: sourceUrl,
            action_source: 'website',
            user_data: { ph: [hashes[0]], fn: [hashes[1]] },
            custom_data: customData
          }]
        };
        /* R-WAVE1: routed through the quest-ai worker /capi route. The old
           client side token (a second, separate token from the quest one)
           was removed and must be invalidated in Meta Events Manager. */
        fetch('https://quest-ai.fondlyframed.workers.dev/capi', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Proof gallery ---------- */
  function galleryRow() {
    var row = '';
    for (var i = 0; i < GALLERY.length; i++) {
      row += '<img class="ffq-gallery__img" src="' + esc(GALLERY[i]) +
        '" alt="A FramedFantasy portrait, sent in by a customer" loading="lazy" decoding="async" draggable="false">';
    }
    /* Three copies (not two) so the drag wrap stays seamless in BOTH
       directions: while the auto-drift only moves forward, a user can
       fling backward via drag/momentum and I need the row to the left
       of the centered set as well. The mountMarquee runtime computes
       singleSetWidth = scrollWidth / 3 and wraps in [0, 2W]. */
    return '<div class="ffq-gallery__viewport"><div class="ffq-gallery__track" data-ffq-marquee>' + row + row + row + '</div></div>';
  }
  function statsHTML() {
    return '<div class="ffq-gallery__stats">' +
      '<span>' + esc(TRUST.reviews || '500 plus') + ' five star reviews</span>' +
      '<span>' + esc(TRUST.commissions || '1000 plus') + ' commissions since ' + esc(TRUST.year || '2012') + '</span>' +
      '<span>Two weeks to a first painting</span>' +
      '</div>';
  }
  function galleryHTML() {
    /* The old numeric trust stats row was removed in this pass. The
       photos themselves carry the proof now, and Loox reviews mount
       further down the page for the hard social-proof layer. */
    if (!GALLERY.length) return '';
    return '<div class="ffq-gallery">' +
      /* The mobile-only <br> forces a line break between "Real portraits,"
         and "real homes" so the headline reads as two centered phrases
         on phones. Desktop keeps it on one line via the CSS rule that
         hides .ffq-br-mobile at the desktop breakpoint. */
      '<p class="ffq-gallery__head">Real portraits,<br class="ffq-br-mobile"> real players</p>' +
      '<p class="ffq-gallery__sub">Sent in by the people I painted them for</p>' +
      galleryRow() + '</div>';
  }
  /* A heading free scrolling band of the same proof photos, used on the
     intro screen. Uses the fixed CDN urls, so it always shows. */
  function galleryBand() {
    if (!GALLERY.length) return '';
    return '<div class="ffq-gallery ffq-gallery--band">' + galleryRow() + '</div>';
  }

  /* ---------- Sample archetype deck (working carousel) ----------
     Same model as the character quest "What other players got"
     carousel: each card's transform is computed from its offset to
     the centered index, side cards are clickable to recenter, arrow
     buttons step prev/next, and horizontal touch swipes paginate.
     The order is fixed so that noble_knight sits at index 2, which
     is the initial center. The flanking spread balances the fan
     visually (gold bard + spellcaster nearest, barbarian + ranger
     outer). Mount happens via mountDecks() after every paint. */
  function deckHTML() {
    /* v26: the deck no longer shows the eight named archetypes (a
       result the quiz no longer gives). It is now a carousel of real
       customer portraits, framed as the kind of painting he ends up
       with. Proof, not a dead feature. Cards are image-only and pull
       from the same GALLERY photo list as the proof strip. If there
       are no photos, the deck is skipped entirely. */
    var pics = (GALLERY && GALLERY.length) ? GALLERY.slice(0, 8) : [];
    if (pics.length < 3) return '';
    var initialIdx = Math.floor(pics.length / 2);
    var cards = '';
    for (var i = 0; i < pics.length; i++) {
      cards += '<div class="ffq-deck__card ffq-deck__card--photo" data-ffq-deck-card="' + i + '">' +
        '<div class="ffq-deck__card-img"><img src="' + esc(pics[i]) + '" alt="A FramedFantasy portrait in a customer home" decoding="async" loading="lazy" draggable="false"></div>' +
        '<p class="ffq-deck__card-foot">FRAMEDFANTASY</p>' +
      '</div>';
    }
    return '<div class="ffq-deck ffq-deck--proof">' +
      '<p class="ffq-deck__head">The portrait he keeps</p>' +
      '<p class="ffq-deck__sub">Real portraits I painted, every one of them his to keep.</p>' +
      '<div class="ffq-deck__area" data-ffq-deck data-ffq-deck-init="' + initialIdx + '">' +
        '<button type="button" class="ffq-deck__arrow ffq-deck__arrow--prev" data-ffq-deck-arrow="prev" aria-label="Previous portrait">&lsaquo;</button>' +
        '<div class="ffq-deck__fan">' + cards + '</div>' +
        '<button type="button" class="ffq-deck__arrow ffq-deck__arrow--next" data-ffq-deck-arrow="next" aria-label="Next portrait">&rsaquo;</button>' +
      '</div>' +
    '</div>';
  }

  /* ---------- Deck carousel runtime ----------
     Ported from character-quest.js, translated to vanilla. For each
     card we compute raw = i - idx, wrap raw to [-n/2, n/2], then
     branch on absOff: 0 center, 1 flanking, 2 outer, >2 hidden. The
     transforms are written inline so the same elements re-flow into
     their new slots when idx changes, the CSS transition handles the
     slide. Mount is idempotent via data-ffq-deck-ready. */
  /* ---------- Loox reviews teleport ----------
     Locates the Loox section anywhere on the page (regardless of how
     Shopify named the wrapper, which can vary between direct JSON
     edits and theme editor additions) and moves it into the result
     screen mount. The selector ladder tries, in order:
       1. The exact id we expect from JSON edits (#shopify-section-loox_reviews)
       2. Any shopify-section whose id contains "loox"
       3. Any shopify-section that contains a Loox widget descendant
     Loox populates widgets on page load, so by the time the result
     screen paints we're just relocating an already rendered node.
     Retry once after 400 ms in case Loox injected late. */
  /* Hunts the Loox section in the DOM. When the merchant adds the
     Loox block via the Shopify theme editor, Shopify assigns the
     wrapper a random hash id like shopify-section-1779383151f64ec88e
     so we cannot rely on the literal name. We try the most specific
     selectors first, then fall back to "any shopify-section that is
     not the FFQ main section and is not theme chrome." Every
     candidate must pass an ancestor check via Node.contains: if the
     candidate already contains the mount point, appending it into
     the mount would create a DOM cycle and throw
     HierarchyRequestError. That happens for shopify-section-main
     (the FFQ's own wrapper) and for any section-group wrapper that
     wraps main. We just skip those silently and keep looking. */
  function findLooxSection(mount) {
    /* Helper: a candidate is safe to move into the mount only when
       it is not the mount itself AND it does not contain the mount. */
    function safe(node) {
      if (!node) return false;
      if (node === mount) return false;
      if (node.contains && node.contains(mount)) return false;
      return true;
    }
    var literal = document.getElementById('shopify-section-loox_reviews');
    if (safe(literal)) return literal;
    var byId = document.querySelector('[id^="shopify-section-"][id*="loox" i]');
    if (safe(byId)) return byId;
    var sects = document.querySelectorAll('[id^="shopify-section-"]');
    var EXCLUDE = {
      'shopify-section-main': 1,
      'shopify-section-header': 1,
      'shopify-section-footer': 1,
      'shopify-section-announcement-bar': 1
    };
    /* Pass A: any safe section containing a Loox descendant. */
    for (var i = 0; i < sects.length; i++) {
      var a = sects[i];
      if (EXCLUDE[a.id] || !safe(a)) continue;
      if (a.querySelector('[id*="loox" i], [class*="loox" i], [data-loox]')) return a;
    }
    /* Pass B: any safe non-chrome shopify-section that isn't the
       FFQ section. Catches the case where Loox's JS hasn't yet
       injected its markup but the Shopify-rendered apps section
       wrapper exists. */
    for (var j = 0; j < sects.length; j++) {
      var b = sects[j];
      if (EXCLUDE[b.id] || !safe(b)) continue;
      if (/announcement|hoh-announcement/i.test(b.id || '')) continue;
      return b;
    }
    return null;
  }
  function revealLooxSection(section) {
    /* Force the moved section visible regardless of any inline or
       computed styles that may have hidden it in its previous spot
       (e.g. our older :has based CSS, or Shopify chrome rules). */
    section.style.display = 'block';
    section.style.visibility = 'visible';
    section.style.height = 'auto';
    section.style.overflow = 'visible';
    section.style.pointerEvents = 'auto';
    section.style.opacity = '1';
    section.removeAttribute('aria-hidden');
  }
  function mountLoox() {
    var mount = document.getElementById('ffq-loox-mount');
    if (!mount || mount.dataset.ffqLooxMounted === '1') return;
    var section = findLooxSection(mount);
    if (section) {
      mount.appendChild(section);
      revealLooxSection(section);
      mount.dataset.ffqLooxMounted = '1';
      return;
    }
    /* Retry once for slow Loox injection. */
    setTimeout(function () {
      var m2 = document.getElementById('ffq-loox-mount');
      if (!m2 || m2.dataset.ffqLooxMounted === '1') return;
      var s2 = findLooxSection(m2);
      if (s2) {
        m2.appendChild(s2);
        revealLooxSection(s2);
        m2.dataset.ffqLooxMounted = '1';
      }
    }, 600);
  }
  function mountDecks(scope) {
    var decks = (scope || document).querySelectorAll('[data-ffq-deck]');
    for (var i = 0; i < decks.length; i++) {
      var d = decks[i];
      if (d.dataset.ffqDeckReady === '1') continue;
      d.dataset.ffqDeckReady = '1';
      initDeck(d);
    }
  }
  function initDeck(area) {
    var cards = area.querySelectorAll('[data-ffq-deck-card]');
    var n = cards.length;
    if (!n) return;
    var idx = parseInt(area.getAttribute('data-ffq-deck-init'), 10);
    if (isNaN(idx) || idx < 0 || idx >= n) idx = Math.floor(n / 2);
    var touchStartX = 0, touchEndX = 0;
    /* Per-breakpoint translate distances. Match the CSS card width so
       the flanking and outer cards sit just past the edge of center.
       v3.6: cards grew wider (152/168/196 from 130/144/174) when the
       painting image and pull quote were added, so the distances grew
       proportionally to keep the fan visually balanced. */
    function dist() {
      var w = window.innerWidth || 360;
      if (w >= 750) return { inner: 134, outer: 235 };
      if (w >= 420) return { inner: 112, outer: 196 };
      return { inner: 86, outer: 146 };
    }
    function apply() {
      var d = dist();
      for (var i = 0; i < n; i++) {
        var card = cards[i];
        var raw = i - idx;
        var off = raw;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        var absOff = Math.abs(off);
        if (absOff > 2) {
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
          card.style.transform = 'translate(-50%, -50%) scale(0.4)';
          card.style.zIndex = '0';
          continue;
        }
        var x, scale, rot, z, op, clickable;
        if (absOff === 0) {
          x = 0; scale = 1; rot = 0; z = 10; op = 1; clickable = false;
        } else if (absOff === 1) {
          x = off > 0 ? d.inner : -d.inner;
          scale = 0.72; rot = off > 0 ? 8 : -8; z = 8; op = 0.85; clickable = true;
        } else {
          x = off > 0 ? d.outer : -d.outer;
          scale = 0.52; rot = off > 0 ? 16 : -16; z = 6; op = 0.55; clickable = true;
        }
        card.style.transform = 'translate(-50%, -50%) translateX(' + x + 'px) scale(' + scale + ') rotate(' + rot + 'deg)';
        card.style.zIndex = String(z);
        card.style.opacity = String(op);
        card.style.pointerEvents = clickable ? 'auto' : 'none';
        card.style.cursor = clickable ? 'pointer' : 'default';
      }
    }
    function setIdx(t) { if (t < 0 || t >= n || t === idx) return; idx = t; apply(); }
    function next() { idx = (idx + 1) % n; apply(); }
    function prev() { idx = (idx - 1 + n) % n; apply(); }
    /* Click on a side card brings it to center. */
    for (var ci = 0; ci < n; ci++) {
      (function (target) {
        cards[target].addEventListener('click', function () { setIdx(target); });
      })(ci);
    }
    var prevBtn = area.querySelector('[data-ffq-deck-arrow="prev"]');
    var nextBtn = area.querySelector('[data-ffq-deck-arrow="next"]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });
    /* Touch swipe, same 40 px threshold as the quest. */
    area.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) {
        touchStartX = e.touches[0].clientX;
        touchEndX = e.touches[0].clientX;
      }
    }, { passive: true });
    area.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) touchEndX = e.touches[0].clientX;
    }, { passive: true });
    area.addEventListener('touchend', function () {
      var dx = touchEndX - touchStartX;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
      touchStartX = 0; touchEndX = 0;
    }, { passive: true });
    /* Recompute distances on resize so the spread tracks the breakpoint. */
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(apply, 120);
    }, { passive: true });
    apply();
  }

  /* ---------- Marquee runtime (auto drift + drag + momentum) ----------
     Same model as the homepage ss-scrolling-images section: a transform
     based marquee with three rows, an auto leftward drift, mouse drag on
     desktop and touch swipe on mobile, and exponential momentum decay on
     release. I intentionally do not import from the homepage section,
     this is a self contained copy so the quiz can evolve independently
     and there is no risk of touching the homepage at all. Each viewport
     is mounted at most once via a dataset flag, and the RAF loop self
     terminates when the track is removed from the DOM. */
  function mountMarquees(scope) {
    var tracks = (scope || document).querySelectorAll('[data-ffq-marquee]');
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (track.dataset.ffqMarqueeReady === '1') continue;
      track.dataset.ffqMarqueeReady = '1';
      initMarquee(track);
    }
  }
  function initMarquee(track) {
    var state = {
      position: 0,
      velocity: 0,
      singleSetWidth: 0,
      autoSpeed: 40,                  /* px/sec, matches homepage default */
      isDragging: false,
      dragMoved: false,
      startPointerX: 0,
      startPosition: 0,
      lastPointerX: 0,
      lastPointerTime: 0,
      activePointer: null,
      touchStartY: 0,
      touchHorizontal: false,
      isVisible: true,
      lastFrame: 0
    };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.autoSpeed = 0;
    }
    function measure() {
      var w = track.scrollWidth;
      if (w > 0) state.singleSetWidth = w / 3;
    }
    function applyTransform() {
      track.style.transform = 'translate3d(' + (-state.position).toFixed(2) + 'px, 0, 0)';
    }
    function ready() {
      measure();
      /* Start at the middle copy so dragging backward has runway. */
      state.position = state.singleSetWidth;
      applyTransform();
      bind();
      loop();
    }
    function dragStart(clientX, pointerId) {
      state.isDragging = true;
      state.dragMoved = false;
      state.velocity = 0;
      state.startPointerX = clientX;
      state.startPosition = state.position;
      state.lastPointerX = clientX;
      state.lastPointerTime = performance.now();
      state.activePointer = pointerId;
      if (pointerId != null && track.setPointerCapture) {
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
    }
    function dragUpdate(clientX) {
      if (!state.isDragging) return;
      var dx = clientX - state.startPointerX;
      if (!state.dragMoved && Math.abs(dx) >= 5) {
        state.dragMoved = true;
        track.classList.add('is-dragging');
      }
      if (!state.dragMoved) return;
      state.position = state.startPosition - dx;
      applyTransform();
      var now = performance.now();
      var dt = now - state.lastPointerTime;
      if (dt > 0) state.velocity = -((clientX - state.lastPointerX) / dt) * 1000;
      state.lastPointerX = clientX;
      state.lastPointerTime = now;
    }
    function dragEnd() {
      if (!state.isDragging) return;
      state.isDragging = false;
      track.classList.remove('is-dragging');
      if (state.activePointer != null && track.releasePointerCapture) {
        try { track.releasePointerCapture(state.activePointer); } catch (_) {}
      }
      state.activePointer = null;
    }
    function bind() {
      /* Desktop pointer (mouse only). Touch and pen go through the touch
         listeners below so I can do the vertical scroll heuristic. */
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          if (e.button !== 0) return;
          dragStart(e.clientX, e.pointerId);
        });
        track.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          dragUpdate(e.clientX);
        });
        var endPtr = function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          dragEnd();
        };
        track.addEventListener('pointerup', endPtr);
        track.addEventListener('pointercancel', endPtr);
      }
      /* Touch: stay passive and let the page scroll vertically until I
         confirm horizontal intent. Once horizontal wins, drag takes
         over, but I never call preventDefault so the page never
         scroll jacks. */
      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        state.touchStartY = t.clientY;
        state.touchHorizontal = false;
        dragStart(t.clientX, null);
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (!state.isDragging) return;
        var t = e.touches[0];
        if (!state.touchHorizontal) {
          var dxAbs = Math.abs(t.clientX - state.startPointerX);
          var dyAbs = Math.abs(t.clientY - state.touchStartY);
          if (dxAbs < 8 && dyAbs < 8) return;
          if (dyAbs > dxAbs) {
            state.isDragging = false;
            state.dragMoved = false;
            track.classList.remove('is-dragging');
            return;
          }
          state.touchHorizontal = true;
        }
        dragUpdate(t.clientX);
      }, { passive: true });
      var touchEnd = function () { if (state.isDragging) dragEnd(); };
      track.addEventListener('touchend', touchEnd, { passive: true });
      track.addEventListener('touchcancel', touchEnd, { passive: true });
      /* Eat the post drag click so a fling does not also open an image. */
      track.addEventListener('click', function (e) {
        if (state.dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          state.dragMoved = false;
        }
      }, true);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          state.isVisible = entries[0].isIntersecting;
        }, { threshold: 0, rootMargin: '200px' });
        io.observe(track);
      }
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var oldW = state.singleSetWidth;
          measure();
          if (oldW > 0 && state.singleSetWidth > 0) {
            state.position = (state.position / oldW) * state.singleSetWidth;
          }
        }, 200);
      }, { passive: true });
    }
    function loop() {
      state.lastFrame = performance.now();
      function tick(now) {
        /* If the screen got repainted, the track is gone from the DOM
           and innerHTML cleared my listeners. Stop the loop so I do
           not leak RAFs across navigations. */
        if (!track.isConnected) return;
        var dt = (now - state.lastFrame) / 1000;
        state.lastFrame = now;
        if (dt > 0.1) dt = 0.016;
        if (state.isVisible && !state.isDragging) {
          /* If the track was measured while hidden (e.g. the two-phase reveal mounts
             the reviews carousel inside a display:none column), singleSetWidth is 0
             and the wrap below never runs, so it would scroll off into a black gap.
             Re-measure once it has width and snap to the middle copy before moving. */
          if (state.singleSetWidth <= 0) {
            measure();
            if (state.singleSetWidth > 0) { state.position = state.singleSetWidth; }
          }
          if (state.singleSetWidth <= 0) { requestAnimationFrame(tick); return; }
          state.position += state.autoSpeed * dt;
          if (Math.abs(state.velocity) > 1) {
            state.position += state.velocity * dt;
            state.velocity *= Math.pow(0.94, dt * 60);
          } else {
            state.velocity = 0;
          }
          if (state.singleSetWidth > 0) {
            while (state.position > 2 * state.singleSetWidth) {
              state.position -= state.singleSetWidth;
              state.startPosition -= state.singleSetWidth;
            }
            while (state.position < 0) {
              state.position += state.singleSetWidth;
              state.startPosition += state.singleSetWidth;
            }
          }
          applyTransform();
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    /* Wait for images to load so scrollWidth is accurate. If document
       is already complete I still wait a microtask to let layout flush. */
    if (document.readyState === 'complete') {
      setTimeout(ready, 0);
    } else {
      window.addEventListener('load', ready, { once: true });
    }
  }

  /* ============================================================
     APP SHELL
     ============================================================ */
  function buildShell() {
    root.innerHTML = '';
    var app = h(
      '<div class="ffq-app">' +
        '<div class="ffq-topbar">' +
          '<div class="ffq-progress" id="ffq-progress" aria-hidden="true"></div>' +
          '<button type="button" class="ffq-mute" id="ffq-mute" aria-label="Toggle music" aria-pressed="false">' +
            '<svg class="ffq-mute__on" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8a5 5 0 010 8M18.5 5.5a8 8 0 010 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>' +
            '<svg class="ffq-mute__off" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8l6 8M22 8l-6 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ffq-stage"><div class="ffq-screen" id="ffq-screen"></div></div>' +
      '</div>'
    );
    root.appendChild(app);
    bindMuteToggle();
  }
  function bindMuteToggle() {
    var btn = document.getElementById('ffq-mute');
    if (!btn) return;
    function reflect() {
      var m = audioMgr.muted;
      btn.classList.toggle('is-muted', m);
      btn.setAttribute('aria-pressed', m ? 'true' : 'false');
      btn.setAttribute('aria-label', m ? 'Unmute music' : 'Mute music');
    }
    audioMgr.muted = audioMgr.isMuted();
    reflect();
    btn.addEventListener('click', function () {
      audioMgr.setMuted(!audioMgr.muted);
      reflect();
    });
  }
  function renderProgress() {
    var p = document.getElementById('ffq-progress');
    if (!p) return;
    if (state.view === 'quiz') {
      p.textContent = 'Question ' + (state.step + 1) + ' of ' + QUESTIONS.length;
    } else {
      /* Breath, intro, beat, and result all read as no progress label. */
      p.textContent = '';
    }
  }
  function screenEl() { return document.getElementById('ffq-screen'); }

  function paint(html, instant, afterBuild) {
    var screen = screenEl();
    function build() {
      screen.innerHTML = html;
      delete screen.dataset.locked;
      renderProgress();
      try { window.scrollTo(0, 0); } catch (e) {}
      try { if (root) root.scrollTop = 0; } catch (e) {}
      void screen.offsetWidth;
      screen.classList.remove('is-hidden');
      /* Activate any gallery marquees that the new HTML just inserted.
         Self-skips tracks already mounted on a prior paint. */
      mountMarquees(screen);
      /* Same idempotent mount for the archetype deck carousel. */
      mountDecks(screen);
      if (afterBuild) afterBuild();
    }
    if (instant) { build(); return; }
    screen.classList.add('is-hidden');
    setTimeout(build, T_FADE);
  }

  /* ============================================================
     INTRO SCREEN
     ============================================================ */
  /* v3 landing: matches the Character Quest landing format.
     Hero image at top → eyebrow label → headline → subhead → primary
     CTA → CTA note → "What do I get?" expander → deck carousel →
     deck hint → photo strip → final proof → bottom CTA → bullets.
     No recipient picker here. The recipient picker is now Q1 inside
     the quiz flow. */
  function introHeroImageHTML() {
    var url = (CONFIG && CONFIG.introHero) || '';
    if (!url) return '';
    return '<div class="ffq-intro__hero"><img src="' + esc(url) +
      '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  function ctaButtonHTML(id, label, variant) {
    /* variant: 'primary' (default) = full gold gradient with shimmer
       and pulse animation. 'quiet' = same gold body, no shimmer span,
       no pulse animation — used for the secondary CTA below the
       photo strip so it does not visually compete with the primary
       above the fold. */
    var quiet = variant === 'quiet';
    var cls = 'ffq-continue ffq-continue--hero' + (quiet ? ' ffq-continue--hero-quiet' : '');
    return '<button type="button" class="' + cls + '" id="' + esc(id) + '">' +
      (quiet ? '' : '<span class="ffq-continue__shimmer" aria-hidden="true"></span>') +
      '<span class="ffq-continue__label">' + esc(label) + ' <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
    '</button>';
  }
  function introHTML() {
    return '<div class="ffq-intro">' +
      introHeroImageHTML() +
      '<p class="ffq-intro__eyebrow">' + esc(EYEBROW_LABEL) + '</p>' +
      '<h1 class="ffq-intro__headline">' + headlineHTML(HEADLINES[state.headlineVariant] || HEADLINES.A) + '</h1>' +
      '<p class="ffq-intro__sub">' + SUBHEAD + '</p>' +
      '<p class="ffq-intro__sub">It is not a card he reads and sets aside. He opens it, and his character starts to come to life.</p>' +
      /* Photo strip — sliding band of customer portraits. Sits right
         under the subhead so the social proof lands before the CTA
         instead of buried at the bottom of the page. */
      galleryBand() +
      ctaButtonHTML('ffq-intro-cta', 'Make his card', 'primary') +
      '<p class="ffq-intro__ctanote">' + esc(CTA_NOTE) + '</p>' +
      /* Deck carousel ("one of these eight is him"). */
      deckHTML() +
      '<p class="ffq-intro__deckhint">Swipe or use arrows to browse</p>' +
      '<p class="ffq-intro__finalproof">' + FINAL_PROOF + '</p>' +
      ctaButtonHTML('ffq-intro-cta2', 'Make his card', 'quiet') +
      '<p class="ffq-intro__bullets">His character, captured in a portrait he keeps forever.</p>' +
      '</div>';
  }
  function bindIntro() {
    var screen = screenEl();
    var ctaA = screen.querySelector('#ffq-intro-cta');
    var ctaB = screen.querySelector('#ffq-intro-cta2');

    /* Single shared start handler. Either CTA invokes it. There is no
       recipient pre-pick here in v3 — Q1 inside the quiz captures
       recipient. */
    function startQuiz() {
      if (screen.dataset.locked) return;
      screen.dataset.locked = '1';
      state.view = 'quiz';
      state.step = 0;
      save();
      preloadQuestionImages();
      /* First confirmed user interaction. Unlock and start BGM so the
         browser autoplay policy lets the audio actually play. */
      audioMgr.unlock();
      audioMgr.playBGM();
      /* v3: QuizStarted fires on homepage CTA click, BEFORE any
         answer. recipient field is empty at this point — Q1 will
         populate it next. */
      trackOnce('started', function () {
        fbTrack('QuizStarted', { content_name: 'Fathers Day Quiz 2026', headline_variant: state.headlineVariant });
        gaTrack('quiz_start', { headline_variant: state.headlineVariant });
      });
      paintQuestion();
    }
    if (ctaA) ctaA.addEventListener('click', startQuiz);
    if (ctaB) ctaB.addEventListener('click', startQuiz);
  }
  function goToIntro(instant) {
    state.view = 'intro';
    save();
    paint(introHTML(), !!instant, bindIntro);
  }

  /* ============================================================
     QUESTION SCREENS
     ============================================================ */
  /* The hero image at the top of a question comes only from the theme
     editor. v3 changed image lookup from positional (idx) to semantic
     (question.key) so reordering QUESTIONS does not silently swap
     images. Special cases that survived the refactor:
       - hobby honors the "My whole family" family-variant image.
       - character_knowledge's image varies by the hobby answer (five
         visual paths, one per hobby option). */
  function questionHeroURL(idx) {
    var q = QUESTIONS[idx];
    if (!q) return '';
    var k = q.key;
    if (k === 'his_world') {
      if (state.recipient === 'whole_family') {
        return Q_IMAGES.q1Family || Q_IMAGES.q1 || '';
      }
      return Q_IMAGES.q1 || '';
    }
    var slot = IMG_SLOT[k];
    return (slot && Q_IMAGES[slot]) || '';
  }
  /* Returns the array of video sources [{url, type}, ...] for the
     question, or an empty array if no video is set for that slot.
     Family path priority on Q1: if the visitor picked My whole
     family AND a family image is set, the family image wins. We do
     NOT fall back to the standard q1 video in that case, because the
     non-family video would overwrite the family image the merchant
     explicitly uploaded for this path. The standard q1 video is only
     used on Q1 family when neither a family video nor a family image
     is set, so the question still has a hero. */
  function questionHeroVideoSources(idx) {
    var q = QUESTIONS[idx];
    if (!q) return [];
    var k = q.key;
    if (k === 'his_world') {
      if (state.recipient === 'whole_family') {
        if (Q_VIDEOS.q1Family && Q_VIDEOS.q1Family.length) return Q_VIDEOS.q1Family;
        if (Q_IMAGES.q1Family) return [];  /* family image overrides standard video */
        return Q_VIDEOS.q1 || [];
      }
      return Q_VIDEOS.q1 || [];
    }
    var slot = IMG_SLOT[k];
    return (slot && Q_VIDEOS[slot]) || [];
  }
  function inEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }
  /* Editor only. When a question has no image set, show a note in the
     Shopify theme editor naming the slot to fill, plus a one line
     status of the config the quiz actually received. Customers never
     see this, it is gated on Shopify designMode. */
  function editorHeroNote(idx) {
    var q = QUESTIONS[idx];
    var keyToLabel = {
      recipient: 'Recipient picker image',
      hobby: 'Hobby image (Question 1 editor slot, plus optional family variant)',
      timing: 'Timing image (Question 3 editor slot)',
      hobby_vibe: 'Hobby vibe image (Question 4 editor slot)',
      /* v16: personality removed, q5 slot orphaned but harmless. */
      moral_signature: 'Moral signature image (Question 6 editor slot)',
      trait_curation: 'Trait curation image (q_traits editor slot)',
      signature_behavior: 'Signature behavior image (q_signature editor slot)',
      inside_detail: 'Inside detail image (q_inside editor slot)'
    };
    var label = (q && keyToLabel[q.key]) || 'Question image';
    var qi = CONFIG.questionImages || {};
    var diag = 'config ' + (CONFIG_OK ? 'loaded' : 'FAILED TO PARSE') +
      '   recipient ' + (qi.recipient ? 'set' : 'empty') +
      '   q1 ' + (qi.q1 ? 'set' : 'empty') +
      '   q3 ' + (qi.q3 ? 'set' : 'empty') +
      '   q4 ' + (qi.q4 ? 'set' : 'empty') +
      /* v16: q5 (personality) removed from diagnostic. */
      '   q6 ' + (qi.q6 ? 'set' : 'empty');
    var box = 'border:1px dashed rgba(201,168,76,.55);border-radius:12px;padding:20px 18px;text-align:center;';
    return '<div class="ffq-qhero" style="' + box + '">' +
      '<div style="font-family:Cinzel,serif;color:#c9a84c;font-size:15px;letter-spacing:.04em;">' +
        esc(label) + '</div>' +
      '<div style="color:#9a93a6;font-size:13px;margin-top:6px;">' +
        'Set this image in the theme editor under Question images. Only the editor shows this note.</div>' +
      '<div style="color:#6f6a7d;font-size:11px;margin-top:10px;font-family:monospace;">' +
        esc(diag) + '</div>' +
    '</div>';
  }
  function questionHTML(idx) {
    var q = QUESTIONS[idx];
    var html = '<button type="button" class="ffq-back" id="ffq-back">' +
      '<span class="ffq-back__arrow">&larr;</span> Back</button>';
    var hero = questionHeroURL(idx);
    var vidSources = questionHeroVideoSources(idx);
    if (vidSources.length) {
      /* Video wins. autoplay + muted + playsinline is the only combo
         that actually auto-starts on iOS and modern Chrome. preload
         "auto" is fine because I steer merchants to sub 2 MB clips, so
         the file lands quickly and starts on its own once metadata is
         ready. The image, if also set, becomes the poster so the still
         shows instantly during the first buffer fill. Multiple sources
         are emitted in order so the browser picks the first it can
         play. */
      html += '<div class="ffq-qhero">';
      html += '<video class="ffq-qhero__video" autoplay muted loop playsinline preload="auto" disableremoteplayback';
      if (hero) html += ' poster="' + esc(hero) + '"';
      html += '>';
      for (var vi = 0; vi < vidSources.length; vi++) {
        var s = vidSources[vi];
        if (s && s.url) {
          html += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      html += '</video></div>';
    } else if (hero) {
      html += '<div class="ffq-qhero"><img src="' + esc(hero) + '" alt="" aria-hidden="true" decoding="async"></div>';
    } else if (inEditor()) {
      html += editorHeroNote(idx);
    } else {
      /* v37.2 every question shows a real image. With no uploaded image we drop
         in a portfolio placeholder (Jan asked for placeholder images even if not
         the exact one for that question) so the slot is never an empty frame. */
      html += questionPlaceholderImgHTML(idx);
    }
    html += '<h1 class="ffq-question">' + esc(q.stem) + '</h1>';
    html += '<p class="ffq-micro">' + esc(q.micro) + '</p>';

    /* v34 names branch (his_name). Two fields, his and hers, so she sees
       she is filling in both names for a card from her to him. Both go onto
       the card and both are optional, so Continue is always enabled. */
    if (q.type === 'names') {
      html += '<div class="ffq-textq ffq-textq--names">' +
        '<input class="ffq-input ffq-textq__input" id="ffq-textq-his" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.hisName || '') + '">' +
        '<input class="ffq-input ffq-textq__input" id="ffq-textq-from" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.fromPlaceholder || 'Your name') + '" value="' + esc(state.fromName || '') + '">' +
      '</div>';
      html += '<button type="button" class="ffq-continue ffq-continue--hero" id="ffq-textq-continue">' +
        '<span class="ffq-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffq-continue__label">Continue <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v31 text branch (his_name). A single text field plus a Continue
       button, since typing does not auto-advance. The value goes onto the
       card and is optional, so Continue is always enabled. */
    if (q.type === 'text') {
      html += '<div class="ffq-textq">' +
        '<input class="ffq-input ffq-textq__input" id="ffq-textq" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.hisName || '') + '">' +
      '</div>';
      html += '<button type="button" class="ffq-continue ffq-continue--hero" id="ffq-textq-continue">' +
        '<span class="ffq-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffq-continue__label">Continue <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v33 capture branch (send_to). Email required, phone optional, then a
       button that subscribes her and goes to the reveal. */
    if (q.type === 'capture') {
      html += '<div class="ffq-capture">' +
        '<div class="ffq-field">' +
          '<input class="ffq-input ffq-capture__email" id="ffq-capture-email" type="email" autocomplete="email" inputmode="email" placeholder="Your email" value="' + esc(state.email || '') + '">' +
          '<p class="ffq-capture__err" id="ffq-capture-err" hidden></p>' +
        '</div>' +
        '<div class="ffq-field">' +
          '<input class="ffq-input ffq-capture__phone" id="ffq-capture-phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="Your phone, if you want a text too" value="' + esc(state.phone || '') + '">' +
        '</div>' +
      '</div>';
      html += '<button type="button" class="ffq-continue ffq-continue--hero" id="ffq-capture-go">' +
        '<span class="ffq-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffq-continue__label">Show me his card <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* Multi-select branch (v5 trait_curation). Renders the same option
       button grid as single-select, but:
       - Tracks an array of selected indices in state.answers[idx]
       - Up to q.maxPicks (3) options can be active at once
       - A counter pill shows current/max picks
       - A Continue button enables ONLY when exactly maxPicks are
         selected (per brief "no more, no less"). The brief reorder
         placed the Reframe breath right after this question, so
         advance() does the breath dispatch on Continue. */
    if (q.type === 'multi') {
      var max = q.maxPicks || 3;
      var sel = Array.isArray(state.answers[idx]) ? state.answers[idx] : [];
      html += '<div class="ffq-options ffq-options--multi">';
      for (var mi = 0; mi < q.options.length; mi++) {
        var mon = sel.indexOf(mi) !== -1;
        html += '<button type="button" class="ffq-option ffq-option--multi' + (mon ? ' is-chosen' : '') +
          '" data-mopt="' + mi + '" aria-pressed="' + (mon ? 'true' : 'false') + '">' +
          '<span class="ffq-option__check" aria-hidden="true"></span>' +
          '<span class="ffq-option__text">' + esc(q.options[mi].label) + '</span></button>';
      }
      html += '</div>';
      html += '<p class="ffq-multi__counter" id="ffq-multi-counter" aria-live="polite">' +
        esc(sel.length) + ' of ' + esc(max) + ' picked</p>';
      html += '<button type="button" class="ffq-continue ffq-continue--hero" id="ffq-multi-continue"' +
        (sel.length === max ? '' : ' disabled') + '>' +
        '<span class="ffq-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffq-continue__label">' + esc(q.continueLabel || 'Continue') +
        ' <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    html += '<div class="ffq-options">';
    for (var i = 0; i < q.options.length; i++) {
      var on = state.answers[idx] === i;
      /* Timing question's Father's Day option carries a small gray
         italic micro line showing the order cutoff. Keyed by the
         semantic question key so the reorder does not move the badge
         onto the wrong option. */
      var extra = '';
      if (q.key === 'timing' && i === 0) {
        extra = '<span class="ffq-option__cutoff">Spots close ' + esc(cutoffLabel()) + '.</span>';
      }
      /* v23: an option can carry a tag (e.g. POPULAR) that renders as
         a small gold ribbon in the corner of the option button. Used
         on the gift_path question to steer toward the Quest Invitation
         path, which is the better-converting D&D-character route. */
      var tag = q.options[i].tag
        ? '<span class="ffq-option__tag">' + esc(q.options[i].tag) + '</span>'
        : '';
      var tagCls = q.options[i].tag ? ' ffq-option--tagged' : '';
      html += '<button type="button" class="ffq-option' + (on ? ' is-chosen' : '') + tagCls +
        '" data-opt="' + i + '">' + tag + '<span class="ffq-option__text">' + esc(q.options[i].label) + extra + '</span></button>';
    }
    html += '</div>';
    /* v37.6 (Change 5) on his_character, the "same one for years" answer is the
       only one that means a single character she might be able to name. Picking
       it reveals this optional name field + Continue in place (wired in
       bindQuestion) instead of auto-advancing. It renders hidden unless that
       option is the current answer, so a resume keeps it open. It is optional,
       so it never blocks. The other three options auto-advance unchanged. */
    if (q.key === 'his_character') {
      var sameIdx = storeIndex(q, 'same');
      var showName = state.answers[idx] === sameIdx;
      html += '<div class="ffq-charname" id="ffq-charname-panel"' + (showName ? '' : ' hidden') + '>' +
        '<input class="ffq-input ffq-charname__input" id="ffq-charname" type="text" maxlength="40" autocomplete="off" placeholder="His character\'s name" value="' + esc(state.characterName || '') + '">' +
        '<p class="ffq-charname__help">Only if you know it.</p>' +
        '<button type="button" class="ffq-continue ffq-continue--hero" id="ffq-charname-continue">' +
          '<span class="ffq-continue__shimmer" aria-hidden="true"></span>' +
          '<span class="ffq-continue__label">Continue <span class="ffq-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
        '</button>' +
      '</div>';
    }
    return html;
  }
  function bindQuestion(idx) {
    var screen = screenEl();
    var back = screen.querySelector('#ffq-back');
    if (back) back.addEventListener('click', function () { goBack(); });
    var q = QUESTIONS[idx];

    /* v31 text branch (his_name). The name updates state.hisName live and
       Continue (or Enter) records the answer and advances. The name is
       optional, so it never blocks. */
    /* v34 names branch. His name fills the greeting, her name signs the
       card. Enter on his field jumps to hers, Enter on hers (or Continue)
       commits. Both optional, so it never blocks. */
    if (q && q.type === 'names') {
      var hisEl = screen.querySelector('#ffq-textq-his');
      var fromNameEl = screen.querySelector('#ffq-textq-from');
      var contN = screen.querySelector('#ffq-textq-continue');
      function commitNames() {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        state.hisName = hisEl ? hisEl.value.replace(/^\s+|\s+$/g, '') : '';
        state.fromName = fromNameEl ? fromNameEl.value.replace(/^\s+|\s+$/g, '') : '';
        /* Store a non-null marker so answersComplete() passes even when
           both names are left blank. */
        state.answers[idx] = state.hisName;
        save();
        advance();
      }
      if (hisEl) {
        hisEl.addEventListener('input', function () { state.hisName = hisEl.value; });
        hisEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            if (fromNameEl) { try { fromNameEl.focus(); } catch (er) {} } else commitNames();
          }
        });
      }
      if (fromNameEl) {
        fromNameEl.addEventListener('input', function () { state.fromName = fromNameEl.value; });
        fromNameEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitNames(); }
        });
      }
      if (contN) contN.addEventListener('click', commitNames);
      return;
    }

    if (q && q.type === 'text') {
      var input = screen.querySelector('#ffq-textq');
      var cont = screen.querySelector('#ffq-textq-continue');
      if (input && state.hisName) input.value = state.hisName;
      function commitText() {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        state.hisName = input ? input.value.replace(/^\s+|\s+$/g, '') : '';
        state.answers[idx] = state.hisName;
        save();
        advance();
      }
      if (input) {
        input.addEventListener('input', function () { state.hisName = input.value; });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitText(); }
        });
      }
      if (cont) cont.addEventListener('click', commitText);
      return;
    }

    /* v33 capture branch (send_to). Email required, phone optional. On
       submit it subscribes her to Klaviyo (non-blocking, with a retry)
       and advances to the reveal. */
    if (q && q.type === 'capture') {
      var emailEl = screen.querySelector('#ffq-capture-email');
      var phoneEl = screen.querySelector('#ffq-capture-phone');
      var errEl = screen.querySelector('#ffq-capture-err');
      var goEl = screen.querySelector('#ffq-capture-go');
      if (emailEl) {
        emailEl.addEventListener('input', function () { errEl && errEl.setAttribute('hidden', ''); });
        emailEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); submitCapture(); } });
      }
      function submitCapture() {
        if (screen.dataset.locked) return;
        var email = emailEl ? emailEl.value.replace(/^\s+|\s+$/g, '') : '';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          if (errEl) { errEl.textContent = 'That email does not look right. Try again.'; errEl.removeAttribute('hidden'); }
          if (emailEl) emailEl.classList.add('is-error');
          return;
        }
        screen.dataset.locked = '1';
        state.email = email;
        state.phone = phoneEl ? phoneEl.value : '';
        state.answers[idx] = email;
        save();
        submitQuizCapture();
        advance();
      }
      if (goEl) goEl.addEventListener('click', submitCapture);
      return;
    }

    /* Multi-select branch. Toggles selection in state.answers[idx],
       updates the counter, enables Continue at exactly maxPicks. */
    if (q && q.type === 'multi') {
      var max = q.maxPicks || 3;
      if (!Array.isArray(state.answers[idx])) state.answers[idx] = [];
      var mbtns = screen.querySelectorAll('[data-mopt]');
      var counter = screen.querySelector('#ffq-multi-counter');
      var contBtn = screen.querySelector('#ffq-multi-continue');
      function refresh() {
        var sel = state.answers[idx];
        Array.prototype.forEach.call(mbtns, function (b) {
          var mi = parseInt(b.getAttribute('data-mopt'), 10);
          var on = sel.indexOf(mi) !== -1;
          b.classList.toggle('is-chosen', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          /* Disable visually if at max and not currently selected. */
          if (!on && sel.length >= max) {
            b.classList.add('is-disabled');
          } else {
            b.classList.remove('is-disabled');
          }
        });
        if (counter) counter.textContent = sel.length + ' of ' + max + ' picked';
        if (contBtn) contBtn.disabled = sel.length !== max;
      }
      Array.prototype.forEach.call(mbtns, function (btn) {
        btn.addEventListener('click', function () {
          if (screen.dataset.locked) return;
          var mi = parseInt(btn.getAttribute('data-mopt'), 10);
          var sel = state.answers[idx];
          var pos = sel.indexOf(mi);
          if (pos !== -1) {
            sel.splice(pos, 1);
          } else if (sel.length < max) {
            sel.push(mi);
          }
          /* If at max + tried to add a new one, silently ignore.
             The visual "is-disabled" hint already communicates this. */
          save();
          refresh();
        });
      });
      if (contBtn) {
        contBtn.addEventListener('click', function () {
          if (screen.dataset.locked) return;
          if (state.answers[idx].length !== max) return;
          screen.dataset.locked = '1';
          save();
          advance();
        });
      }
      refresh();
      return;
    }

    var btns = screen.querySelectorAll('[data-opt]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        state.answers[idx] = oi;
        /* The recipient picker is the first question in v3 (moved off
           the homepage). When it is answered we mirror the option onto
           state.recipient + state.branch so everything downstream that
           still reads those fields (revealData, family branch
           routing, Klaviyo property writes, first text template,
           image lookup for the hobby question's family variant) keeps
           working unchanged. */
        if (QUESTIONS[idx].key === 'recipient') {
          var recipientValues = ['husband', 'boyfriend', 'dad', 'whole_family'];
          state.recipient = recipientValues[oi] || '';
          state.branch = state.recipient === 'whole_family' ? 'Family' : 'Standard';
          trackOnce('recipient_selected', function () {
            fbTrack('RecipientSelected', { recipient: recipientObj().map });
            gaTrack('recipient_selected', { recipient: state.recipient });
          });
        }
        /* v33 Q1 stance sets the voice of the breath and the read. */
        if (QUESTIONS[idx].key === 'stance') {
          var stanceValues = ['insider', 'semi', 'outsider'];
          state.stance = stanceValues[oi] || '';
          trackOnce('stance_selected', function () {
            fbTrack('QuizStance', { stance: state.stance });
            gaTrack('quiz_stance', { stance: state.stance });
          });
        }
        /* Clear any prior highlight first, so only the option she just
           picked looks selected. Otherwise a previous pick and the new
           one both stay lit. */
        Array.prototype.forEach.call(btns, function (b) {
          b.classList.remove('is-selected');
          b.classList.remove('is-chosen');
        });
        btn.classList.add('is-chosen');
        /* v37.6 (Change 5) his_character: picking "the same one for years"
           reveals the optional character-name field in place instead of
           auto-advancing, so she can name him if she knows it. The screen is
           unlocked again so Continue, a re-pick, or another option still work.
           Any other answer hides the field and drops a previously typed name,
           then advances normally. */
        if (QUESTIONS[idx].key === 'his_character') {
          var sameIdx2 = storeIndex(QUESTIONS[idx], 'same');
          var charPanel = screen.querySelector('#ffq-charname-panel');
          if (oi === sameIdx2) {
            if (charPanel) charPanel.hidden = false;
            screen.dataset.locked = '';
            save();
            var nameEl = screen.querySelector('#ffq-charname');
            if (nameEl) { try { nameEl.focus(); } catch (e) {} }
            return;
          }
          if (charPanel) charPanel.hidden = true;
          state.characterName = '';
        }
        save();
        setTimeout(function () { advance(); }, T_CONFIRM);
      });
    });
    /* v37.6 (Change 5) bindings for the optional character-name field the
       "same one for years" option reveals. Typing updates state live, Continue
       or Enter records it and advances (the breath after his_character fires as
       usual). It is optional, so an empty field still advances. */
    if (q && q.key === 'his_character') {
      var charInput = screen.querySelector('#ffq-charname');
      var charCont = screen.querySelector('#ffq-charname-continue');
      var commitCharName = function () {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        state.characterName = charInput ? charInput.value.replace(/^\s+|\s+$/g, '') : '';
        save();
        advance();
      };
      if (charInput) {
        charInput.addEventListener('input', function () { state.characterName = charInput.value; });
        charInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitCharName(); }
        });
      }
      if (charCont) charCont.addEventListener('click', commitCharName);
    }
    /* Shrink near-square question media. Uploads with a ratio between
       0.8 and 1.25 (roughly 4:5 to 5:4) otherwise render full width and
       eat the whole viewport. Landscape and tall portraits are left
       alone so they still render at their natural width. Same rule
       applies to videos, measured from videoWidth and videoHeight once
       metadata is ready. */
    var applySquareIfNeeded = function (wrap, w, h) {
      if (!w || !h) return;
      var r = w / h;
      if (r >= 0.8 && r <= 1.25) wrap.classList.add('ffq-qhero--square');
    };
    var heroImg = screen.querySelector('.ffq-qhero img');
    if (heroImg) {
      var checkImg = function () { applySquareIfNeeded(heroImg.parentNode, heroImg.naturalWidth, heroImg.naturalHeight); };
      if (heroImg.complete) checkImg();
      else heroImg.addEventListener('load', checkImg);
    }
    var heroVid = screen.querySelector('.ffq-qhero video');
    if (heroVid) {
      var checkVid = function () { applySquareIfNeeded(heroVid.parentNode, heroVid.videoWidth, heroVid.videoHeight); };
      if (heroVid.readyState >= 1) checkVid();
      else heroVid.addEventListener('loadedmetadata', checkVid);
      /* Safari sometimes pauses autoplay on transition. Calling play()
         after the element is in the DOM nudges it. The promise is
         swallowed because rejection just means the browser blocked it,
         which is fine, the poster stays visible. */
      var p = heroVid.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }
  function paintQuestion(instant) {
    state.view = 'quiz';
    paint(questionHTML(state.step), instant, function () {
      bindQuestion(state.step);
      if (state.step >= 2) preloadReveals();
    });
  }
  function advance() {
    /* Belief-installing breath screens are anchored to the question
       the visitor JUST answered (not to an array index), so reordering
       QUESTIONS does not move the breaths to the wrong spot.
       Reframe lands after the first scored question (hobby_vibe).
       Heirloom lands after the second scored question (personality).
       Each fires at most once per session. The step counter does not
       move here; paintBreath leaves state.step on the just-answered
       question and lets the breath screen advance the step itself. */
    var justAnswered = QUESTIONS[state.step] && QUESTIONS[state.step].key;
    /* v33 the single breath fires after his_character (Q5), right before
       the_notice (Q6). Two short lines, branched by her stance. */
    if (justAnswered === 'his_character' && !state.breathShown.hinge) {
      paintBreath('hinge');
      return;
    }
    if (state.step < QUESTIONS.length - 1) {
      state.step++;
      save();
      paintQuestion();
    } else {
      finishQuiz();
    }
  }
  function goBack() {
    /* Back from any question also kills a pending breath timer.
       In practice the timer is only live while a breath screen is
       on screen, but the clear is cheap and keeps the invariant. */
    clearBreathTimer();
    if (state.step <= 0) { goToIntro(); return; }
    state.step--;
    save();
    paintQuestion();
  }

  /* ---------- Breath screens ----------
     A breath screen sits between two questions as a content moment, no
     option buttons. It auto advances after T_BREATH and also advances
     on tap. Tracked once per session so it does not re-appear if the
     visitor backs out and re-answers the prior question. */
  /* v33 the breath branches on her stance from Q1. The insider, who plays
     with him, gets respect. The semi and outsider get the gentle relief.
     Two short lines, nothing more. */
  function breathLines() {
    if (state.stance === 'insider') {
      return { headline: 'You already know exactly who he plays.', subline: 'The kind of gift he opens, then watches come to life.', add: 'All you do is open the door for him.' };
    }
    return { headline: 'You do not have to know his character.', subline: 'He brings it to life himself.', add: 'All you do is open the door for him.' };
  }
  function breathHTML(kind) {
    var b = BREATH[kind] || BREATH_DEFAULTS[kind];
    var lines = breathLines();
    var prompt = (b && b.prompt) || 'continue';
    var img = (b.image && b.image.full) || '';
    var vidSources = (b.video && b.video.sources) || [];
    var media = '';
    if (vidSources.length) {
      media = '<div class="ffq-breath__media">' +
        '<video autoplay muted loop playsinline preload="auto" disableremoteplayback' +
        (img ? ' poster="' + esc(img) + '"' : '') + '>';
      for (var vi = 0; vi < vidSources.length; vi++) {
        var s = vidSources[vi];
        if (s && s.url) {
          media += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      media += '</video></div>';
    } else if (img) {
      media = '<div class="ffq-breath__media"><img src="' + esc(img) +
        '" alt="" aria-hidden="true" decoding="async"></div>';
    } else {
      /* v37.2 the pause screens carry a real placeholder image too. */
      media = breathPlaceholderImgHTML();
    }
    return '<div class="ffq-breath ffq-breath--' + esc(kind) + '" id="ffq-breath" role="button" tabindex="0">' +
      '<h2 class="ffq-breath__headline">' + esc(lines.headline) + '</h2>' +
      media +
      '<p class="ffq-breath__subline">' + esc(lines.subline) + '</p>' +
      (lines.add ? '<p class="ffq-breath__subline">' + esc(lines.add) + '</p>' : '') +
      '<p class="ffq-breath__prompt">' + esc(prompt) + ' &rsaquo;</p>' +
      '</div>';
  }
  function paintBreath(kind) {
    state.breathShown[kind] = true;
    state.view = 'breath';
    /* Fire tracking once per session per breath, on first paint. */
    if (kind === 'reframe') {
      trackOnce('breath_reframe', function () {
        fbTrack('BreathReframeView', { content_name: 'Fathers Day Quiz 2026' });
        gaTrack('breath_reframe_view', {});
      });
    } else if (kind === 'heirloom') {
      trackOnce('breath_heirloom', function () {
        fbTrack('BreathHeirloomView', { content_name: 'Fathers Day Quiz 2026' });
        gaTrack('breath_heirloom_view', {});
      });
    }
    paint(breathHTML(kind), false, function () { bindBreath(kind); });
  }
  function bindBreath(kind) {
    clearBreathTimer();
    var el = document.getElementById('ffq-breath');
    if (!el) return;
    var fired = false;
    function advanceFromBreath() {
      if (fired) return;
      fired = true;
      clearBreathTimer();
      /* Move on to the next question. state.step was left at the
         just-answered question, so ++ lands on the next one. */
      if (state.step < QUESTIONS.length - 1) {
        state.step++;
        state.view = 'quiz';
        save();
        paintQuestion();
      } else {
        finishQuiz();
      }
    }
    el.addEventListener('click', advanceFromBreath);
    breathTimer = setTimeout(advanceFromBreath, T_BREATH);
  }

  /* ---------- Preloading ---------- */
  function preloadList(urls) {
    for (var i = 0; i < urls.length; i++) {
      if (urls[i]) { var im = new Image(); im.src = urls[i]; }
    }
  }
  var qImgPreloaded = false;
  function preloadQuestionImages() {
    if (qImgPreloaded) return;
    qImgPreloaded = true;
    var singles = ['recipient', 'q1', 'q1Family', 'q3', 'q4', 'q5', 'q6', 'qTraits', 'qSignature', 'qInside'];
    for (var i = 0; i < singles.length; i++) {
      if (Q_IMAGES[singles[i]]) preloadList([Q_IMAGES[singles[i]]]);
    }
  }
  var preloaded = false;
  function preloadReveals() {
    if (preloaded) return;
    preloaded = true;
    for (var k in IMG) {
      if (IMG.hasOwnProperty(k) && IMG[k] && IMG[k].full) {
        var im = new Image();
        im.src = IMG[k].full;
      }
    }
  }

  /* ============================================================
     THE ENDING  -  one continuous screen
     The reveal, the proof gallery, and the opt in form all render
     here. On a successful submit the opt in block swaps in place
     to the confirmation and the card.
     ============================================================ */
  function finishQuiz() {
    /* v24: no archetype is computed. We compute the gift route and seed
       the invitation card from her answers, then go to the builder,
       which is the card + gift end screen for both routes. The old
       archetype reveal (renderResult) is retired from the flow. */
    computeRoute();
    seedCardFromAnswers();
    state.view = 'builder';
    save();
    /* The card message is a prebuilt line keyed to her Q6 answer
       (seedCardFromAnswers + NOTICE_TO_PRESET). No external calls. */
    trackOnce('completed', function () {
      fbTrack('QuizCompleted', {
        content_name: 'Fathers Day Quiz 2026',
        route: state.giftRoute,
        branch: state.branch,
        world: answerByKey('his_world')
      });
      gaTrack('quiz_complete', { route: state.giftRoute });
    });
    var screen = screenEl();
    screen.classList.add('is-hidden');
    renderProgress();
    setTimeout(function () {
      screen.innerHTML = '<div class="ffq-reveal-beat">' +
        '<div class="ffq-reveal-beat__ring"></div>' +
        '<div class="ffq-reveal-beat__text">Bringing his card to life…</div></div>';
      screen.classList.remove('is-hidden');
    }, T_FADE);
    setTimeout(renderBuilder, T_FADE + T_BEAT);
  }

  function renderResult() {
    var d = revealData();
    var heroFull = (IMG[d.imageKey] && IMG[d.imageKey].full) || '';
    var hero = heroFull
      ? '<div class="ffq-hero"><img src="' + esc(heroFull) + '" alt="A Jan portrait"></div>'
      : '<div class="ffq-hero"><div class="ffq-hero__ph">Portrait</div></div>';
    var reads = '';
    for (var i = 0; i < d.read.length; i++) {
      reads += '<p class="ffq-readout__p">' + esc(d.read[i]) + '</p>';
    }
    /* Bridge line. A small gold Cinzel caption between the hero and
       the readout. Inline-styled with brand CSS vars so the CSS file
       does not need a new rule. Universal "Here's what that means
       about him." for archetypes, slightly shorter for Family. */
    var bridgeStyle = 'font-family:var(--ffq-display);font-size:14.5px;font-weight:600;letter-spacing:0.22em;text-transform:uppercase;color:var(--ffq-gold);text-align:center;margin:24px 0 10px;opacity:0.9;';
    var bridge = d.bridge
      ? '<p class="ffq-readout__bridge" style="' + bridgeStyle + '">' + esc(d.bridge) + '</p>'
      : '';
    /* v22 result page. The quiz no longer dead-ends on an archetype
       label. The reveal stays as recognition (the witness line + 2
       read paragraphs still carry the emotional peak), but the page
       headline is now "Here is the version of him I heard." and the
       read closes with a line that hands the buyer the next step.
       Below the read, the page splits on state.giftPath (from Q8)
       into one of two recommendation blocks: Direct Portrait or
       Quest Invitation. One primary CTA per branch, near the end. */
    var isFamily = state.branch === 'Family';
    /* Read the routing answer. Q8 stores 'direct' or 'invitation'.
       Default to 'direct' if the answer is missing (defensive — covers
       resume-from-old-storage edge cases). */
    var giftPath = answerByKey('gift_path') || 'direct';
    var newHeadline = isFamily
      ? 'Here is the version of your family I heard.'
      : 'Here is the version of him I heard.';
    /* Close line. Names that this is the part of him nobody else
       sees and pivots from recognition into the recommendation. */
    var closeLine = isFamily
      ? 'This is what your family is from the inside. Now you can hand it to him.'
      : 'This is the part of him nobody else sees. Now you can make sure he gets seen.';
    var html =
      '<div class="ffq-result">' +
        /* Small FRAMEDFANTASY wordmark above the headline on the
           reveal screen only. Doubles as a quiet return-home link. */
        '<a class="ffq-wordmark ffq-result__wordmark" href="/" aria-label="FramedFantasy home">FRAMEDFANTASY</a>' +
        /* ----- v22 reveal heading: no longer the archetype label.
           The tagline below it stays — it now reads as a quiet
           subhead under the new headline rather than a typed answer. */
        '<h1 class="ffq-result__headline" id="ffq-headline">' + esc(newHeadline) + '</h1>' +
        '<p class="ffq-result__tagline">' + esc(d.tagline) + '</p>' +
        hero +
        bridge +
        '<div class="ffq-readout">' + reads +
          /* v22 read close line — appended INSIDE the readout block
             so it sits visually with the read, not separated from it. */
          '<p class="ffq-readout__p ffq-readout__close">' + esc(closeLine) + '</p>' +
        '</div>' +
        '<div class="ffq-readout__sign">Jan, FramedFantasy</div>' +
        /* ----- Card download. A free recognition keepsake she can
           save or share. v23: shown on the DIRECT path only. On the
           invitation path it is suppressed on purpose, because a free
           downloadable finished card before the builder would fill the
           gap the empty-envelope builder is built to open. On the
           invitation path the card experience IS the builder, reached
           through the recommendation below. ----- */
        (giftPath === 'invitation' ? '' :
          '<div class="ffq-cardblock">' +
            '<p class="ffq-cardblock__head">Save his archetype card. Keep it, or send it to someone who knows him.</p>' +
            '<button type="button" class="ffq-cardbtn" id="ffq-cardbtn">' +
              '<span class="ffq-cardbtn__label">' +
                esc(cardButtonLabel().replace(/ ARCHETYPE CARD$/, '')) +
                '<br class="ffq-br-mobile">' +
                ' ARCHETYPE CARD' +
              '</span>' +
              '<svg class="ffq-cardbtn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>' +
                '<polyline points="7 10 12 15 17 10"/>' +
                '<line x1="12" y1="15" x2="12" y2="3"/>' +
              '</svg>' +
            '</button>' +
          '</div>') +
        /* ----- Real portraits, real homes. Visual proof of what a
           finished painting looks like for real customers. ----- */
        galleryHTML() +
        /* ----- v22 recommendation block. Branched on giftPath
           (set by Q8). Each branch has its own heading, body, button,
           and timing/note pair. Direct Portrait is the buy-by-cutoff
           path. Quest Invitation is the deadline-free path that ends
           in a downloadable card she designs herself. One CTA
           per branch, sized as the page's primary action. ----- */
        (function () {
          if (giftPath === 'invitation') {
            /* Quest Invitation. Defuses the two biggest blocks (does
               not need to know his character, deadline is gone) and
               positions the invitation as the gift, not packaging.
               The button opens the card builder (renderBuilder), not
               the product page. The builder is where she designs the
               invitation and meets the empty-envelope gap that the
               purchase closes. */
            var inviteHead = isFamily
              ? 'The gift that fits is an invitation.'
              : 'The gift that fits him is an invitation.';
            var inviteBody = isFamily
              ? 'You do not have to know each character. You hand him the adventure and your family brings it to life. He plays, his character takes shape, and I paint it by hand from there. Because it is a code, you can give it to him on Father\'s Day itself. Nothing to ship, nothing to race.'
              : 'You do not have to know his character. You hand him the adventure and he brings it to life himself. He plays, his character takes shape, and I paint it by hand from there. Because it is a code, you can give it to him on Father\'s Day itself. Nothing to ship, nothing to race.';
            var builderIntro = 'Let me help you make his invitation. Write him a line, or use one of mine. You will see exactly what he opens.';
            return '<div class="ffq-rec ffq-rec--invitation">' +
              '<h2 class="ffq-rec__head">' + esc(inviteHead) + '</h2>' +
              '<p class="ffq-rec__body">' + esc(inviteBody) + '</p>' +
              '<p class="ffq-rec__builder">' + esc(builderIntro) + '</p>' +
              '<button type="button" class="ffq-cta-primary" id="ffq-open-builder">' +
                '<span class="ffq-cta-primary__shimmer" aria-hidden="true"></span>' +
                '<span class="ffq-cta-primary__label">Make his invitation <span class="ffq-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
              '</button>' +
            '</div>';
          }
          /* Direct Portrait (default). Short heading, short body,
             timing line, button, descent line. */
          var directHead = isFamily
            ? 'You know them well enough to surprise him.'
            : 'You know him well enough to surprise him.';
          var directBody = isFamily
            ? 'Send me the photos and tell me what you know. I ask the rest. Nothing ships until it looks like all of you.'
            : 'Send me one photo and tell me what you know. I ask the rest. Nothing ships until it looks like him.';
          var directTiming = isFamily
            ? 'I can still finish theirs by Father\'s Day if you start by June 7.'
            : 'I can still finish his by Father\'s Day if you start by June 7.';
          var directBtnLabel = isFamily ? 'Start the portrait' : 'Start his portrait';
          return '<div class="ffq-rec ffq-rec--direct">' +
            '<h2 class="ffq-rec__head">' + esc(directHead) + '</h2>' +
            '<p class="ffq-rec__body">' + esc(directBody) + '</p>' +
            primaryButtonHTML('ffq-cta-start-1', directBtnLabel) +
            '<p class="ffq-cta-note ffq-cta-note--urgent">' + esc(directTiming) + '</p>' +
            '<p class="ffq-cta-note">Most people only wish they had done it sooner.</p>' +
          '</div>';
        })() +
        /* ----- v22 trust band. Carries the two load-bearing trust
           signals the page would otherwise lose: the money-back line
           and the personal-text line. Both are required per brief;
           do not cut either to save length. ----- */
        '<div class="ffq-trustband">' +
          '<p class="ffq-trustband__line">' + esc(isFamily
            ? 'If it does not feel right when you see it, you get your money back.'
            : 'If it does not feel like him when you see it, you get your money back.') + '</p>' +
          '<p class="ffq-trustband__line">You hear from me personally the whole way through.</p>' +
        '</div>' +
        /* ----- Loox reviews. The last main content block. ----- */
        '<div id="ffq-loox-mount" class="ffq-loox-mount" aria-label="Customer reviews"></div>' +
        /* ----- Retake link. The only thing below the reviews. ----- */
        '<button type="button" class="ffq-retake" id="ffq-retake">Retake the quiz from the start</button>' +
        /* ----- Sticky mobile CTA. v23 fix: only on the DIRECT path,
           where it links to the portrait product. On the invitation
           path it is omitted, because the action there is opening the
           builder (a JS view switch), which a plain link cannot do, and
           a sticky pointing at the portrait product would send her to
           the wrong place. The in-page "Make his invitation" button is
           the action on that path. ----- */
        (giftPath === 'invitation' ? '' :
          '<a class="ffq-sticky-cta" id="ffq-sticky-cta" href="' + esc(PRODUCT_URL) + '" data-ffq-cta="sticky"><span class="ffq-sticky-cta__label">' + esc(isFamily ? 'Start the portrait' : 'Start his portrait') + '</span><span class="ffq-sticky-cta__arrow" aria-hidden="true">&rarr;</span></a>') +
      '</div>';
    state.view = 'result';
    save();
    paint(html, true, function () {
      renderProgress();
      bindResult();
      /* Move the page level Loox section into the result screen. */
      mountLoox();
      trackOnce('reveal', function () {
        /* Keep the existing ResultRevealView event for continuity
           with the prior pixel rules and Klaviyo segments, and fire
           the new reveal_view event the v18 brief calls for. */
        fbTrack('ResultRevealView', {
          content_name: 'Fathers Day Quiz 2026',
          archetype: (ARCH[state.archetype] || {}).name || ''
        });
        gaTrack('result_reveal_view', { archetype: state.archetype });
        fbTrack('reveal_view', {
          content_name: 'Fathers Day Quiz 2026',
          archetype: (ARCH[state.archetype] || {}).name || ''
        });
        gaTrack('reveal_view', { archetype: state.archetype });
      });
    });
  }
  /* ---------- Primary CTA helper ----------
     The buy button. Identical markup wherever it appears on the page
     so the click handler can find each instance by class. The href
     points at PRODUCT_URL with no query params so the product page
     renders its normal standalone self. */
  function primaryButtonHTML(id, label) {
    /* v21 accepts a label so the family branch can swap "Start his
       portrait" for "Start the portrait". Sticky mobile CTA stays
       hardcoded per the brief, so the swap only applies here in the
       offer block. */
    var lbl = label || 'Start his portrait';
    return '<a class="ffq-cta-primary" id="' + esc(id) + '" href="' + esc(PRODUCT_URL) + '" data-ffq-cta="primary">' +
      '<span class="ffq-cta-primary__shimmer" aria-hidden="true"></span>' +
      '<span class="ffq-cta-primary__label">' + esc(lbl) + ' <span class="ffq-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
    '</a>';
  }
  /* ---------- Trust band helper ----------
     Jan in first person, then a row of trust signals as badges. This
     is the work the personal text used to do, now living on the page
     because the personal text no longer fires before the sale. An
     optional square video sits above the intro when a merchant has
     uploaded one in the theme editor. autoplay muted loop playsinline
     is the only combo that auto starts on iOS Safari and modern
     Chrome, so the clip starts on its own without any user gesture
     and the page never gets browser-blocked audio. The poster image,
     if also set, shows instantly while the video buffers. */
  function trustVideoHTML() {
    var tv = (CONFIG && CONFIG.trustVideo) || {};
    var sources = tv.sources || [];
    var poster = tv.poster || '';
    if (!sources.length && !poster) return '';
    var html = '<div class="ffq-trust__video">';
    if (sources.length) {
      html += '<video class="ffq-trust__videoel" autoplay muted loop playsinline preload="auto" disableremoteplayback';
      if (poster) html += ' poster="' + esc(poster) + '"';
      html += '>';
      for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        if (s && s.url) {
          html += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      html += '</video>';
    } else if (poster) {
      /* No video set, only a poster image. Render the still on its
         own so the slot is not blank when a merchant uploaded just
         the poster. */
      html += '<img class="ffq-trust__videoel" src="' + esc(poster) + '" alt="" aria-hidden="true" decoding="async" loading="lazy">';
    }
    html += '</div>';
    return html;
  }
  function trustBandHTML() {
    var badges = [
      'Money back guarantee',
      'Unlimited revisions until it looks like him',
      '1000+ portraits painted',
      '500+ five star reviews',
      'Hand painted by Jan, start to finish'
    ];
    var items = '';
    for (var i = 0; i < badges.length; i++) {
      items += '<li class="ffq-trust__badge">' + esc(badges[i]) + '</li>';
    }
    return '<div class="ffq-trust">' +
      trustVideoHTML() +
      '<p class="ffq-trust__intro">Hi, I am Jan. I paint every portrait by hand and I run every order myself. You do not play and you do not need to. You tell me who he is and I take it from there.</p>' +
      '<ul class="ffq-trust__badges">' + items + '</ul>' +
    '</div>';
  }

  /* ---------- The opt in block ---------- */
  /* The opt in sub line references the deadline she picked on question 3. */
  function fathersDayCutoffDate() {
    var parts = String(FD_CUTOFF).split('-');
    var y = parseInt(parts[0], 10), m = parseInt(parts[1], 10), d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }
  function fathersDayDoable() {
    var c = fathersDayCutoffDate();
    if (!c) return true;
    return new Date() < c;
  }
  function cutoffLabel() {
    var c = fathersDayCutoffDate();
    if (!c) return 'the cutoff';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[c.getMonth()] + ' ' + c.getDate();
  }
  /* v12 dynamic opt-in copy. Both the headline and subhead now key off
     state.recipient (set by Q1) and state.archetype (set by computeResult)
     so the form mirrors back exactly what she just told us. The Family
     branch gets its own headline + subhead because there's no single
     archetype to name. The cutoff date inside both subhead variants
     still flows from cutoffLabel() so the theme editor's fathers_day_cutoff
     setting continues to drive it. */
  function archetypeShortNoun() {
    /* "the Knight" / "the Bard" / etc. — short noun form for the
       opt-in headline, distinct from the full ARCH[].name ("Noble
       Knight") used in the reveal headline above. Dungeon Master
       stays two-word because there's no shorter version. */
    var map = {
      noble_knight:       'Knight',
      devoted_cleric:     'Cleric',
      charismatic_bard:   'Bard',
      arcane_spellcaster: 'Spellcaster',
      wild_ranger:        'Ranger',
      sneaky_rogue:       'Rogue',
      mighty_barbarian:   'Barbarian',
      dungeon_master:     'Dungeon Master'
    };
    return map[state.archetype] || 'character';
  }
  function recipientNoun() {
    /* Q1 collapses boyfriend + partner into a single "boyfriend or
       partner" option, so we render that branch as "partner" — the
       more universal word and the one the spec calls for when the
       Q1 option covers both. */
    var map = {
      husband:   'husband',
      boyfriend: 'partner',
      dad:       'dad'
    };
    return map[state.recipient] || 'guy';
  }
  function optinHeadline() {
    if (state.branch === 'Family') {
      return 'Want your family painted as your adventuring party?';
    }
    return 'Want your ' + recipientNoun() +
      ' hand painted as the ' + archetypeShortNoun() + '?';
  }
  function optinSubhead() {
    /* v18 subhead. The result page primary CTA is now the buy button.
       The opt-in lives only as the collapsed fallback ("Not ready
       today?"), so the headline + subhead are no longer rendered above
       the fields. This helper is kept so the function reference exists
       in case downstream callers expect it, but it returns an empty
       string in v18 and the fallback's link copy provides the framing. */
    return '';
  }
  /* v17 timing question lives on the SMS opt-in form as inline form
     data, not in the quiz body. Same four options that used to be
     Q3. The picked value is written to state.timing on form submit
     and pushed to Klaviyo as FathersDayQuiz_Timing. */
  /* v17.3: ASAP option removed. The "show me what's open" framing
     was reading as a sales qualifier instead of a timing pick, and
     the buyer most likely to pick ASAP is already covered by the
     Father's Day choice when the cutoff is close. Three options
     keep the form tighter and the choice cleaner. */
  var TIMING_OPTIONS = [
    { value: 'Fathers Day',             label: 'Father\'s Day this year, June 21' },
    { value: 'Birthday or anniversary', label: 'A birthday or anniversary coming up' },
    { value: 'No rush',                 label: 'No rush, whenever it is ready' }
  ];
  function timingFieldHTML() {
    var html = '<fieldset class="ffq-timing">' +
      '<legend class="ffq-label">When are you thinking?</legend>';
    for (var i = 0; i < TIMING_OPTIONS.length; i++) {
      var opt = TIMING_OPTIONS[i];
      var checked = state.timing === opt.value ? ' checked' : '';
      html += '<label class="ffq-timing__opt">' +
        '<input type="radio" name="ffq-timing" value="' + esc(opt.value) + '"' + checked + '>' +
        '<span>' + esc(opt.label) + '</span>' +
        '</label>';
    }
    html += '<p class="ffq-fielderror" id="ffq-timing-err" hidden></p></fieldset>';
    return html;
  }
  function optinInnerHTML() {
    /* v18 fallback form. Headline and subhead removed because the
       fallback link "Not ready today? Jan will text you once before
       June 7." now provides the framing. The form holds the timing
       question (kept because the SMS nurture uses it), first name,
       mobile number, the submit button, and one line of microcopy.
       Submission still posts to the same Klaviyo destination. */
    return timingFieldHTML() +
      '<div class="ffq-field">' +
        '<label class="ffq-label" for="ffq-fname">First name</label>' +
        '<input class="ffq-input" id="ffq-fname" type="text" autocomplete="given-name" placeholder="Your first name">' +
        '<p class="ffq-fielderror" id="ffq-fname-err" hidden></p>' +
      '</div>' +
      '<div class="ffq-field">' +
        '<label class="ffq-label" for="ffq-phone">Mobile number</label>' +
        '<div class="ffq-phone-row">' +
          '<select class="ffq-country" id="ffq-country" aria-label="Country code">' +
            '<option value="US">US +1</option>' +
            '<option value="CA">CA +1</option>' +
          '</select>' +
          '<input class="ffq-input" id="ffq-phone" type="tel" autocomplete="tel-national" inputmode="numeric" placeholder="(555) 123-4567">' +
        '</div>' +
        '<p class="ffq-fielderror" id="ffq-phone-err" hidden></p>' +
      '</div>' +
      '<button type="button" class="ffq-submit" id="ffq-submit">Have Jan text me</button>' +
      '<p class="ffq-micro-note">I text you personally. The same number works to talk through his photo and his character. No spam, just me.</p>';
  }
  function bindResult() {
    var screen = screenEl();
    var retake = screen.querySelector('#ffq-retake');
    var cardBtn = screen.querySelector('#ffq-cardbtn');
    if (retake) retake.addEventListener('click', resetQuiz);
    if (cardBtn) cardBtn.addEventListener('click', saveCard);
    /* v23: the invitation-path recommendation button opens the card
       builder (a new in-app view), not the product page. */
    var openBuilder = screen.querySelector('#ffq-open-builder');
    if (openBuilder) {
      openBuilder.addEventListener('click', function () {
        fbTrack('build_invitation_open', { content_name: 'Fathers Day Quiz 2026' });
        gaTrack('build_invitation_open', {});
        renderBuilder();
      });
    }
    /* v19 primary CTA. Both Start his portrait buttons and the
       sticky mobile CTA fire start_portrait_click before the browser
       follows the href. The pixel and gtag beacons are designed to
       survive same-tab navigation, so no preventDefault is needed. */
    var primaryButtons = screen.querySelectorAll('[data-ffq-cta]');
    Array.prototype.forEach.call(primaryButtons, function (btn) {
      btn.addEventListener('click', function () {
        fbTrack('start_portrait_click', {
          content_name: 'Fathers Day Quiz 2026',
          archetype: (ARCH[state.archetype] || {}).name || '',
          placement: btn.getAttribute('data-ffq-cta') || 'primary'
        });
        gaTrack('start_portrait_click', {
          archetype: state.archetype,
          placement: btn.getAttribute('data-ffq-cta') || 'primary'
        });
      });
    });
    /* Trust band square video. Safari sometimes pauses autoplay on
       screen transitions, so a play() nudge after the element is in
       the DOM kicks it back on. Promise rejection is swallowed
       because a block just means the poster stays visible. */
    var trustVid = screen.querySelector('.ffq-trust__video video');
    if (trustVid) {
      var tp = trustVid.play();
      if (tp && typeof tp.catch === 'function') tp.catch(function () {});
    }
  }

  /* ============================================================
     v23 QUEST INVITATION CARD BUILDER  (Path A)
     ============================================================
     The emotional and commercial centerpiece of the invitation path.
     She designs the OUTSIDE of an invitation she will give him. The
     live preview is HTML and CSS, not canvas, so it updates smoothly
     on every keystroke and lets the empty-envelope gap render cleanly.

     The non-negotiable rule. The free card is an empty envelope. The
     preview shows a finished-looking invitation with a visibly SEALED,
     empty code slot. There is no quest, no code, and no portrait
     behind it yet. The download is locked. The only move that fills
     the gap is the purchase. She builds the wrapping for free and owns
     it emotionally, but she cannot complete or download it until she
     puts his adventure inside. That tension is the whole engine.

     The builder stays an emotional act, not a design tool. Three
     inputs only. The polish is locked. The message presets pull care
     and protection of a loved one. The descent line survives right
     before the button. */

  /* Four invitation art themes, matching the four worlds in the brief:
     a tavern, an arcane study, the wilds, a grand hall. Each maps to an
     optional theme-editor image (CONFIG.inviteArt[key]). When no image
     is set the card fills with a hand-drawn SVG scene (not a flat
     color) so picking a world changes the whole scene, which is what
     turns the builder from a form into a gift. When Jan uploads real
     scene art it takes over and the SVG is the fallback. */
  /* v34 the five card themes. Each is a full theme: a research-backed
     jewel-tone palette plus a hand drawn scene, with gold the constant
     accent (gold reads as a keepsake on any ground). The swatch is the
     darker palette anchor shown on the picker chip. Default is derived
     from his world in defaultThemeForHobby, and she can pick any of them. */
  var INVITE_ART_THEMES = [
    /* v36.9 a romantic option in the FramedFantasy brand colours, with a scene
       of floating hearts. The swatch is the two brand colours blended.
       v37.3 Jan: Love leads the picker and is the default for everyone. */
    { key: 'love',   label: 'Love',      swatch: 'linear-gradient(135deg, #ED96FD, #AAFEFE)' },
    { key: 'tavern', label: 'Candlelit', swatch: '#5a4019' },
    { key: 'arcane', label: 'Arcane',    swatch: '#3a2a63' },
    { key: 'wilds',  label: 'Wilds',     swatch: '#1b3d27' },
    { key: 'hall',   label: 'Royal',     swatch: '#1c2c5a' },
    { key: 'ember',  label: 'Ember',     swatch: '#4a1a20' }
  ];
  function defaultThemeForHobby() {
    /* v37.3 Jan: Love is the default colour for everyone now (it also leads the
       picker). The earlier hobby-derived default (DnD->tavern, Reading->arcane,
       VideoGame->hall, else wilds) is retired. */
    return 'love';
  }
  function inviteArtUrl(key) {
    var art = (CONFIG && CONFIG.inviteArt) || {};
    return art[key] || '';
  }
  /* v24 route-aware copy for the builder + invitation. The character
     route (default) frames the gift as an adventure he plays to bring
     his own character to life. The portrait route frames it as turning
     him into the hero from one photo she sends. Both buy the same gift
     card and keep the empty-envelope gap. */
  function routeCopy() {
    if (state.giftRoute === 'portrait') {
      return {
        summons: 'Your portrait is on the way.',
        codeLabel: 'To claim your portrait',
        codeHintSample: 'A sample. His real code appears here once you finish his gift.',
        codeHintReal: 'Enter this code at FramedFantasy.com/Gift',
        gift: 'Him, turned into the hero, painted by hand from one photo you send.',
        status: 'His card is ready. One step puts his portrait behind it.',
        cta: 'Give him his gift',
        trust: 'You send me one photo. I paint him by hand.'
      };
    }
    return {
      summons: 'Your adventure is waiting.',
      codeLabel: 'To claim your portrait',
      codeHintSample: 'A sample. His real code appears here once you finish his gift.',
      codeHintReal: 'Enter this code at FramedFantasy.com/Gift',
      gift: 'His character, painted by hand and his to keep. His part is already paid for, so all he does is show up and play.',
      status: 'His card is ready. One step puts his portrait behind it.',
      cta: 'Give him his adventure',
      trust: 'His slot is already paid for. He just shows up and plays.'
    };
  }
  /* Hand-drawn scene per world. Gold silhouettes over the theme
     gradient (the gradient lives in CSS). Simple and atmospheric, not
     busy. preserveAspectRatio slices so it always fills the band. */
  function inviteSceneSVG(key) {
    var g = '#c9a84c', gb = '#e8c674';
    var open = '<svg class="ffq-invite__scene" viewBox="0 0 400 200" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    var scenes = {
      tavern:
        /* v36.3 candlelit. v37.11 the flames flicker (per-candle, staggered)
           and the glow breathes. */
        '<circle class="ffq-anim-glow" cx="200" cy="74" r="46" fill="' + gb + '" opacity="0.10"/>' +
        '<g fill="' + g + '" opacity="0.5">' +
          '<rect x="151" y="92" width="15" height="66" rx="4"/>' +
          '<rect x="192" y="74" width="16" height="84" rx="4"/>' +
          '<rect x="234" y="100" width="15" height="58" rx="4"/>' +
        '</g>' +
        '<g fill="' + gb + '" opacity="0.3">' +
          '<ellipse cx="158.5" cy="92" rx="7.5" ry="2.5"/>' +
          '<ellipse cx="200" cy="74" rx="8" ry="2.5"/>' +
          '<ellipse cx="241.5" cy="100" rx="7.5" ry="2.5"/>' +
        '</g>' +
        '<g fill="' + gb + '" opacity="0.8">' +
          '<path class="ffq-anim-flame" style="animation-delay:-.2s" d="M158.5 90 C151 82, 154 72, 158.5 66 C163 72, 166 82, 158.5 90 Z"/>' +
          '<path class="ffq-anim-flame" style="animation-delay:-1.1s" d="M200 72 C191 63, 195 50, 200 43 C205 50, 209 63, 200 72 Z"/>' +
          '<path class="ffq-anim-flame" style="animation-delay:-.6s" d="M241.5 98 C234 90, 237 80, 241.5 74 C246 80, 249 90, 241.5 98 Z"/>' +
        '</g>' +
        '<g fill="#fff3d6" opacity="0.55">' +
          '<path class="ffq-anim-flame" style="animation-delay:-.45s" d="M158.5 88 C154 82, 156 75, 158.5 71 C161 75, 163 82, 158.5 88 Z"/>' +
          '<path class="ffq-anim-flame" style="animation-delay:-1.4s" d="M200 70 C195 63, 197 53, 200 48 C203 53, 205 63, 200 70 Z"/>' +
          '<path class="ffq-anim-flame" style="animation-delay:-.85s" d="M241.5 96 C237 90, 239 83, 241.5 79 C244 83, 246 90, 241.5 96 Z"/>' +
        '</g>' +
        '<rect x="120" y="158" width="160" height="4" rx="2" fill="' + g + '" opacity="0.4"/>',
      arcane:
        /* v35 wizard hat. v37.11 the star shines/glows purple. */
        '<ellipse cx="200" cy="151" rx="76" ry="12" fill="' + g + '" opacity="0.4"/>' +
        '<path d="M162 151 Q190 120 199 82 Q203 62 217 58 Q206 76 209 98 Q214 126 238 151 Z" fill="' + g + '" opacity="0.55"/>' +
        '<path d="M178 132 Q200 142 222 132 L220 124 Q200 133 180 124 Z" fill="' + gb + '" opacity="0.45"/>' +
        '<g fill="' + gb + '" opacity="0.8"><polygon class="ffq-anim-star" points="200,92 203,103 214,103 205,110 208,121 200,114 192,121 195,110 186,103 197,103"/></g>' +
        /* v38.2 magic sparkles rise from the hat tip, staggered so a little burst of
           magic pops every so often. Each is base opacity 0 (hidden in the static
           PNG export); the animation brings it in only on the live card + the present
           reveal. Outer g positions, inner g animates (avoids the SVG-attr vs CSS
           transform conflict). */
        '<g fill="' + gb + '">' +
          '<g transform="translate(214 46)"><g class="ffq-anim-magic" opacity="0" style="animation-delay:0s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(231 55) scale(0.7)"><g class="ffq-anim-magic" opacity="0" style="animation-delay:-1.4s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(198 42) scale(0.9)"><g class="ffq-anim-magic" opacity="0" style="animation-delay:-2.6s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(223 34) scale(0.6)"><g class="ffq-anim-magic" opacity="0" style="animation-delay:-0.7s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(206 52) scale(0.8)"><g class="ffq-anim-magic" opacity="0" style="animation-delay:-3.4s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
        '</g>',
      wilds:
        /* v37.11 the sun/moon arcs in a slow orbit (day to night) + dims. */
        '<g class="ffq-anim-orbit">' +
          '<circle cx="312" cy="52" r="20" fill="' + gb + '" opacity="0.2"/>' +
          '<circle cx="312" cy="52" r="20" fill="none" stroke="' + gb + '" stroke-width="1.5" opacity="0.55"/>' +
        '</g>' +
        '<g fill="' + g + '" opacity="0.45">' +
          '<polygon points="60,165 100,95 140,165"/><polygon points="120,165 165,80 210,165"/>' +
          '<polygon points="250,165 295,100 340,165"/>' +
        '</g>' +
        '<g fill="' + g + '" opacity="0.3"><polygon points="0,165 70,120 150,165"/><polygon points="230,165 320,118 400,165"/></g>' +
        '<rect x="0" y="163" width="400" height="4" fill="' + g + '" opacity="0.4"/>',
      hall:
        '<g fill="' + g + '" opacity="0.4">' +
          '<rect x="74" y="60" width="16" height="100"/><rect x="150" y="60" width="16" height="100"/>' +
          '<rect x="234" y="60" width="16" height="100"/><rect x="310" y="60" width="16" height="100"/>' +
        '</g>' +
        /* v37.11 extra pillars rise in then vanish, so the hall keeps shifting
           back to its four. Hidden (opacity 0) in the static export. */
        '<g fill="' + g + '">' +
          '<rect class="ffq-anim-pillar" style="animation-delay:0s" x="112" y="60" width="16" height="100" opacity="0"/>' +
          '<rect class="ffq-anim-pillar" style="animation-delay:-2.2s" x="272" y="60" width="16" height="100" opacity="0"/>' +
          '<rect class="ffq-anim-pillar" style="animation-delay:-4.4s" x="192" y="60" width="16" height="100" opacity="0"/>' +
        '</g>' +
        '<g fill="none" stroke="' + g + '" stroke-width="2" opacity="0.45">' +
          '<path d="M74 60 Q82 44 90 60"/><path d="M150 60 Q158 44 166 60"/>' +
          '<path d="M234 60 Q242 44 250 60"/><path d="M310 60 Q318 44 326 60"/>' +
        '</g>' +
        '<g fill="' + gb + '" opacity="0.6"><polygon points="190,30 210,30 206,52 200,46 194,52"/></g>' +
        '<rect x="0" y="160" width="400" height="4" fill="' + g + '" opacity="0.4"/>',
      ember:
        /* v35 symmetric flame. v37.11 the flame flickers + sparks rise off it. */
        '<circle class="ffq-anim-glow" cx="200" cy="106" r="58" fill="' + gb + '" opacity="0.10"/>' +
        '<path class="ffq-anim-flame" style="animation-delay:-.3s" d="M200 152 C 158 124, 176 82, 200 58 C 224 82, 242 124, 200 152 Z" fill="' + g + '" opacity="0.5"/>' +
        '<path class="ffq-anim-flame" style="animation-delay:-.9s" d="M200 146 C 178 126, 188 98, 200 80 C 212 98, 222 126, 200 146 Z" fill="' + gb + '" opacity="0.75"/>' +
        '<g fill="' + gb + '">' +
          '<circle class="ffq-anim-spark" style="animation-delay:0s" cx="188" cy="120" r="2.2" opacity="0"/>' +
          '<circle class="ffq-anim-spark" style="animation-delay:-1.3s" cx="212" cy="120" r="1.8" opacity="0"/>' +
          '<circle class="ffq-anim-spark" style="animation-delay:-2.4s" cx="200" cy="118" r="2" opacity="0"/>' +
          '<circle class="ffq-anim-spark" style="animation-delay:-3.2s" cx="178" cy="122" r="1.5" opacity="0"/>' +
        '</g>' +
        '<rect x="120" y="158" width="160" height="3" rx="1.5" fill="' + g + '" opacity="0.4"/>',
      /* v36.9 Love hearts. v37.11 each heart gently drifts + breathes (staggered). */
      love: (function () {
        var hp = 'M12 21 C12 21 3 13.5 3 8.5 C3 5.5 5.5 4 7.5 4 C9.5 4 11 5.5 12 7 C13 5.5 14.5 4 16.5 4 C18.5 4 21 5.5 21 8.5 C21 13.5 12 21 12 21 Z';
        var pink = '#ED96FD', cyan = '#AAFEFE';
        var hearts = [
          [200, 80, 2.4, pink, 0.85], [120, 60, 1.2, cyan, 0.6], [285, 55, 1.5, gb, 0.55],
          [80, 122, 1.1, cyan, 0.5], [322, 120, 1.3, pink, 0.6], [156, 142, 1.0, gb, 0.5],
          [246, 138, 1.2, cyan, 0.55], [58, 82, 0.85, pink, 0.45], [350, 78, 0.95, gb, 0.4]
        ];
        var out = '<circle class="ffq-anim-glow" cx="200" cy="82" r="58" fill="' + pink + '" opacity="0.10"/>';
        for (var hi = 0; hi < hearts.length; hi++) {
          var ht = hearts[hi];
          out += '<g transform="translate(' + ht[0] + ',' + ht[1] + ')">' +
            '<g class="ffq-anim-fheart" style="animation-delay:' + (-(hi * 0.6)).toFixed(1) + 's">' +
              '<path transform="scale(' + ht[2] + ') translate(-12,-12)" d="' + hp + '" fill="' + ht[3] + '" opacity="' + ht[4] + '"/>' +
            '</g>' +
          '</g>';
        }
        return out;
      })()
    };
    return open + (scenes[key] || scenes.wilds) + '</svg>';
  }
  /* v30 the same scene as a data URL, so the export canvas can raster it
     into the banner and match the on-screen preview. Self-contained SVG
     (inline colors, no external refs), so it does not taint the canvas. */
  function inviteSceneDataUrl(key) {
    /* Add an explicit intrinsic size so the rasterized image scales
       predictably when drawn onto the export canvas. */
    var svg = inviteSceneSVG(key).replace('<svg ', '<svg width="400" height="200" ');
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  /* Small wax seal motif for the sealed code slot. A serrated gold
     disc with the FF monogram, so the empty slot reads as a sealed
     envelope she has not opened yet. */
  function inviteSealSVG() {
    return '<svg class="ffq-invite__waxsvg" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="32" cy="32" r="22" fill="#7a1f1a"/>' +
      '<circle cx="32" cy="32" r="22" fill="none" stroke="#9c2a22" stroke-width="3"/>' +
      '<circle cx="32" cy="32" r="15" fill="none" stroke="#c9837c" stroke-width="1" opacity="0.6"/>' +
      '<text x="32" y="39" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-size="16" font-weight="700" fill="#e8c0bc">FF</text>' +
      '</svg>';
  }
  /* v27 sanitize a pasted code. Uppercase, keep letters, numbers, and
     dashes only, cap the length. Returns '' for anything too short to be
     a real Shopify code. No server check, this only prints her code onto
     the card, he claims his portrait at FramedFantasy.com/Gift. */
  function sanitizeCode(s) {
    var c = (s || '').toUpperCase().replace(/[^A-Z0-9\-]/g, '').slice(0, 32);
    return c.length >= 4 ? c : '';
  }
  /* Message presets. First person, from her to him, tuned to pull care
     and protection of a loved one (she honors him, she protects the
     part of him the world overlooks). She can use one untouched or
     edit it. The build-it-and-own-it effect fires either way because
     she chose and placed it. */
  var INVITE_PRESETS = [
    'Most people never see this side of you. I do. This year I wanted you to see it too.',
    'You spend every year taking care of all of us. This time it is your turn to be the hero.',
    'You have carried this whole crew for as long as I have known you. I made you something that says I noticed.',
    'There is a version of you that only comes out when you play. I wanted to give him a face.',
    'You step in before any of us even sees it coming. I notice, even when you think no one does.',
    /* v26: index 5 funny, index 6 clever. */
    'You are the one who makes the whole table laugh. I wanted to give that part of you a face.',
    'You are always three moves ahead, and I love watching you do it. I wanted to give that part of you a face.'
  ];
  /* v30 short labels for the message picker. The picker shows the gist so
     the list stays scannable. The full line above goes on the card, where
     she reads it in full. Index-aligned with INVITE_PRESETS. */
  var INVITE_PRESET_LABELS = [
    'The side only I see',
    'Your turn to be the hero',
    'You carry us all',
    'The character you play',
    'You step in for us',
    'You make the whole table laugh',
    'You are always three moves ahead'
  ];
  /* The collapsed picker's current line. A preset shows its gist, her own
     written line shows its text (the field truncates it). */
  function msgPickLabel() {
    var p = state.cardMsgPreset;
    if (p !== 'custom' && p !== '' && INVITE_PRESET_LABELS[parseInt(p, 10)]) {
      return INVITE_PRESET_LABELS[parseInt(p, 10)];
    }
    return (state.cardMessage || '').trim() || 'Choose a message';
  }

  function renderBuilder() {
    state.view = 'builder';
    if (!state.cardTheme) state.cardTheme = defaultThemeForHobby();
    /* v36.1 the card message is a prebuilt line keyed to her Q6 answer
       (seedCardFromAnswers). No AI call, so nothing to fold in here. */
    if (!state.cardMessage) seedCardFromAnswers();
    save();
    paint(builderHTML(), false, function () {
      bindBuilder();
      mountMarquees(screenEl());
      /* v28 bring the page's real reviews into the proof beat. No-ops if
         there is no Loox section on the page. */
      mountLoox();
    });
  }

  /* The invitation preview, inner HTML only (no wrapper). Re-rendered
     on every edit. Lives in its own node so re-rendering it never
     disturbs focus in the control fields. */
  /* A made-up code shown in the preview so she sees exactly what the
     finished card looks like before she buys. Her real code replaces it
     once she pastes it (paste-to-unlock). It is only a sample. */
  var SAMPLE_CODE = 'XXXX-XXXX';
  /* The name line. Her typed name wins. With no name it falls back to
     who she is buying for, so it reads "For your partner" not a generic
     line. */
  /* v37.1 occasion. The first quiz question lets her pick Father's Day (the
     default) or his birthday, and that re-themes the card copy that depends on
     the occasion: the greeting, the date stamp, and the "give him the card on X"
     buyer step. Father's Day keeps everything Father's-Day; birthday swaps it.
     Read dynamically so EYEBROW_LABEL (editor-set) still drives the FD stamp. */
  function occasionKey() {
    /* v38 Father's Day only. The occasion question was removed, so this is fixed.
       The other occasion helpers keep their branches but only the FD branch is
       reached now. */
    return 'fathers_day';
  }
  /* The big line on the card. "Other" has no fixed occasion phrase, so it greets
     him warmly without naming a day. */
  function occasionGreet() {
    var k = occasionKey();
    if (k === 'birthday') return 'Happy Birthday';
    if (k === 'anniversary') return 'Happy Anniversary';
    if (k === 'other') return 'For you';
    return 'Happy Father\'s Day';
  }
  /* The small datestamp above the greeting. FD uses the editor-set label so the
     year stays current; the rest get a fixed stamp. */
  function occasionStamp() {
    var k = occasionKey();
    if (k === 'birthday') return 'HAPPY BIRTHDAY';
    if (k === 'anniversary') return 'HAPPY ANNIVERSARY';
    if (k === 'other') return 'A GIFT FOR YOU';
    return EYEBROW_LABEL;
  }
  /* The "when do I hand it over" buyer step. FD/birthday/anniversary name the day;
     "other" stays open since there is no fixed date. Returns the full sentence so
     each case reads naturally. */
  function occasionGiveStep() {
    var k = occasionKey();
    if (k === 'birthday') return 'On his birthday, give him the card and his code.';
    if (k === 'anniversary') return 'On your anniversary, give him the card and his code.';
    if (k === 'other') return 'When the moment is right, give him the card and his code.';
    return 'On Father\'s Day, open this page with his code ready and [Present his card](#present-card).';
  }
  /* v38.26 device detection for the "keep this page" step. Touch/coarse pointer or
     a mobile UA reads as a phone (say save the link); otherwise a computer (say
     bookmark it). No keyboard shortcut. The code is mentioned in step 1 now. */
  function ffqIsTouch() {
    try {
      if ((navigator.maxTouchPoints || 0) > 1) return true;
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    } catch (e) { return false; }
  }
  function bookmarkStep() {
    return ffqIsTouch()
      ? 'Save this page so it is ready on the day.'
      : 'Bookmark this page so it is ready on the day.';
  }
  /* v37.9.4 the occasion worded for the reveal headline ("Customize your ___ card").
     "Something else" has no label, so the headline reads just "your card". */
  function occasionLabel() {
    var k = occasionKey();
    if (k === 'birthday') return 'birthday';
    if (k === 'anniversary') return 'anniversary';
    if (k === 'other') return '';
    return 'Father\'s Day';
  }
  /* v29 the big line is the occasion greeting, so the card reads as the right
     card the moment he sees it. Her name for him wins. With no name, the dad and
     family routes still address him as Dad, the others greet him without a name. */
  function inviteGreeting() {
    var g = occasionGreet();
    var name = (state.hisName || '').trim();
    if (name) return g + ', ' + name;
    var rk = (state.recipient || '').toLowerCase();
    if (rk === 'dad' || rk === 'whole_family') return g + ', Dad';
    return g;
  }
  /* v29 the sign-off, so the card is signed by whoever sent it. Her own
     name wins on any route. Otherwise it falls back to the relationship
     she gave on question one, so most routes need no extra input. The
     dad route has no fitting relationship word, so with no name it signs
     from the family. */
  function inviteSignoff() {
    var from = (state.fromName || '').trim();
    if (from) return 'Love, ' + from;
    var rk = (state.recipient || '').toLowerCase();
    if (rk === 'husband') return 'Love, your wife';
    if (rk === 'boyfriend') return 'Love, your partner';
    return 'Love, your family';
  }
  /* The hint shown in the optional from field, so she can see what the
     card will say if she leaves it blank. */
  function fromPlaceholder() {
    var rk = (state.recipient || '').toLowerCase();
    if (rk === 'husband') return 'Leave blank to sign from your wife';
    if (rk === 'boyfriend') return 'Leave blank to sign from your partner';
    if (rk === 'whole_family') return 'Leave blank to sign from your family';
    return 'Add your name';
  }
  /* v36.6 the claim block at the bottom of the card. Instead of a bare code
     and a hover "?", the card itself spells out exactly how he brings his
     character to life: the gift he has, the three steps, and his code. It is
     written so the card reads as a finished, prepackaged gift the moment he
     opens it. Before she finishes his gift it shows a sample code and a clear
     disclaimer that the steps go live once she does, so a downloaded sample
     never reads as a working gift. Route-aware (quest vs photo). */
  /* v37.6 (Changes 4 + 5) the editable "your character" value for the claim
     gift line on the card. Her in-place card edit wins, then the name she
     captured in the quiz (the "same one for years" answer), then the default
     "your character". Shared by the live card and the PNG export so they stay
     in sync. */
  function cardCharacterValue() {
    var edit = (state.cardCharacter && state.cardCharacter.trim());
    if (edit) return edit;
    var quiz = (state.characterName && state.characterName.trim());
    if (quiz) return quiz;
    return 'your character';
  }
  /* v37.0 the gift line is the white SUBTEXT under the gold eyebrow, leading
     into the three steps (copy per Jan).
     v37.6 (Change 4) only the "your character" words are editable on the
     card, so she can put his character's name on it (for example "a hand
     painted Thigh up portrait of Bramblefoot."). The size word, the rest of
     the sentence, and the trailing period stay fixed. The photo route keeps
     the fixed "you as the hero" since there is no single character there.
     v39.1 extracted so a size change can rebuild just this line in place
     (updateClaimGiftLine) instead of repainting the whole card front. */
  function claimGiftHTML() {
    var character = state.giftRoute !== 'portrait';
    var sz = selectedSize();
    var giftPrefix = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of '
      : 'Your gift is a hand painted portrait of ';
    return character
      ? esc(giftPrefix) +
          '<span class="ffq-invite__claim-char" id="ffq-invite-character" contenteditable="true" role="textbox" spellcheck="false" aria-label="His character name, tap to edit" data-ph="your character">' +
            esc(cardCharacterValue()) +
          '</span>.'
      : esc(giftPrefix + 'you as the hero.');
  }
  function inviteCodeBox(rc) {
    var character = state.giftRoute !== 'portrait';
    var giftHTML = claimGiftHTML();
    /* v37.4 Jan: "Here is how to bring it to life." sits on its own line. */
    var bringLine = 'Here is how to bring it to life.';
    /* The three steps he follows. Static copy, so the URL can be bolded
       directly. Step 2 is route-aware (quest vs photo). */
    var step2 = character
      ? 'Take the character quest and download your blueprint.'
      : 'Send your best photo so I have your likeness.';
    /* v37.5 (Change 6) — step 3 rewrite. The old line never told him to
       send the blueprint; the flow was missing its handoff. The new line
       names the explicit action (check out, then send the blueprint) and
       keeps the timeline beat. Verbatim per the build prompt. */
    var steps = [
      'Go to <b class="ffq-invite__claim-url">FramedFantasy.com/Gift</b>.',
      step2,
      'Check out with your code, then send me your blueprint. About two weeks later you review your finished portrait.'
    ];
    var stepsHTML = '';
    for (var i = 0; i < steps.length; i++) {
      stepsHTML += '<li><span class="ffq-invite__claim-n">' + (i + 1) + '</span><span>' + steps[i] + '</span></li>';
    }
    /* v36.9 gold eyebrow on top, then the white subtext, then the steps. */
    return '<div class="ffq-invite__claim">' +
        '<p class="ffq-invite__claim-head">Claim your portrait</p>' +
        '<p class="ffq-invite__claim-gift">' + giftHTML + '</p>' +
        '<p class="ffq-invite__claim-bring">' + esc(bringLine) + '</p>' +
        '<ol class="ffq-invite__claim-steps">' + stepsHTML + '</ol>' +
      '</div>';
  }

  function invitePreviewInner() {
    var rc = routeCopy();
    /* v34.1 every line is edited in place on the card. Each shows her
       override if she typed one, otherwise the value built from her answers. */
    var greeting = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
    var summons = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : rc.summons;
    var signoff = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
    var msg = (state.cardMessage || '').replace(/^\s+|\s+$/g, '');
    /* The message is edited in place on the card. Newlines she types become
       <br> so the preview matches what she sees, and an empty field shows
       the placeholder via CSS so the contenteditable stays truly empty. */
    var msgInner = msg ? esc(msg).replace(/\n/g, '<br>') : '';
    var msgCls = 'ffq-invite__msg' + (msg ? '' : ' ffq-invite__msg--placeholder');
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    /* Art layer. An uploaded scene photo wins. Otherwise the hand-drawn
       SVG scene for this world fills the band, so picking a world
       changes the whole scene, not a color. */
    var artInner = artUrl
      ? '<div class="ffq-invite__photo" style="background-image:url(\'' + esc(artUrl) + '\');"></div>'
      : inviteSceneSVG(themeKey);
    var artCls = 'ffq-invite__art ffq-invite__art--' + esc(themeKey) + (artUrl ? ' ffq-invite__art--photo' : '');
    /* v36.3 no portrait image is drawn on the card anymore. The size only sets
       the code-box line and the variant the buy adds, so the card keeps its
       full scene band and stays a clean, fixed-height keepsake (the morph made
       it too tall and clipped the scene). The portrait lives on the wall, not
       on the card. */
    var cardCls = 'ffq-invite ffq-invite--' + esc(themeKey);
    /* v34.1 the card reads as a keepable object and every line is tappable
       to edit in place. The datestamp stays a fixed occasion label. */
    return '<div class="' + cardCls + '">' +
      '<div class="ffq-invite__frame">' +
        '<p class="ffq-invite__datestamp">' + esc(occasionStamp()) + '</p>' +
        '<div class="' + artCls + '">' + artInner + '</div>' +
        '<div class="ffq-invite__body">' +
          '<p class="ffq-invite__greeting" id="ffq-invite-greeting" contenteditable="true" role="textbox" spellcheck="false" aria-label="His greeting, tap to edit" data-ph="His greeting">' + esc(greeting) + '</p>' +
          '<p class="ffq-invite__summons" id="ffq-invite-summons" contenteditable="true" role="textbox" spellcheck="false" aria-label="A line under his name, tap to edit" data-ph="A line under his name">' + esc(summons) + '</p>' +
          '<p class="' + msgCls + '" id="ffq-invite-msg" contenteditable="true" role="textbox" aria-multiline="true" aria-label="Your message, tap to edit" spellcheck="false" data-ph="Tap to write your own message">' + msgInner + '</p>' +
          '<p class="ffq-invite__signoff" id="ffq-invite-signoff" contenteditable="true" role="textbox" spellcheck="false" aria-label="How you sign it, tap to edit" data-ph="How you sign it">' + esc(signoff) + '</p>' +
          inviteCodeBox(rc) +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* v37.8 two-sided flip card. ---------------------------------------------
     The portrait side shows a full-bleed character image for the selected
     size, with the character name in gold near the bottom. The image comes
     from the per-size sample-portrait settings (size1/2/3_image); until Jan
     uploads them, each size falls back to a distinct portfolio placeholder so
     the side is never empty. */
  /* v37.9 the example portrait per size (Jan-supplied art), each with the name of
     the character it shows. An uploaded per-size image in the editor still wins. */
  var SIZE_PORTRAIT = {
    half:  { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Cullen_Dragonborn_v2_HD.webp?v=1780790187', name: 'Drakkar' },
    thigh: { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/AustinKinderEdit6copy.jpg?v=1780778658', name: 'Anduin' },
    full:  { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/FramedFantasy_Hero_Full_Body.webp?v=1780055109', name: 'Ambessa' }
  };
  function sizePortraitUrl(sz) {
    if (sz && sz.image) return sz.image;
    var d = sz && SIZE_PORTRAIT[sz.key];
    if (d) return d.img;
    return GALLERY_DEFAULT.length ? GALLERY_DEFAULT[0] : '';
  }
  /* The name of the character shown in the example art for this size. */
  function sizePortraitName(sz) {
    var d = sz && SIZE_PORTRAIT[sz.key];
    return d ? d.name : '';
  }
  /* The size whose portrait the card shows. The selected size wins; before any
     pick we hold the first size so the image can preload and the face is ready. */
  function currentPortraitSize() {
    return selectedSize() || (SIZES.length ? SIZES[0] : null);
  }
  /* The gold name on the portrait. Her own character name wins (edit, then quiz
     value). With none, it shows the name of the character in the example art for
     the current size (Ember / Lily / Ambessa), so the sample reads as a finished,
     named card. Falls to empty (hidden) only if there is no example name. */
  function portraitDisplayName() {
    var edit = (state.cardCharacter && state.cardCharacter.trim());
    if (edit) return edit;
    var quiz = (state.characterName && state.characterName.trim());
    if (quiz) return quiz;
    return sizePortraitName(currentPortraitSize());
  }
  /* v38.10 the sample note names the size, e.g. "An example of a completed thigh up
     portrait", so it reads as a clear sample of exactly what he gets at that size.
     Tracks the selected size live. */
  function portraitSampleLabel() {
    var sz = currentPortraitSize();
    var nm = (sz && sz.name) ? sz.name.toLowerCase() : '';
    return nm ? 'An example of a completed ' + nm + ' portrait' : 'An example of a completed portrait';
  }
  /* The portrait face content. Image + scrim + a prominent size-aware sample banner
     at the top + the gold name at the bottom. */
  function invitePortraitInner() {
    var url = sizePortraitUrl(currentPortraitSize());
    var name = portraitDisplayName();
    return '<img class="ffq-portrait__img" id="ffq-portrait-img" src="' + esc(url) + '" alt="" decoding="async">' +
      '<div class="ffq-portrait__scrim" aria-hidden="true"></div>' +
      '<p class="ffq-portrait__label" id="ffq-portrait-label">' + esc(portraitSampleLabel()) + '</p>' +
      '<p class="ffq-portrait__name" id="ffq-portrait-name">' + esc(name) + '</p>';
  }
  /* The flip scaffold: message face (in flow, defines height) + portrait face
     (absolute over the same box). updateInvitePreview re-renders only the front
     face, so the flip wrapper and portrait face persist across edits/themes.
     v37.9.2 no flip icon: tapping any non-editable spot on the card flips it. */
  function invitePreviewShell() {
    /* v37.9.3 a tilt wrapper sits between the perspective container and the flip
       element. It carries the live mouse-follow tilt (a small rotateX/rotateY)
       so the card leans toward the cursor, while the inner keeps owning the flip
       (rotateY 180). Separate layers so the two transforms never fight. */
    return '<div class="ffq-flip" id="ffq-flip">' +
      '<div class="ffq-flip__tilt" id="ffq-flip-tilt">' +
        '<div class="ffq-flip__inner" id="ffq-flip-inner">' +
          '<div class="ffq-flip__face ffq-flip__face--message" id="ffq-flip-front" role="button" tabindex="0" aria-label="Tap the card to see the portrait side">' + invitePreviewInner() + '</div>' +
          '<div class="ffq-flip__face ffq-flip__face--portrait" id="ffq-portrait-face" role="button" tabindex="0" aria-label="Tap to flip back to the card">' + invitePortraitInner() + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* v34.1 the redemption explainer, now the body of the how-it-works
     lightbox. It tells her plainly what she just made him and the three
     steps to get it to him, ending at FramedFantasy.com/Gift. The code is
     typed straight onto the card, so there is no input here anymore. */
  function unlockBlockInner() {
    return '<p class="ffq-redeem__head">What you just made him</p>' +
      '<p class="ffq-redeem__lead">A hand painted portrait of the character he plays. Here is how it reaches him.</p>' +
      '<ol class="ffq-redeem__steps">' +
        '<li><span class="ffq-redeem__n">1</span><span>Finish his gift to lock in his portrait.</span></li>' +
        '<li><span class="ffq-redeem__n">2</span><span>Type the code you get onto his card, then download it and give it to him.</span></li>' +
        '<li><span class="ffq-redeem__n">3</span><span>He enters the code at FramedFantasy.com/Gift and I paint his character by hand.</span></li>' +
      '</ol>';
  }
  /* v34.1 the how-it-works lightbox. It auto-opens the first time she taps
     the code area on the card, and the small help button reopens it. The
     steps live here so the card stays clean and she still learns what the
     XXXX code is for. */
  function stepsLightboxHTML() {
    return '<div class="ffq-lightbox" id="ffq-steps-lightbox" hidden>' +
      '<div class="ffq-lightbox__backdrop" data-ffq-steps-close></div>' +
      '<div class="ffq-lightbox__panel" role="dialog" aria-modal="true" aria-label="How his code works">' +
        '<button type="button" class="ffq-lightbox__close" data-ffq-steps-close aria-label="Close">&times;</button>' +
        unlockBlockInner() +
      '</div>' +
    '</div>';
  }

  function builderHTML() {
    var rc = routeCopy();
    var giftUrl = (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
    /* v36.6 product-page reveal. Desktop reads like a real product page: the
       card is the "product image" on the LEFT (card on top, then the colour
       picker, then the download right under it), and it stays in view (sticky)
       while the buyer scrolls the buy column on the RIGHT. The right column is
       laid out like a product page: star reviews + a short headline above the
       size options, the buy button right under the options, and the longer
       detail (how it works for her + the For him / For you reasons) below it,
       so nothing long blocks the options. Reviews run full width below. On
       mobile it stacks into one intuitive flow. */
    return '<div class="ffq-builder ffq-builder--centered ffq-builder--product ffq-reveal-2p is-phase1">' +
      '<a class="ffq-wordmark ffq-result__wordmark" href="/" aria-label="FramedFantasy home">FRAMEDFANTASY</a>' +
      '<button type="button" class="ffq-builder__back" id="ffq-builder-back" aria-label="Back">&lsaquo; Back</button>' +
      '<h1 class="ffq-builder__head">' + esc('Customize your ' + (occasionLabel() ? occasionLabel() + ' ' : '') + 'card') + '</h1>' +
      '<p class="ffq-builder__sub">I made it from your answers. Every line is yours to change, so tap any field on the card to make it his, or leave it just as it is.</p>' +
      '<div class="ffq-reveal-split">' +
        '<div class="ffq-reveal-split__media">' +
          '<div class="ffq-builder__preview" id="ffq-invite-preview">' + invitePreviewShell() + '</div>' +
          themePickerHTML() +
          /* v38.4 phase 1 confirm. While building, this is the only button under the
             card + colours. Clicking it reveals the rest of the page (phase 2), where
             it is replaced by the Present / Download actions below. */
          '<div class="ffq-confirm" id="ffq-confirm-wrap">' +
            '<button type="button" class="ffq-confirm__btn" id="ffq-confirm-card">' +
              '<span class="ffq-confirm__label">Looks good</span>' +
              '<span class="ffq-confirm__arrow" aria-hidden="true">&rarr;</span>' +
            '</button>' +
          '</div>' +
          '<div class="ffq-builder__dl" id="ffq-builder-dl">' + downloadBlock() + '</div>' +
        '</div>' +
        '<div class="ffq-reveal-split__info">' +
          buyTopHTML() +
          reviewsCarouselHTML() +
          sizesSelectorHTML() +
          '<div class="ffq-builder__finish">' + finishInner(rc, giftUrl) + '</div>' +
          buyDetailHTML() +
        '</div>' +
      '</div>' +
      /* v37.7 the "Good to know" FAQ, full width, its own quiet section directly
         above the reviews. */
      faqHTML() +
      /* The Loox reviews widget, full width below the split. No-ops if the page
         has no Loox section to bring in. */
      '<div id="ffq-loox-mount" class="ffq-loox-mount" aria-label="Customer reviews"></div>' +
      /* v37.5 (Change 5) — sticky scroll nudge.
         Mirrors the .ff-stickybar mechanic from product.d-d-custom-sales:
           - Hidden until the buy area scrolls out of view
           - Slides up from the bottom (mobile) / sits along the bottom (desktop)
           - Click → smooth-scroll back to the SIZE PICKER (not the button),
             so she lands on the choice rather than being dropped at the
             top or having a size auto-selected for her.
           - Dismissible via the × button; sessionStorage flag keeps it
             gone for the rest of this visit (clears on tab close).
           - Mounted as a fixed-position element, kept inside the reveal
             container so it tears down cleanly if the quiz unmounts. */
      '<div class="ffq-stickynudge" id="ffq-stickynudge" aria-hidden="true" role="region" aria-label="Continue to gift">' +
        '<div class="ffq-stickynudge__inner">' +
          '<div class="ffq-stickynudge__text">' +
            '<span class="ffq-stickynudge__title">His card is ready.</span>' +
            '<span class="ffq-stickynudge__sub">His portrait is the gift he keeps.</span>' +
          '</div>' +
          '<button type="button" class="ffq-stickynudge__cta" id="ffq-stickynudge-cta">Give him his adventure</button>' +
          '<button type="button" class="ffq-stickynudge__dismiss" id="ffq-stickynudge-dismiss" aria-label="Dismiss">&times;</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  /* v36.6 the product-page top of the buy column: star reviews, a short
     benefit headline, and one subtitle line. Kept deliberately short so the
     size options sit high, not buried under copy. Route-aware. */
  function buyTopHTML() {
    /* v37.5 (Change 1) — title + subhead rewrite. Per Jan: the previous title
       led with a feature ("painted by hand") and never told her what the
       free card was vs. what the paid gift was. The new title names the
       portrait as the gift and keeps the card as the moment. Universal copy
       across both routes (character / portrait) per the build prompt.
       v37.10 the product title is now the emotional headline "He'll talk
       about this for years", with "years" in the same gold accent (.ffq-em)
       as the hero headline on the main screen. The subhead drops its old
       "for years" so the word is not repeated under the title. */
    var titleHTML = 'The gift he&#39;ll talk about for <span class="ffq-em">years</span>';
    var subhead = 'Not a portrait off a shelf. He opens it, and brings his own character to life.';
    return '<div class="ffq-buytop">' +
      '<div class="ffq-stars" role="img" aria-label="Rated 5.0 from over 500 five star reviews">' +
        '<span class="ffq-stars__row" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
        '<span class="ffq-stars__text">500+ five star reviews</span>' +
      '</div>' +
      '<h2 class="ffq-buytop__title">' + titleHTML + '</h2>' +
      '<p class="ffq-buytop__sub">' + esc(subhead) + '</p>' +
    '</div>';
  }
  /* v37.5 (Changes 2 + 3 + reorder) — under-button detail rewritten:
       1. The "For him" / "For you" columns are gone. They read like a spec
          sheet inside an emotional moment, and the labels sorted the value
          into buckets that did not need sorting.
       2. Four universal value lines replace them. Each is its own beat,
          short, and route-agnostic. The standalone "Almost everyone I
          paint for…" reassurance paragraph is removed — value-line #4
          already says the equivalent in fewer words, so keeping both was
          redundant.
       3. Order swap per Jan's UX note: reasons before process. The four
          value lines render before the "How it works for you" steps, so the
          buyer reads WHY this is worth her time before she scans her own
          to-do list.
       v37.7 (Change 2): this block is now the WHOLE under-button column, one
       cohesive flush left-aligned section. finishInner() owns only the CTA
       above it; the availability, reassurance, and proof lines lead this
       block, then the value lines, then How it works. */
  function buyDetailHTML() {
    var buyerSteps = [
      'Make his card yours and check out. I send his code to your email right away.',
      bookmarkStep(),
      occasionGiveStep()
    ];
    var stepHTML = '';
    for (var s = 0; s < buyerSteps.length; s++) {
      stepHTML += '<li><span class="ffq-buysteps__n">' + (s + 1) + '</span><span>' + presentLinkify(buyerSteps[s], 'ffq-present-link') + '</span></li>';
    }
    /* v37.7 (Change 2) four value lines. Verbatim copy per the build prompt.
       None of them promise a wall or a frame anymore, since the gift is the
       digital portrait. Same on every route, no labels, no header above them. */
    var valueLines = [
      'He has played this character for years. This is the first time he gets to see him, painted by hand.',
      'It is the part of him only you notice, made into a portrait that is his. Nothing off a shelf does that.',
      'The day he opens it, his character comes to life in front of him. That moment is the gift as much as the painting.',
      'He just answers a few quick questions. I take care of the rest by hand.'
    ];
    var valueHTML = '';
    for (var v = 0; v < valueLines.length; v++) {
      valueHTML += '<p class="ffq-value-lines__item">' + esc(valueLines[v]) + '</p>';
    }
    /* v37.7 (Change 2) everything under the buy button is one cohesive,
       flush, left-aligned column with tight even spacing, in this order:
       availability, reassurance, proof, the four value lines, then How it
       works. The availability line is the single honest act-now reason and
       gives the in-stock dots above it a meaning. The reassurance and proof
       lines moved here out of finishInner so nothing reads as a separate
       scrap. No divider, no indent, no loud scarcity styling. */
    /* v37.7 the availability + reassurance lines moved into the FAQ ("Good to
       know") below. The block opens straight on the proof line now. */
    /* v39.1 (Rebuild 1) the code pre frame line, approved by Jan. It sits
       first, directly under the CTA, and sets up what happens after checkout
       so the gift card code never jars her. */
    return '<div class="ffq-buydetail">' +
      '<p class="ffq-codeline">His code lands in your inbox the moment you check out. Hand it to him with the card and his portrait is already paid in full.</p>' +
      '<p class="ffq-reveal__microtrust">Over a thousand painted by hand since 2022. More than 500 five star reviews.</p>' +
      '<div class="ffq-value-lines">' + valueHTML + '</div>' +
      /* Her own three steps, kept intact. The numbered circle style is
         preserved so she still reads it as her checklist. */
      '<div class="ffq-buysteps">' +
        '<p class="ffq-buydetail__label">How it works for you</p>' +
        '<ol class="ffq-buysteps__list">' + stepHTML + '</ol>' +
      '</div>' +
    '</div>';
  }
  /* v37.7 the "Good to know" FAQ. A quiet accordion that sits full width above
     the reviews. Every row is collapsed on load; tapping a question opens its
     answer (smooth grid-rows expand) and tapping again closes it. Rows are
     independent so several can be open. Copy is verbatim (per Jan). */
  /* v38.1 FAQ copy rewrite (verbatim per Jan). New title, then six Q&A. */
  var FAQ_TITLE = 'What you\'re probably wondering';
  /* v38.21 each answer is an array of blocks: a string is a paragraph, an object
     { list: [...] } is a bullet list. The [Present his card](#present-card) marker
     inside any paragraph or bullet renders as an inline link that opens the same
     reveal as the Present his card button (see faqInline + bindFaq). */
  var FAQS = [
    /* v39 (Rebuild 5) the first answer cut to two short lines, verbatim per
       the rebuild brief. The reviews below carry the proof. */
    { q: 'What makes this different from a normal gift?', a: [
      'There is a part of him almost no one in his life has really seen. You have.',
      'Most gifts get a thank you and a drawer. This one shows him you saw the thing he loves.'
    ] },
    { q: 'Doesn\'t he already have a picture of his character?', a: [
      'Probably a placeholder. A lot of players keep a rough one, the way a quick sketch stands in for a real photo. You can tell who it is meant to be, but everything that makes him him is missing.',
      'This is the real one. I paint his details by hand from his own description until it is unmistakably his, and I keep going until he sees himself in it.',
      'Just below, players describe what it is like to finally see their character done right.'
    ] },
    { q: 'Does he have to do anything?', a: [
      'Normally a commission is a lot of back and forth before anything ever gets painted. After four years and more than a thousand of these, I have turned that part into something he will actually look forward to. He plays a short quest and describes his character in his own words. Most guys get into it without even realizing they are handing me everything I need.',
      { gold: 'You never have to know a thing about his character. That part is completely on him, not you.' },
      'Do not just take my word for it. Read the reviews below, then press [Present his card](#present-card) and run through the experience yourself.'
    ] },
    { q: 'What if he does not love it?', a: [
      'He will, because he is the one shaping it. He describes his own character and sees it before anything is final, so it is built around his picture of it, not mine. If anything is off, I keep revising until it is right.',
      'I play these games myself, so getting him right matters to me as much as it does to you. Out of more than a thousand portraits, fewer than five people have ever asked for their money back. Every order still carries that guarantee, so you are protected either way.'
    ] },
    { q: 'Will it be ready for Father\'s Day?', a: [
      'Yes, with room to spare. The card is ready the moment you check out, so you have something real to give him on the day no matter what. I am usually booked weeks out, and this gift skips that line.',
      'Here is exactly how it goes.',
      { list: [
        'You check out now and your code lands in your inbox within minutes.',
        'On Father\'s Day, you present his card and hand him the code.',
        'He plays his quest whenever he is ready.',
        'Around two weeks after he plays it, his finished portrait is ready for him.'
      ] }
    ] }
  ];
  /* escape a line, then turn the [Present his card](#present-card) marker into a
     real inline link (bound to openPresent in bindFaq). cls picks the look:
     ffq-faq__present is the underlined FAQ link, ffq-present-link is the subtle
     no-underline variant used inside the buyer steps. */
  function presentLinkify(text, cls) {
    return esc(text).replace(/\[Present his card\]\(#present-card\)/g,
      '<a class="' + (cls || 'ffq-faq__present') + '" href="#present-card" data-ffq-present>Present his card</a>');
  }
  function faqInline(text) { return presentLinkify(text, 'ffq-faq__present'); }
  function faqAnswerHTML(blocks) {
    var out = '';
    for (var b = 0; b < blocks.length; b++) {
      var blk = blocks[b];
      if (blk && blk.list) {
        var items = '';
        for (var k = 0; k < blk.list.length; k++) { items += '<li>' + faqInline(blk.list[k]) + '</li>'; }
        out += '<ul class="ffq-faq__bullets">' + items + '</ul>';
      } else if (blk && blk.gold) {
        out += '<p class="ffq-faq__a ffq-faq__a--gold">' + faqInline(blk.gold) + '</p>';
      } else {
        out += '<p class="ffq-faq__a">' + faqInline(blk) + '</p>';
      }
    }
    return out;
  }
  function faqHTML() {
    var rows = '';
    for (var i = 0; i < FAQS.length; i++) {
      var aid = 'ffq-faq-a-' + i, qid = 'ffq-faq-q-' + i;
      rows += '<div class="ffq-faq__item">' +
        '<button type="button" class="ffq-faq__q" id="' + qid + '" aria-expanded="false" aria-controls="' + aid + '">' +
          '<span class="ffq-faq__qtext">' + esc(FAQS[i].q) + '</span>' +
          '<span class="ffq-faq__chev" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
          '</span>' +
        '</button>' +
        '<div class="ffq-faq__panel" id="' + aid + '" role="region" aria-labelledby="' + qid + '">' +
          '<div class="ffq-faq__panel-inner">' + faqAnswerHTML(FAQS[i].a) + '</div>' +
        '</div>' +
      '</div>';
    }
    return '<section class="ffq-faq" aria-label="' + esc(FAQ_TITLE) + '">' +
      '<h2 class="ffq-faq__head">' + esc(FAQ_TITLE) + '</h2>' +
      '<div class="ffq-faq__list">' + rows + '</div>' +
    '</section>';
  }
  function bindFaq(root) {
    var qs = (root || document).querySelectorAll('.ffq-faq__q');
    Array.prototype.forEach.call(qs, function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentNode;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    /* v38.21 every inline "Present his card" link (FAQ + the buyer step) opens
       the same reveal as the Present his card button. Guard against double-binding
       since this can be called on the whole screen. */
    var links = (root || document).querySelectorAll('[data-ffq-present]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.__ffqPresentBound) return;
      a.__ffqPresentBound = true;
      a.addEventListener('click', function (e) { e.preventDefault(); openPresent(); });
    });
  }
  /* v34 the color theme picker. Clickable swatches under the card that
     re-skin the whole card live, palette and scene. The active one is the
     world-derived default until she picks another. */
  function themePickerHTML() {
    var cur = state.cardTheme || defaultThemeForHobby();
    var row = '';
    for (var i = 0; i < INVITE_ART_THEMES.length; i++) {
      var t = INVITE_ART_THEMES[i];
      var on = t.key === cur;
      row += '<button type="button" class="ffq-theme' + (on ? ' is-active' : '') + '" data-ffq-theme="' + esc(t.key) + '" aria-pressed="' + (on ? 'true' : 'false') + '" title="' + esc(t.label) + '">' +
        '<span class="ffq-theme__swatch" style="background:' + esc(t.swatch) + '" aria-hidden="true"></span>' +
        '<span class="ffq-theme__name">' + esc(t.label) + '</span>' +
      '</button>';
    }
    return '<div class="ffq-themes" id="ffq-themes" role="group" aria-label="Card theme">' +
      '<p class="ffq-themes__label">Pick his theme</p>' +
      '<div class="ffq-themes__row">' + row + '</div>' +
      '<p class="ffq-themes__hint">Each theme has its own reveal animation.</p>' +
    '</div>';
  }

  /* v27.1 the download lives directly under the card preview so she sees
     straight away that she can download what she is building. Quiet
     outline secondary while she is still building (the buy is the hero
     below), then the gold primary once she pastes his code and it becomes
     the finished, code-bearing card. The note names plainly what the
     download contains so the free version never reads as the finished
     gift on its own. */
  /* v36.3 a clear download glyph (a tray with a downward arrow) instead of the
     bare arrow, so the action reads at a glance. Inherits the gold via
     currentColor on the glyph span. */
  function dlGlyph() {
    return '<span class="ffq-dl__glyph" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 3v11"/><path d="M7.5 10l4.5 4.5 4.5-4.5"/><path d="M5 20.5h14"/>' +
      '</svg>' +
    '</span>';
  }
  /* v37.10 a play glyph for the "Present his card" button (launches the reveal). */
  function playGlyph() {
    return '<span class="ffq-dl__glyph" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none"><path d="M7 4.5v15l13-7.5z"/></svg>' +
    '</span>';
  }
  function downloadBlock() {
    /* v36.6 the download lives right under the card and downloads immediately on
       click. No email prompt anymore (per Jan) so the card is one tap away and
       nothing sits between her and the buy. The card is her free Father's Day
       card, complete from her answers, so it never waits on a size pick. */
    var dlLabel = 'Download his card';
    /* v37.10 two actions side by side: Present (launches the in-page reveal
       experience) on the left, Download (immediate PNG) on the right. */
    return '<div class="ffq-cardactions">' +
        '<button type="button" class="ffq-dl__icon" id="ffq-invite-present" aria-label="Present his card">' +
          playGlyph() + ' Present his card' +
        '</button>' +
        '<button type="button" class="ffq-dl__icon" id="ffq-invite-download" aria-label="' + esc(dlLabel) + '">' +
          dlGlyph() + ' ' + dlLabel +
        '</button>' +
      '</div>';
  }
  /* v36.6 bind the download. One subtle icon that downloads the PNG straight
     away. Called after the builder paints and after the block re-renders. */
  function bindDownload() {
    var dl = document.getElementById('ffq-invite-download');
    if (dl) dl.addEventListener('click', downloadInvitation);
    var pr = document.getElementById('ffq-invite-present');
    if (pr) pr.addEventListener('click', openPresent);
  }

  /* v39 (Rebuild 4) one light, dismissible prompt that leads her into the
     reveal once, right after she confirms the card and the buy column
     appears. It sits inline under the card actions, never a wall. The ×
     dismisses it, opening the reveal any other way also retires it, and the
     persisted presentPromptSeen flag keeps it to a single appearance. The
     line is the sentence Jan already shipped in the old first FAQ answer,
     reused here so the reveal keeps its strongest invitation. Flagged for
     copy approval. */
  function dismissPresentPrompt() {
    var p = document.getElementById('ffq-present-prompt');
    if (p && p.parentNode) p.parentNode.removeChild(p);
    if (!state.presentPromptSeen) { state.presentPromptSeen = true; save(); }
  }
  function showPresentPrompt() {
    if (state.presentPromptSeen) return;
    if (document.getElementById('ffq-present-prompt')) return;
    var dl = document.getElementById('ffq-builder-dl');
    if (!dl || !dl.parentNode) return;
    var p = document.createElement('div');
    p.className = 'ffq-presentprompt';
    p.id = 'ffq-present-prompt';
    p.setAttribute('role', 'note');
    p.innerHTML =
      '<button type="button" class="ffq-presentprompt__close" id="ffq-present-prompt-close" aria-label="Dismiss">&times;</button>' +
      '<p class="ffq-presentprompt__line">Press Present his card now and you will feel exactly what he will.</p>' +
      '<button type="button" class="ffq-presentprompt__cta" id="ffq-present-prompt-cta">' + playGlyph() + ' Present his card</button>';
    dl.parentNode.insertBefore(p, dl.nextSibling);
    var close = document.getElementById('ffq-present-prompt-close');
    if (close) close.addEventListener('click', dismissPresentPrompt);
    var cta = document.getElementById('ffq-present-prompt-cta');
    if (cta) cta.addEventListener('click', function () { dismissPresentPrompt(); openPresent(); });
  }

  /* ============================================================
     v37.10 PRESENT — the in-page unboxing reveal experience.
     Launchable any time from "Present his card". It dims the page, centres a
     sealed envelope, the buyer taps it three times (a heart floats up each
     tap), it bursts open, the card rises out and writes itself, and the claim
     ends on one tap-through CTA. Re-openable + resettable so they can rehearse
     the reveal for the day. Built on demand, torn down on close. */
  /* v38.26 the three charge-up hint lines under the envelope: resting, after tap 1,
     after tap 2. Father's Day themed instead of the old generic "Keep going". */
  var PRESENT_HINTS = { open: 'Open your gift', tap1: 'Keep going', tap2: 'Almost yours' };
  var presentState = { taps: 0, busy: false, timers: [], scrollY: 0 };
  function presentClearTimers() {
    for (var i = 0; i < presentState.timers.length; i++) { clearTimeout(presentState.timers[i]); }
    presentState.timers = [];
  }
  function presentT(fn, ms) { var id = setTimeout(fn, ms); presentState.timers.push(id); return id; }
  /* v38.18 the portrait (sample) side of the PRESENT card. Same image + size-aware
     sample label + gold name as the live card, but ID-free so it can coexist with
     the builder card behind the overlay (the present card is a static snapshot). */
  function presentPortraitInner() {
    var url = sizePortraitUrl(currentPortraitSize());
    return '<img class="ffq-portrait__img" src="' + esc(url) + '" alt="" decoding="async">' +
      '<div class="ffq-portrait__scrim" aria-hidden="true"></div>' +
      '<p class="ffq-portrait__label">' + esc(portraitSampleLabel()) + '</p>' +
      '<p class="ffq-portrait__name">' + esc(portraitDisplayName()) + '</p>';
  }
  /* The read-only card for the reveal: same look as the live card (theme, art,
     lines) but not editable, and flippable to the portrait sample side just like
     the live card. The claim ends on a single step-one CTA to /gift. */
  function presentCardInner() {
    var character = state.giftRoute !== 'portrait';
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    var artInner = artUrl
      ? '<div class="ffq-invite__photo" style="background-image:url(\'' + esc(artUrl) + '\');"></div>'
      : inviteSceneSVG(themeKey);
    var artCls = 'ffq-invite__art ffq-invite__art--' + esc(themeKey) + (artUrl ? ' ffq-invite__art--photo' : '');
    var greeting = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
    var summons = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : routeCopy().summons;
    var signoff = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
    var msg = (state.cardMessage || '').replace(/^\s+|\s+$/g, '');
    var sz = selectedSize();
    var subject = character ? cardCharacterValue() : 'you as the hero';
    var giftLine = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of ' + subject + '.'
      : 'Your gift is a hand painted portrait of ' + subject + '.';
    /* one tap-through step (per Jan), links to /gift */
    var claim = '<div class="ffq-invite__claim ffq-present__claim">' +
        '<p class="ffq-invite__claim-head">Claim your portrait</p>' +
        '<p class="ffq-invite__claim-gift">' + esc(giftLine) + '</p>' +
        '<a class="ffq-present__cta" id="ffq-present-cta" href="/gift" target="_blank" rel="noopener">Get started <span class="ffq-present__cta-arrow" aria-hidden="true">&rarr;</span></a>' +
      '</div>';
    return '<div class="ffq-flip ffq-present__flip" id="ffq-present-flip">' +
      '<div class="ffq-flip__tilt" id="ffq-present-tilt">' +
      '<div class="ffq-flip__inner">' +
        '<div class="ffq-flip__face ffq-flip__face--message">' +
          '<div class="ffq-invite ffq-invite--' + esc(themeKey) + '">' +
            '<div class="ffq-invite__frame">' +
              '<p class="ffq-invite__datestamp">' + esc(occasionStamp()) + '</p>' +
              '<div class="' + artCls + '">' + artInner + '</div>' +
              '<div class="ffq-invite__body">' +
                '<p class="ffq-invite__greeting ffq-present__rise ffq-present__rise--hero">' + esc(greeting) + '</p>' +
                '<p class="ffq-invite__summons ffq-present__rise">' + esc(summons) + '</p>' +
                '<p class="ffq-invite__msg ffq-present__rise">' + esc(msg) + '</p>' +
                '<p class="ffq-invite__signoff ffq-present__rise">' + esc(signoff) + '</p>' +
                '<div class="ffq-present__rise">' + claim + '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="ffq-flip__face ffq-flip__face--portrait">' + presentPortraitInner() + '</div>' +
      '</div>' +
      '</div>' +
    '</div>';
  }
  function presentHTML() {
    return '<div class="ffq-present" id="ffq-present" role="dialog" aria-modal="true" aria-label="Your card reveal">' +
      '<button type="button" class="ffq-present__close" id="ffq-present-close" aria-label="Close the reveal">&times;</button>' +
      '<div class="ffq-present__stage" id="ffq-present-stage">' +
        '<div class="ffq-present__env" id="ffq-present-env" role="button" tabindex="0" aria-label="Tap to open the card">' +
          '<div class="ffq-env__pocket" aria-hidden="true"></div>' +
          '<div class="ffq-env__tri" aria-hidden="true"></div>' +
          '<div class="ffq-env__flap" aria-hidden="true"></div>' +
          '<div class="ffq-env__seal" aria-hidden="true">' + presentSealSVG() + '</div>' +
          '<p class="ffq-present__hint" id="ffq-present-hint">' + esc(PRESENT_HINTS.open) + '</p>' +
        '</div>' +
        '<div class="ffq-present__card" id="ffq-present-card" aria-hidden="true">' + presentCardInner() + '</div>' +
      '</div>' +
      '<button type="button" class="ffq-present__replay" id="ffq-present-replay" hidden>Play again</button>' +
    '</div>';
  }
  function heartSVG() {
    /* v38.11 a clean heart, perfectly symmetric about the centre (x=12): every
       control point on the right mirrors the left, so both lobes match. */
    return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" stroke="none"><path d="M12 20.7 C12 20.7 2.4 13.9 2.4 7.8 C2.4 4.9 4.7 2.9 7.2 2.9 C9.2 2.9 10.9 4.1 12 5.9 C13.1 4.1 14.8 2.9 16.8 2.9 C19.3 2.9 21.6 4.9 21.6 7.8 C21.6 13.9 12 20.7 12 20.7 Z"/></svg>';
  }
  /* v38.28 per-theme reveal FX. Each card theme gets its own envelope seal emblem
     and its own burst particle, in colours pulled from that theme, so the reveal
     feels specific to the world he plays in. Love keeps the brand hearts. Minimal,
     clean shapes (single path, 24x24, currentColor) so they glow like the seal. */
  function flameSVG()       { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 22 C5 18 8 9 12 3 C16 9 19 18 12 22 Z"/></svg>'; }
  function candleFlameSVG() { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 3 C12 3 6 9 6 14 a6 6 0 0 0 12 0 C18 9 12 3 12 3 Z"/></svg>'; }
  function starSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 1 C12.5 8 16 11.5 23 12 C16 12.5 12.5 16 12 23 C11.5 16 8 12.5 1 12 C8 11.5 11.5 8 12 1 Z"/></svg>'; }
  function leafSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 2 C6 8 6 16 12 22 C18 16 18 8 12 2 Z"/></svg>'; }
  function gemSVG()         { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 2 L21 10 L12 22 L3 10 Z"/></svg>'; }
  function sparkSVG()       { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 1 L13.4 12 L12 23 L10.6 12 Z"/></svg>'; }
  function moteSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><circle cx="12" cy="12" r="6"/></svg>'; }
  /* Love still cycles the two FramedFantasy brand tones plus a soft tint of each. */
  var PRESENT_HEART_COLORS = ['#e99df6', '#bbede8', '#f3c2f9', '#d4f4f0', '#e99df6', '#bbede8'];
  /* seal = the emblem on the envelope (kept brand gold, only the shape is themed).
     particle = the shape that bursts/drifts, in the theme's own colours.
     spin = how far each particle tumbles. v38.30 no gravity: every effect radiates
     OUTWARD evenly, as if the card is emitting it, never falling. */
  var PRESENT_THEME_FX = {
    love:   { seal: heartSVG,       particle: heartSVG, colors: PRESENT_HEART_COLORS,                         spin: 55 },
    tavern: { seal: candleFlameSVG, particle: moteSVG,  colors: ['#e8c674', '#c9a84c', '#fff3d6', '#f0d9a0'], spin: 35 },
    arcane: { seal: starSVG,        particle: starSVG,  colors: ['#b9a6f0', '#d4c2ff', '#e8c674', '#9f86e0'], spin: 90 },
    wilds:  { seal: leafSVG,        particle: leafSVG,  colors: ['#7fc99a', '#a8e0bd', '#c9a84c', '#5fae7d'], spin: 150 },
    hall:   { seal: gemSVG,         particle: gemSVG,   colors: ['#8fb0f0', '#c2d4ff', '#e8c674', '#6f93e0'], spin: 60 },
    ember:  { seal: flameSVG,       particle: sparkSVG, colors: ['#f0a25a', '#ff8c42', '#e8c674', '#ff6b35'], spin: 45 }
  };
  function currentPresentTheme() { return state.cardTheme || defaultThemeForHobby(); }
  function presentSealSVG() {
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    return fx.seal();
  }
  function presentRand(min, max) { return min + Math.random() * (max - min); }
  function spawnParticle(layer, cx, cy, dx, dy, scale, rot, dur, color, svg, extraClass) {
    if (!layer) return;
    var h = document.createElement('span');
    h.className = 'ffq-present__heart' + (extraClass ? ' ' + extraClass : '');
    h.style.left = cx + 'px';
    h.style.top = cy + 'px';
    h.style.color = color;
    h.style.setProperty('--ffq-dx', dx + 'px');
    h.style.setProperty('--ffq-dy', dy + 'px');
    h.style.setProperty('--ffq-sc', scale);
    h.style.setProperty('--ffq-rot', rot + 'deg');
    h.style.setProperty('--ffq-dur', dur + 'ms');
    h.innerHTML = svg || heartSVG();
    layer.appendChild(h);
    h.addEventListener('animationend', function () { if (h.parentNode) h.parentNode.removeChild(h); });
    /* safety removal if animationend never fires */
    presentT(function () { if (h.parentNode) h.parentNode.removeChild(h); }, dur + 400);
  }
  /* Fire `count` themed particles radially outward from (cx,cy). power (default 1)
     scales how far they fly, so each tap throws them further than the last. v38.30
     no gravity: a clean even radial burst, the same in every theme. Used by the
     envelope taps and the reveal (which emit from the envelope point). */
  function burstParticles(layer, cx, cy, count, power, themeKey) {
    if (!layer) return;
    count = count || 14;
    power = power || 1;
    var fx = PRESENT_THEME_FX[themeKey] || PRESENT_THEME_FX.love;
    var svg = fx.particle();
    for (var i = 0; i < count; i++) {
      var ang = (Math.PI * 2 * i) / count + presentRand(-0.35, 0.35);
      var dist = presentRand(70, 165) * power;
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist;
      var scale = presentRand(0.55, 1.45);
      var rot = presentRand(-fx.spin, fx.spin);
      var dur = presentRand(820, 1320);
      spawnParticle(layer, cx, cy, dx, dy, scale, rot, dur, fx.colors[i % fx.colors.length], svg);
    }
  }
  /* v38.30 the card-emission effects. Particles are born on the card PERIMETER and
     travel OUTWARD (away from the card centre), so it reads as the card emitting
     them, never as gravity pulling them down. Shared by the present card and the
     builder card so every theme behaves the same clean way. */
  function emitFromCardOnce(layer, lr, r, fx, o) {
    if (!r.width || !r.height) return;
    var ccx = r.left + r.width / 2, ccy = r.top + r.height / 2;
    var side = Math.floor(presentRand(0, 4));
    var px, py;
    if (side === 0) { px = presentRand(r.left, r.right); py = r.top; }
    else if (side === 1) { px = r.right; py = presentRand(r.top, r.bottom); }
    else if (side === 2) { px = presentRand(r.left, r.right); py = r.bottom; }
    else { px = r.left; py = presentRand(r.top, r.bottom); }
    var vx = px - ccx, vy = py - ccy, m = Math.sqrt(vx * vx + vy * vy) || 1;
    vx /= m; vy /= m;
    var dist = presentRand(o.distMin, o.distMax);
    var dx = vx * dist + presentRand(-12, 12);
    var dy = vy * dist + presentRand(-12, 12);
    var scale = presentRand(o.scaleMin, o.scaleMax);
    var rot = presentRand(-fx.spin, fx.spin) * 0.5;
    var dur = presentRand(o.durMin, o.durMax);
    spawnParticle(layer, px - lr.left, py - lr.top, dx, dy, scale, rot, dur, fx.colors[Math.floor(presentRand(0, fx.colors.length))], fx.particle(), o.cls);
  }
  function emitFromCard(layer, cardEl, fx, o, count) {
    if (!layer || !cardEl) return;
    var lr = layer.getBoundingClientRect();
    var r = cardEl.getBoundingClientRect();
    count = count || 1;
    for (var i = 0; i < count; i++) { emitFromCardOnce(layer, lr, r, fx, o); }
  }
  /* the resting halo (now livelier, more present) and the tap spurt (a quick burst) */
  var FX_AMBIENT = { distMin: 34, distMax: 108, scaleMin: 0.6, scaleMax: 1.18, durMin: 1500, durMax: 2400, cls: 'ffq-present__heart--ambient' };
  var FX_SPURT   = { distMin: 72, distMax: 152, scaleMin: 0.55, scaleMax: 1.2, durMin: 700, durMax: 1160, cls: '' };
  function presentAmbientTick() {
    var node = document.getElementById('ffq-present');
    var card = document.getElementById('ffq-present-card');
    /* stop quietly once the overlay closes or the card is no longer revealed */
    if (!node || !card || !card.classList.contains('is-revealed')) return;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    emitFromCard(node, card, fx, FX_AMBIENT, 2 + (Math.random() < 0.5 ? 1 : 0));
    presentT(presentAmbientTick, presentRand(280, 520));
  }
  /* v38.33 a tap fires a satisfying spray of the theme's particles OUT of the card
     edges. The card itself does not move, it is just the burst that pulses out. */
  function presentCardSpurt() {
    var node = document.getElementById('ffq-present');
    var card = document.getElementById('ffq-present-card');
    if (!node || !card) return;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    emitFromCard(node, card, fx, FX_SPURT, 16);
  }
  /* v38.30 the builder preview card carries the same ambient halo while she builds.
     The preview re-renders on a theme switch (innerHTML is replaced), so the FX layer
     self-heals: each tick re-creates it if it was wiped. */
  var builderFxRunning = false;
  function ensureBuilderFxLayer() {
    var pv = document.getElementById('ffq-invite-preview');
    if (!pv) return null;
    if (pv.style.position !== 'relative') pv.style.position = 'relative';
    var layer = pv.querySelector('#ffq-builder-fx');
    if (!layer) {
      layer = document.createElement('div');
      layer.id = 'ffq-builder-fx';
      layer.className = 'ffq-card-fx';
      layer.setAttribute('aria-hidden', 'true');
      pv.insertBefore(layer, pv.firstChild);
    }
    return layer;
  }
  function builderAmbientTick() {
    if (state.view !== 'builder') { builderFxRunning = false; return; }
    var pv = document.getElementById('ffq-invite-preview');
    if (!pv || !document.body.contains(pv)) { builderFxRunning = false; return; }
    var layer = ensureBuilderFxLayer();
    var card = pv.querySelector('.ffq-invite') || pv;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    if (layer && card) emitFromCard(layer, card, fx, FX_AMBIENT, 1 + (Math.random() < 0.6 ? 1 : 0));
    setTimeout(builderAmbientTick, presentRand(420, 760));
  }
  function startBuilderFx() {
    if (builderFxRunning) return;
    builderFxRunning = true;
    setTimeout(builderAmbientTick, 450);
  }
  function presentReveal() {
    var card = document.getElementById('ffq-present-card');
    var env = document.getElementById('ffq-present-env');
    var replay = document.getElementById('ffq-present-replay');
    /* clear the swollen-seal inline transform so the .is-open rule can shrink it
       away as the envelope bursts open */
    var seal = env ? env.querySelector('.ffq-env__seal') : null;
    if (seal) { seal.style.animation = 'none'; seal.style.transform = ''; }
    if (env) env.classList.add('is-open');
    /* a big brand-coloured explosion from the envelope centre */
    var layer = document.getElementById('ffq-present');
    if (layer && env) {
      var r = env.getBoundingClientRect();
      var lr = layer.getBoundingClientRect();
      burstParticles(layer, r.left - lr.left + r.width / 2, r.top - lr.top + r.height / 2, 30, 1, currentPresentTheme());
    }
    /* fade the envelope away, raise the card with a glow flash */
    presentT(function () { if (env) env.classList.add('is-gone'); }, 220);
    presentT(function () {
      if (card) { card.setAttribute('aria-hidden', 'false'); card.classList.add('is-revealed'); }
    }, 380);
    /* once the card is up, cascade the lines in (no typewriter) */
    presentT(function () {
      var lines = card ? card.querySelectorAll('.ffq-present__rise') : [];
      for (var i = 0; i < lines.length; i++) {
        (function (el, d) { presentT(function () { el.classList.add('is-in'); }, d); })(lines[i], i * 170);
      }
      if (replay) { replay.hidden = false; presentT(function () { replay.classList.add('is-in'); }, lines.length * 170 + 220); }
    }, 820);
    /* once the reveal burst has cleared, start the soft ambient field around the card */
    presentT(presentAmbientTick, 1300);
  }
  function presentReset() {
    presentClearTimers();
    presentState.taps = 0;
    presentState.busy = false;
    var env = document.getElementById('ffq-present-env');
    var card = document.getElementById('ffq-present-card');
    var hint = document.getElementById('ffq-present-hint');
    var replay = document.getElementById('ffq-present-replay');
    var stage = document.getElementById('ffq-present-stage');
    if (card) {
      card.classList.remove('is-revealed');
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML = presentCardInner(); /* fresh empty type targets */
      bindPresentTilt(); /* rebind the lean to the freshly built card */
    }
    if (env) {
      env.classList.remove('is-open', 'is-gone');
      var rseal = env.querySelector('.ffq-env__seal');
      if (rseal) { rseal.style.animation = ''; rseal.style.transform = ''; }
    }
    if (hint) hint.textContent = 'Tap to open';
    if (replay) { replay.hidden = true; replay.classList.remove('is-in'); }
    var layer = document.getElementById('ffq-present');
    if (layer) {
      var hs = layer.querySelectorAll('.ffq-present__heart');
      for (var i = 0; i < hs.length; i++) { if (hs[i].parentNode) hs[i].parentNode.removeChild(hs[i]); }
    }
  }
  /* v38.11 three-tap "charge, then burst". Tap 1 throws ~30% of the final burst,
     tap 2 ~50%, and the heart swells a little more each time so it looks about to
     pop. Tap 3 is the full explosion + the card reveal. */
  function presentTap() {
    if (presentState.busy) return;
    presentState.taps++;
    var env = document.getElementById('ffq-present-env');
    var hint = document.getElementById('ffq-present-hint');
    var layer = document.getElementById('ffq-present');
    var seal = env ? env.querySelector('.ffq-env__seal') : null;
    if (env) { env.classList.remove('is-nudge'); void env.offsetWidth; env.classList.add('is-nudge'); }
    if (presentState.taps >= 3) {
      presentState.busy = true;
      if (hint) hint.textContent = '';
      presentReveal();
      return;
    }
    /* escalating burst: tap 1 is small + close (~9 hearts, ~half distance), tap 2 is
       bigger + shoots out further (~15 hearts, ~80% distance). Tap 3 (reveal) is full. */
    if (layer && env) {
      var r = env.getBoundingClientRect();
      var lr = layer.getBoundingClientRect();
      var cx = r.left - lr.left + r.width / 2, cy = r.top - lr.top + r.height * 0.4;
      var tk = currentPresentTheme();
      if (presentState.taps === 1) { burstParticles(layer, cx, cy, 9, 0.5, tk); }
      else { burstParticles(layer, cx, cy, 15, 0.8, tk); }
    }
    /* the heart grows a touch more each tap (overrides the resting wiggle), so it
       reads as charging up to burst */
    if (seal) {
      seal.style.animation = 'none';
      seal.style.transform = 'translate(-50%, -50%) scale(' + (presentState.taps === 1 ? 1.16 : 1.32) + ')';
    }
    if (hint) hint.textContent = presentState.taps === 1 ? PRESENT_HINTS.tap1 : PRESENT_HINTS.tap2;
  }
  function openPresent() {
    if (document.getElementById('ffq-present')) return;
    /* v39 (Rebuild 4) opening the reveal by any path retires the one-time
       prompt so it never asks for something she already did. */
    dismissPresentPrompt();
    /* Append to #ffq-root, NOT the screen: the screen carries an identity
       transform, which would make this position:fixed overlay size to that tall
       element instead of the viewport. #ffq-root has the CSS vars + no transform,
       so the overlay centres on the real viewport. */
    var root = document.getElementById('ffq-root') || screenEl();
    if (!root) return;
    presentClearTimers();
    presentState.taps = 0; presentState.busy = false;
    var wrap = document.createElement('div');
    wrap.innerHTML = presentHTML();
    var node = wrap.firstChild;
    root.appendChild(node);
    /* v38.21 lock background scroll while the experience is open, remembering the
       current scroll position so we can restore it exactly on close. Pinning the
       body with position:fixed holds the page still on mobile (overflow:hidden
       alone does not on iOS). */
    try {
      presentState.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + presentState.scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } catch (e) {}
    /* fade in on the next frame */
    requestAnimationFrame(function () { node.classList.add('is-visible'); });
    var env = document.getElementById('ffq-present-env');
    if (env) {
      env.addEventListener('click', presentTap);
      env.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); presentTap(); } });
    }
    var close = document.getElementById('ffq-present-close');
    if (close) close.addEventListener('click', closePresent);
    var replay = document.getElementById('ffq-present-replay');
    if (replay) replay.addEventListener('click', presentReset);
    /* v38.29 the revealed card no longer flips. Tapping anywhere in the claim box
       (the whole gold "Claim your portrait" panel) opens the gift, the same as the
       Get started link, and stops any media first. Tapping the card anywhere else
       pulses a small spurt of the theme's particles. */
    var pcard = document.getElementById('ffq-present-card');
    if (pcard) {
      pcard.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.ffq-present__claim')) {
          stopAllMedia();
          /* if they tapped the link itself, let the browser open it; otherwise
             open it for them (the whole box is the target). */
          if (!(t.closest('.ffq-present__cta'))) {
            var cta = document.getElementById('ffq-present-cta');
            if (cta) { try { window.open(cta.href, '_blank', 'noopener'); } catch (err) {} }
          }
          return;
        }
        presentCardSpurt();
      });
    }
    /* v38.31 the present card leans toward the cursor, same subtle tilt as the builder card */
    bindPresentTilt();
    node.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePresent(); });
    /* v38.26 only the X closes the reveal. Tapping anywhere else (including the dim
       backdrop) keeps the experience going. The envelope/card/replay have their own
       handlers; the card handler above owns the claim box + the card spurt. */
    node.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.ffq-present__card, .ffq-present__env, .ffq-present__close, .ffq-present__replay')) return;
      /* backdrop or any other empty area advances the reveal instead of closing it */
      presentTap();
    });
    if (close) close.focus();
    try { fbTrack('present_open', { content_name: 'Fathers Day Quiz 2026' }); } catch (e) {}
  }
  function closePresent() {
    presentClearTimers();
    var node = document.getElementById('ffq-present');
    /* v38.21 unlock scroll and restore the exact position we were at on open. */
    try {
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      var y = presentState.scrollY || 0;
      window.scrollTo(0, y);
    } catch (e) {}
    if (!node) return;
    node.classList.remove('is-visible');
    setTimeout(function () { if (node.parentNode) node.parentNode.removeChild(node); }, 360);
  }
  /* v38.20 stop every video/audio in this tab. Called when "Get started" opens
     /gift in a new tab, so any media (now or added later) does not keep playing
     here in the background. */
  function stopAllMedia() {
    try {
      var m = document.querySelectorAll('video, audio');
      for (var i = 0; i < m.length; i++) {
        try { m[i].pause(); if (m[i].tagName === 'AUDIO') { m[i].currentTime = 0; } m[i].autoplay = false; m[i].loop = false; } catch (e) {}
      }
    } catch (e) {}
  }

  /* v28 layer-three reveal. The product is held back from the hero and
     the questions so the curiosity gap stays open. Here, after she is
     invested, it is finally stated plainly and in her terms. Route-aware
     because the character path has a quest and the portrait path takes a
     photo. */
  /* v33 the painting framed as the upgrade of the card she just made,
       an experience and a keepsake. The picture line lands the moment. */
  /* v36.1 the value-stack (For him / For you bullets, reservation, picture) was
     replaced by the short buyExplainHTML above the pricing. */
  /* v36.1 the portrait size she picked. Nothing is selected by default, so
     the card stays in its base state until she taps a size, which completes
     it (adds the portrait) and reveals the download. */
  function selectedSize() {
    if (!state.sizeKey) return null;
    for (var i = 0; i < SIZES.length; i++) { if (SIZES[i].key === state.sizeKey) return SIZES[i]; }
    return null;
  }
  /* v36 the product-style size picker on the reveal, just above the button.
     Name + descriptor + price per row, the popular one badged, tap to select.
     Selecting updates the card size line and the variant the buy adds. */
  /* v36.7 scarcity per size, modeled on the d-d-custom-sales pulsing dot. Each
     size reads "In stock" with a small pulsing dot whose colour comes from the
     slots-left number (editor-set per size): green at 21+, amber at 10 to 20,
     red under 10, and a still "Sold out" at 0. */
  function sizeStock(sz) {
    var qty = parseInt(sz && sz.qty, 10);
    if (isNaN(qty)) qty = 22;
    if (qty <= 0) return { cls: 'sold', label: 'Sold out', sold: true };
    if (qty < 10) return { cls: 'out', label: 'In stock', sold: false };
    if (qty < 21) return { cls: 'low', label: 'In stock', sold: false };
    return { cls: 'in', label: 'In stock', sold: false };
  }
  function sizesSelectorHTML() {
    if (!SIZES.length) return '';
    var cur = selectedSize();
    var rows = '';
    for (var i = 0; i < SIZES.length; i++) {
      var sz = SIZES[i];
      var on = cur && sz.key === cur.key;
      var st = sizeStock(sz);
      rows += '<button type="button" class="ffq-size' + (on ? ' is-selected' : '') + (st.sold ? ' ffq-size--sold' : '') + '" data-ffq-size="' + esc(sz.key) + '"' + (st.sold ? ' data-sold="1" aria-disabled="true"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="ffq-size__check" aria-hidden="true"></span>' +
        '<span class="ffq-size__main">' +
          '<span class="ffq-size__name">' + esc(sz.name) + (sz.popular ? '<span class="ffq-size__badge">Most popular</span>' : '') + '</span>' +
          (sz.desc ? '<span class="ffq-size__desc">' + esc(sz.desc) + '</span>' : '') +
        '</span>' +
        '<span class="ffq-size__right">' +
          '<span class="ffq-size__price">' + esc(sz.price) + '</span>' +
          '<span class="ffq-stock ffq-stock--' + st.cls + '"><span class="ffq-stockdot" aria-hidden="true"></span>' + esc(st.label) + '</span>' +
        '</span>' +
      '</button>';
    }
    return '<div class="ffq-sizes" id="ffq-sizes" role="radiogroup" aria-label="Portrait size">' +
      '<p class="ffq-sizes__label">Choose his size</p>' +
      rows +
    '</div>';
  }

  /* v36.8 the review carousel: a left-aligned, auto-scrolling loop of square
     customer review photos between the headline and the size picker. ~5 show at
     a time; the loop holds up to 15. Each photo is a link to its Loox review, so
     tapping it opens Loox's own review lightbox (same as clicking a review in the
     grid). The track is the items tripled, driven by the shared marquee runtime
     (data-ffq-marquee) so mountMarquees animates + makes it draggable. */
  function reviewsCarouselHTML() {
    var reviews = reviewsList();
    if (!reviews.length) return '';
    var items = '';
    for (var i = 0; i < reviews.length; i++) {
      var r = reviews[i];
      /* Eager (not lazy) so the looping carousel never pops a blank thumb in as
         it scrolls. Only the unique URLs download; the tripled copies are cached. */
      var img = '<img src="' + esc(r.img) + '" alt="A FramedFantasy review photo" decoding="async" draggable="false">';
      items += r.link
        ? '<a class="ffq-reviews__item" href="' + esc(r.link) + '" aria-label="Read this review" draggable="false">' + img + '</a>'
        : '<span class="ffq-reviews__item ffq-reviews__item--static">' + img + '</span>';
    }
    /* Tripled for a seamless loop, matching the proof gallery (the marquee
       runtime measures singleSetWidth = scrollWidth / 3). */
    return '<div class="ffq-reviews" id="ffq-reviews">' +
      '<p class="ffq-reviews__label">Loved by hundreds who finally saw their character</p>' +
      '<div class="ffq-reviews__viewport">' +
        '<div class="ffq-reviews__track" data-ffq-marquee>' + items + items + items + '</div>' +
      '</div>' +
    '</div>';
  }

  /* v28 the social proof beat, the trust moment placed right before the
     buy. Belief 3: Jan is a real person who paints each one. The
     scarcity line doubles as the act-now reason. Real faces (the photo
     gallery) sit right under it. v28.2 the heavier Loox review widget
     moves below the buy and the paste step, so it never pushes the
     action down the page. */
  function proofBeatHTML() {
    return '<div class="ffq-proofbeat">' +
        '<p class="ffq-proofbeat__line">I am Jan, and I have hand painted over a thousand of these since 2022.</p>' +
        '<p class="ffq-proofbeat__trust">I only take a handful at a time, so each one gets the time it needs.</p>' +
      '</div>' +
      galleryHTML();
  }

  /* v27 the finish block has two states. Before purchase the gold buy
     button is the hero (Part 2). After she pastes his code the buy is
     done, so it retires and the under-card download carries the finished
     card. v28 the trust band moved up into the proof beat, so the close
     is just the gift line, the descent, and the buy. */
  /* v33 the descent and the one forward button, with honest scarcity.
     Once she has pasted a code (post purchase) the buy retires and the
     finished card download under the card is the only action. */
  function finishInner(rc, giftUrl) {
    /* v37.7 (Change 2) finishInner now owns ONLY the CTA. The reassurance and
       proof lines that used to sit here moved down into buyDetailHTML, so
       everything under the button reads as one cohesive, flush, left-aligned
       column (availability, reassurance, proof, value lines, How it works). */
    return '<a class="ffq-cta-primary" id="ffq-invite-buy" href="' + esc(giftUrl) + '" data-ffq-cta="invitation">' +
        '<span class="ffq-cta-primary__shimmer" aria-hidden="true"></span>' +
        '<span class="ffq-cta-primary__label">' + esc(rc.cta) + ' <span class="ffq-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</a>';
  }
  /* v30 the paste-to-unlock block moved up into the card controls (it is a
     card field she fills in), so the close is just the gift line, the
     descent, and the buy. The inner is its own function so the code field
     can refresh it in place as she types, without a full repaint. */
  function finishHTML(rc, giftUrl) {
    return '<div class="ffq-builder__finish">' + finishInner(rc, giftUrl) + '</div>';
  }

  /* v37.8 re-render only the MESSAGE face so the flip wrapper + portrait face
     persist (the flip state survives theme/size refreshes, and the delegated
     input listener on #ffq-invite-preview keeps covering the editable fields). */
  function updateInvitePreview() {
    var front = document.getElementById('ffq-flip-front');
    if (front) { front.innerHTML = invitePreviewInner(); return; }
    var node = document.getElementById('ffq-invite-preview');
    if (node) node.innerHTML = invitePreviewShell();
  }
  /* v39.1 a size change only affects the claim gift line on the card front,
     so rebuild just that line in place with a soft fade. The old full repaint
     (updateInvitePreview) restarted the scene animation and made the size
     switch feel abrupt. Falls back to the full repaint if the line is not in
     the DOM (it is hidden during phase 1, which keeps the node, so the
     selector still finds it). */
  function updateClaimGiftLine() {
    var p = document.querySelector('#ffq-invite-preview .ffq-invite__claim-gift');
    if (!p) { updateInvitePreview(); return; }
    p.classList.remove('ffq-invite__claim-gift--swap');
    void p.offsetWidth; /* restart the fade if she clicks sizes quickly */
    p.innerHTML = claimGiftHTML();
    p.classList.add('ffq-invite__claim-gift--swap');
  }
  /* v37.8 swap the portrait face's image to the current size, optionally with a
     crossfade (used when the size changes while already on the portrait side),
     and keep the gold name in sync. */
  function updatePortraitFace(crossfade) {
    var nameEl = document.getElementById('ffq-portrait-name');
    if (nameEl) nameEl.textContent = portraitDisplayName();
    var lblEl = document.getElementById('ffq-portrait-label');
    if (lblEl) lblEl.textContent = portraitSampleLabel();
    var img = document.getElementById('ffq-portrait-img');
    if (!img) return;
    var url = sizePortraitUrl(currentPortraitSize());
    if (!url || img.getAttribute('src') === url) return;
    if (crossfade) {
      img.style.opacity = '0';
      var pre = new Image();
      pre.onload = pre.onerror = function () { img.src = url; img.style.opacity = '1'; };
      pre.src = url;
    } else {
      img.src = url;
    }
  }
  function ffqReducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { return false; }
  }
  /* v37.8 module-scoped flip state so size/theme re-renders never lose which
     side is showing. */
  var flipShowingPortrait = false;
  function flipCard(toPortrait) {
    var flip = document.getElementById('ffq-flip');
    var inner = document.getElementById('ffq-flip-inner');
    if (!flip || !inner) return;
    flipShowingPortrait = !!toPortrait;
    /* Blur any focused editable so a size-triggered flip feels intentional and
       nothing typed is lost (edge case / Part 3.5). */
    try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) {}
    if (ffqReducedMotion()) {
      /* No spin. Soft opacity crossfade: fade out, swap sides, fade back in. */
      flip.classList.add('ffq-flip--fading');
      setTimeout(function () {
        inner.classList.toggle('is-flipped', !!toPortrait);
        flip.classList.remove('ffq-flip--fading');
      }, 250);
    } else {
      inner.classList.toggle('is-flipped', !!toPortrait);
    }
  }
  /* Preload all three size portraits so the first flip is instant, no flash. */
  function preloadPortraits() {
    for (var i = 0; i < SIZES.length; i++) {
      var u = sizePortraitUrl(SIZES[i]);
      if (u) { var im = new Image(); im.src = u; }
    }
  }
  /* v37.9.3 the card leans toward the cursor. As the mouse moves over it, the
     tilt layer takes a small rotateX/rotateY based on where the cursor is, so the
     card subtly tilts in 3D (and settles back when the mouse leaves). This is the
     ambient hint that the card is a real, flippable object, replacing the old
     one-time load tease. Mouse only (no touch), skipped under reduced motion. */
  var TILT_MAX = 4; /* degrees — subtle lean */
  /* v37.9.3 / v38.31 the subtle mouse-follow lean. Shared by the builder card and
     the present (reveal) card so both lean toward the cursor the same gentle way. */
  function bindTilt(flip, tilt) {
    if (!flip || !tilt || ffqReducedMotion()) return;
    if (flip.__ffqTiltBound) return;
    flip.__ffqTiltBound = true;
    var raf = null, lastX = 0, lastY = 0;
    function apply() {
      raf = null;
      var r = flip.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (lastX - r.left) / r.width;   /* 0..1 across */
      var py = (lastY - r.top) / r.height;   /* 0..1 down */
      var ry = (px - 0.5) * 2 * TILT_MAX;    /* left/right -> rotateY */
      var rx = -(py - 0.5) * 2 * TILT_MAX;   /* up/down -> rotateX */
      tilt.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
    }
    flip.addEventListener('mousemove', function (e) {
      lastX = e.clientX; lastY = e.clientY;
      if (raf == null) raf = requestAnimationFrame(apply);
    });
    flip.addEventListener('mouseleave', function () {
      if (raf != null) { cancelAnimationFrame(raf); raf = null; }
      tilt.style.transform = '';
    });
  }
  function bindCardTilt() { bindTilt(document.getElementById('ffq-flip'), document.getElementById('ffq-flip-tilt')); }
  function bindPresentTilt() { bindTilt(document.getElementById('ffq-present-flip'), document.getElementById('ffq-present-tilt')); }
  /* v34 drop the caret at the end of a contenteditable node, used after the
     message soft-cap trims overflow so her cursor does not jump to the top. */
  function placeCaretEnd(el) {
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      r.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    } catch (e) {}
  }
  /* v34.1 read a contenteditable's text with line breaks preserved and any
     non-breaking spaces normalized. innerText keeps newlines in browsers;
     textContent is the jsdom fallback. */
  function editableText(el) {
    var t = (el.innerText != null ? el.innerText : (el.textContent || ''));
    return t.split(String.fromCharCode(160)).join(' ');
  }
  /* v34.1 the how-it-works lightbox. */
  function openSteps() {
    var lb = document.getElementById('ffq-steps-lightbox');
    if (!lb) return;
    lb.hidden = false;
    if (!state.stepsSeen) { state.stepsSeen = true; save(); }
  }
  function closeSteps() {
    var lb = document.getElementById('ffq-steps-lightbox');
    if (lb) lb.hidden = true;
  }
  /* v34.1 she types the real code straight into the box on the card. Update
     the box state, the note, the download, and the buy in place, never
     re-rendering the preview (that would steal the caret she is typing in). */
  function handleCodeInput(el) {
    state.unlockCode = sanitizeCode(editableText(el));
    var box = el.closest ? el.closest('.ffq-invite__claim') : el.parentNode;
    if (box && box.classList) {
      var real = !!state.unlockCode;
      box.classList.toggle('ffq-invite__claim--real', real);
      var note = box.querySelector('.ffq-invite__claim-note');
      if (note) {
        note.textContent = real
          ? 'His code is on the card. Give it to him and he follows these steps.'
          : 'A sample. His real code appears here once you finish his gift, and these steps go live.';
      }
    }
    refreshAfterCode();
    save();
  }

  function bindBuilder() {
    var screen = screenEl();
    /* v38.30 the builder preview card carries the same ambient themed halo */
    startBuilderFx();
    /* v38.4 two-phase reveal. The page lands in phase 1 (just the card, the colour
       picker, and the "It looks good" confirm). Confirming reveals the rest of the
       page (the buy column, FAQ, reviews, the claim block on the card, and the
       Present / Download actions) and eases the card from centre to the left. */
    var confirmBtn = screen.querySelector('#ffq-confirm-card');
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      var b = screen.querySelector('.ffq-reveal-2p');
      if (!b || b.classList.contains('is-phase2')) return;
      b.classList.remove('is-phase1');
      b.classList.add('is-phase2');
      /* is-revealing drives the one-time entrance cascade. It is removed after the
         cascade so a later re-render (theme/size change re-renders the card front)
         does NOT replay the claim-block pop-in. */
      b.classList.add('is-revealing');
      setTimeout(function () { if (b) b.classList.remove('is-revealing'); }, 1800);
      try { fbTrack('CardConfirmed', { content_name: 'Fathers Day Quiz 2026' }); gaTrack('card_confirmed', {}); } catch (e) {}
      /* v39 (Rebuild 4) once the entrance cascade settles, lead her into the
         reveal with the one-time dismissible prompt. */
      setTimeout(showPresentPrompt, 1500);
    });
    /* v34 the color theme picker. Clicking a swatch re-skins the card live,
       palette and scene, and marks itself active. */
    var themeBtns = screen.querySelectorAll('[data-ffq-theme]');
    Array.prototype.forEach.call(themeBtns, function (btn) {
      btn.addEventListener('click', function () {
        state.cardTheme = btn.getAttribute('data-ffq-theme');
        Array.prototype.forEach.call(themeBtns, function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        updateInvitePreview();
        save();
      });
    });
    /* v36 the portrait size picker. Picking a size marks it selected, updates
       the size line on the card, and sets the variant the buy will add. */
    var sizeBtns = screen.querySelectorAll('[data-ffq-size]');
    Array.prototype.forEach.call(sizeBtns, function (btn) {
      btn.addEventListener('click', function () {
        /* v36.7 a sold-out size cannot be picked. */
        if (btn.getAttribute('data-sold') === '1') return;
        state.sizeKey = btn.getAttribute('data-ffq-size');
        Array.prototype.forEach.call(sizeBtns, function (b) {
          var on = b.getAttribute('data-ffq-size') === state.sizeKey;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        /* The gift line on the card updates live, in place, so the rest of
           the card (scene animation included) never jumps. */
        updateClaimGiftLine();
        /* v37.8 the size drives the portrait side too. Point the portrait at the
           new size's art; if already on the portrait side, crossfade in place;
           otherwise flip to it. */
        var alreadyPortrait = flipShowingPortrait;
        updatePortraitFace(alreadyPortrait);
        if (!alreadyPortrait) flipCard(true);
        save();
      });
    });
    /* v34.1 every card line is edited in place. The preview node persists
       across re-renders (only its innerHTML changes on a theme switch), so
       one delegated input listener covers all the editable fields. I read
       the text (newlines preserved) into the matching state override, never
       repaint the preview while she types (that would steal the caret), and
       clear the node when empty so the CSS placeholder shows again. The code
       value is handled separately so it can drive the download and the buy. */
    var FIELD_MAP = {
      'ffq-invite-greeting': 'cardGreeting',
      'ffq-invite-summons': 'cardSummons',
      'ffq-invite-msg': 'cardMessage',
      'ffq-invite-signoff': 'cardSignoff',
      /* v37.6 (Change 4) the "your character" words in the claim gift line. */
      'ffq-invite-character': 'cardCharacter'
    };
    var previewNode = screen.querySelector('#ffq-invite-preview');
    if (previewNode) {
      /* v36.7 the card has no code field anymore, so this just keeps the
         editable greeting/summons/message/sign-off in sync with state. */
      previewNode.addEventListener('input', function (e) {
        var m = e.target;
        if (!m || !m.id) return;
        var field = FIELD_MAP[m.id];
        if (!field) return;
        var max = (m.id === 'ffq-invite-msg') ? 220 : 60;
        var txt = editableText(m);
        if (txt.length > max) { txt = txt.slice(0, max); m.textContent = txt; placeCaretEnd(m); }
        var trimmed = txt.replace(/^\s+|\s+$/g, '');
        if (!trimmed && m.innerHTML) m.innerHTML = '';
        state[field] = trimmed;
        if (field === 'cardMessage') { state.cardMsgPreset = 'custom'; }
        /* v37.8 the character name drives the gold name on the portrait side too;
           update it live as she types (edge: empty hides cleanly via :empty CSS). */
        if (m.id === 'ffq-invite-character') {
          var pn = document.getElementById('ffq-portrait-name');
          if (pn) pn.textContent = portraitDisplayName();
        }
        save();
      });
      /* v37.9.2 flip interactions, delegated on the persistent preview container.
         No flip icon: tapping ANY non-editable spot on the message side flips to
         the portrait; tapping the portrait flips back to edit. Editable fields,
         links, and active text selections are left alone so editing still works. */
      previewNode.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('#ffq-portrait-face')) { flipCard(false); return; }
        if (t.closest('#ffq-flip-front')) {
          if (t.closest('[contenteditable="true"]')) return;   // let her edit a line
          if (t.closest('a, button')) return;                  // let interactive bits work
          var sel = window.getSelection && window.getSelection();
          if (sel && !sel.isCollapsed) return;                 // she is selecting text, not tapping
          flipCard(true);
        }
      });
      previewNode.addEventListener('keydown', function (e) {
        var t = e.target;
        if (!t) return;
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        if (t.id === 'ffq-portrait-face') { e.preventDefault(); flipCard(false); return; }
        if (t.id === 'ffq-flip-front') { e.preventDefault(); flipCard(true); }
      });
      preloadPortraits();
      bindCardTilt();
    }
    /* Download the card (immediate). */
    bindDownload();
    /* v37.7 the "Good to know" FAQ accordion. */
    bindFaq(screen);
    /* v36.8 the review carousel auto-scrolls via the shared marquee runtime
       (mountMarquees, called after paint). The photos are plain links to Loox
       reviews, so no extra binding is needed here. */
    /* Back to the quiz. v25: the result page is retired, so back goes
       to the last question (the_notice) rather than a dead reveal. */
    var back = screen.querySelector('#ffq-builder-back');
    if (back) back.addEventListener('click', function () {
      state.view = 'quiz';
      state.step = QUESTIONS.length - 1;
      paintQuestion();
    });
    /* The gap-close CTA. Fires analytics, then the browser follows the
       href to the gift product page. */
    bindBuyClick(screen.querySelector('#ffq-invite-buy'));
    /* v37.5 (Change 5) — sticky scroll nudge wire-up.
       Mirrors product.d-d-custom-sales' ff-stickybar pattern: passive
       scroll listener + rAF tick + getBoundingClientRect().bottom < 0
       on the buy-area anchor (the .ffq-builder__finish wrapper that
       holds the CTA + the two trust lines). Dismissal lives in
       sessionStorage so it persists across the visit but does not
       leak into future sessions on the same device. */
    bindStickyNudge(screen);
  }

  /* v37.5 (Change 5) — sticky scroll nudge controller.
     Behaviour summary:
       - HIDDEN by default.
       - Shows once the .ffq-builder__finish (button + trust lines) has
         scrolled fully above the top of the viewport. That keeps the
         nudge out of the way while there is nothing yet to nudge her
         toward.
       - Hides again if she scrolls back up and the button re-enters view.
       - Tap on the CTA → smooth-scroll the SIZE PICKER to the center of
         the viewport. Per Jan: "she lands on the choice rather than being
         dropped at the top or having a size chosen for her."
       - Dismiss × → permanent-for-this-visit hide via sessionStorage.
       - Mobile: bottom-anchored full-width bar above the safe area inset.
       - Desktop: bottom-anchored centered card with extra padding.
     CSS lives in fathers-day-quiz.css. */
  var STICKY_DISMISS_KEY = 'ffq-stickynudge-dismissed';
  function bindStickyNudge(screen) {
    var bar = screen.querySelector('#ffq-stickynudge');
    if (!bar) return;
    var cta = bar.querySelector('#ffq-stickynudge-cta');
    var dismiss = bar.querySelector('#ffq-stickynudge-dismiss');
    var anchor = screen.querySelector('.ffq-builder__finish');
    if (!anchor) return;
    /* sessionStorage may be unavailable in private modes; guard everything. */
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(STICKY_DISMISS_KEY) === '1'; } catch (e) {}
    if (dismissed) {
      bar.style.display = 'none';
      return;
    }
    var ticking = false;
    function showBar() {
      if (bar.classList.contains('is-visible')) return;
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
    function hideBar() {
      if (!bar.classList.contains('is-visible')) return;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
    function checkPosition() {
      ticking = false;
      /* If the anchor was removed from the DOM (rare, only on a full
         re-render of the screen), tear down quietly. */
      if (!document.body.contains(anchor)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      var rect = anchor.getBoundingClientRect();
      /* Trigger only after the buy area has fully scrolled past the top
         of the viewport. Identical heuristic to ff-stickybar in
         product.d-d-custom-sales. */
      if (rect.bottom < 0) showBar();
      else hideBar();
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(checkPosition);
        ticking = true;
      }
    }
    function scrollToSizes() {
      var picker = document.getElementById('ffq-sizes');
      if (picker && picker.scrollIntoView) {
        try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      }
    }
    if (cta) cta.addEventListener('click', scrollToSizes);
    if (dismiss) dismiss.addEventListener('click', function () {
      hideBar();
      try { sessionStorage.setItem(STICKY_DISMISS_KEY, '1'); } catch (e) {}
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* Initial check (the buy area may already be out of view if she
       navigated here via in-page anchor / back-forward cache). */
    checkPosition();
  }

  /* v35 the reveal IS the close now. The button no longer hops to the gift
     product page. It adds the gift product to the cart and goes straight to
     checkout, the highest-intent moment in the funnel. The gift page stays
     live for non-quiz traffic; we only stop routing the quiz through it. */
  function bindBuyClick(buy) {
    if (!buy) return;
    buy.addEventListener('click', function (e) {
      if (e && e.preventDefault) e.preventDefault();
      var sz = selectedSize();
      /* v36 she has to pick a size first. If she has not, send her up to the
         picker and pulse it rather than checking out an unchosen gift. */
      if (!sz) {
        var picker = document.getElementById('ffq-sizes');
        if (picker) {
          if (picker.scrollIntoView) { try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {} }
          picker.classList.remove('ffq-sizes--nudge');
          void picker.offsetWidth;
          picker.classList.add('ffq-sizes--nudge');
        }
        return;
      }
      var giftUrl = buy.getAttribute('href') || (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
      directCheckout(buy, giftUrl, sz);
    });
  }
  /* v37.9 direct checkout with the chosen size, mapped to the GIFT CARD product.
     The quiz offers three sizes (99 / 139 / 199), which match three of the gift
     card's four denominations. We resolve the gift card product's variants from
     its JSON and add the one whose price matches the chosen size, then go to
     checkout, so the order is for the gift card (not the portrait product). The
     per-size variant id settings are no longer used here, so a stale id can no
     longer send the wrong product to the cart. The gift card product URL comes
     from the section's "Gift card product URL" setting (CONFIG.giftCardUrl); set
     it to the gift card product or the buy falls back to that URL. Clear the cart
     first so she never checks out with a stale item. On any failure, navigate to
     the gift URL so the funnel never dead-ends. */
  var checkoutBusy = false;
  function priceToCents(p) {
    var n = parseFloat(String(p == null ? '' : p).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? Math.round(n * 100) : 0;
  }
  function directCheckout(buy, giftUrl, sz) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    var sizeKey = (sz && sz.key) || '';
    try {
      var ev = { content_name: 'Fathers Day Quiz 2026', route: state.giftRoute || '', theme: state.cardTheme || '', size: sizeKey };
      fbTrack('AddToCart', ev); gaTrack('add_to_cart', { route: state.giftRoute || '', size: sizeKey });
      fbTrack('InitiateCheckout', ev); gaTrack('begin_checkout', { route: state.giftRoute || '', size: sizeKey });
    } catch (e) {}
    var label = buy && buy.querySelector ? buy.querySelector('.ffq-cta-primary__label') : null;
    var prev = label ? label.innerHTML : '';
    if (label) label.textContent = 'Taking you to checkout…';
    var fallback = function () { window.location.href = giftUrl; };
    var fail = function () { if (label) label.innerHTML = prev; checkoutBusy = false; fallback(); };
    var addAndGo = function (id) {
      return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .catch(function () {})
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          });
        })
        .then(function (r) { if (!r || !r.ok) return Promise.reject(); window.location.href = '/checkout'; });
    };
    /* v38.3 prefer the per-size gift card variant id wired in the section settings
       (size1/2/3_variant -> the $99 / $139 / $199 denominations), so the chosen
       size buys the exact matching variant. Only when no id is configured do we
       resolve the variant by price from the product JSON. Either way, a failure
       navigates to the gift product page so the funnel never dead-ends. */
    var variantId = sz && sz.variantId ? String(sz.variantId).replace(/[^0-9]/g, '') : '';
    if (variantId) { addAndGo(variantId).catch(fail); return; }
    try {
      var targetCents = priceToCents(sz && sz.price);
      var handle = String(giftUrl).split('?')[0].replace(/\/$/, '');
      fetch(handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          var match = null, firstAvail = null, i, v;
          for (i = 0; i < vs.length; i++) {
            v = vs[i]; if (!v) continue;
            if (firstAvail === null && v.available !== false) firstAvail = v;
            if (targetCents && Number(v.price) === targetCents) { match = v; break; }
          }
          var chosen = match || firstAvail || vs[0];
          if (!chosen) return Promise.reject();
          return addAndGo(chosen.id);
        })
        .catch(fail);
    } catch (e) { fail(); }
  }

  /* v34.1 the code is typed straight onto the card (#ffq-invite-code-value),
     handled by handleCodeInput in the delegated preview listener. This
     refreshes only what the code drives, the download and the buy, without
     repainting the preview, so the caret stays in the code box she is typing
     in. The code box class and note are updated in place by handleCodeInput. */
  function refreshAfterCode() {
    var dlWrap = document.getElementById('ffq-builder-dl');
    if (dlWrap) {
      dlWrap.innerHTML = downloadBlock();
      bindDownload();
    }
    var fin = document.querySelector('.ffq-builder__finish');
    if (fin) {
      var rc = routeCopy();
      var giftUrl = (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
      fin.innerHTML = finishInner(rc, giftUrl);
      bindBuyClick(fin.querySelector('#ffq-invite-buy'));
    }
  }

  /* ---------- Phone ---------- */
  function formatPhone(raw) {
    var d = digits(raw);
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length <= 3) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function phoneE164() {
    var d = digits(state.phone || (document.getElementById('ffq-phone') || {}).value);
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return null;
    return '+1' + d;
  }
  function showFieldError(id, msg) {
    var input = document.getElementById(id);
    var err = document.getElementById(id + '-err');
    if (input) input.classList.add('is-error');
    if (err) { err.textContent = msg; err.hidden = false; }
  }
  function clearFieldError(id) {
    var input = document.getElementById(id);
    var err = document.getElementById(id + '-err');
    if (input) input.classList.remove('is-error');
    if (err) err.hidden = true;
  }
  function removeFormError() {
    var e = document.getElementById('ffq-formerror');
    if (e && e.parentNode) e.parentNode.removeChild(e);
  }

  /* ============================================================
     OPT IN  ->  KLAVIYO
     ============================================================ */
  function submitOptIn() {
    var fnameEl = document.getElementById('ffq-fname');
    var phoneEl = document.getElementById('ffq-phone');
    var submit = document.getElementById('ffq-submit');
    var first = (fnameEl ? fnameEl.value : '').trim();
    state.firstName = first;
    state.phone = phoneEl ? phoneEl.value : '';

    var ok = true;
    clearFieldError('ffq-fname');
    clearFieldError('ffq-phone');
    clearFieldError('ffq-timing');
    removeFormError();
    /* v17: timing required. Block submit if she hasn't picked one. */
    if (!state.timing) { showFieldError('ffq-timing', 'Please pick when you\'re thinking.'); ok = false; }
    if (first.length < 2) { showFieldError('ffq-fname', 'Please add your first name.'); ok = false; }
    var e164 = phoneE164();
    if (!e164) { showFieldError('ffq-phone', 'Please enter a 10 digit mobile number.'); ok = false; }
    if (!ok) return;

    submit.disabled = true;
    submit.classList.add('is-busy');
    submit.textContent = 'Sending';

    var props = buildProperties();

    if (first.toLowerCase() === TEST_NAME) {
      setTimeout(function () { onOptInSuccess(true); }, 500);
      return;
    }

    klaviyoSubscribe(e164, first)
      .then(function (r) { return r.ok ? r : klaviyoSubscribe(e164, first); })
      .then(function (r) {
        if (!r.ok) throw new Error('subscribe failed');
        return klaviyoProfile(e164, first, props);
      })
      .then(function () {
        // Real submit only (test names return early before this chain).
        // Fire Meta CompleteRegistration via browser pixel + Conversions API.
        capiCompleteRegistration(e164, first);
        onOptInSuccess(false);
      })
      .catch(function () { onOptInError(); });
  }

  function klaviyoPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KL_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return { ok: res.status >= 200 && res.status < 300, status: res.status };
    }).catch(function () { return { ok: false, status: 0 }; });
  }
  function klaviyoSubscribe(e164, first) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Fathers Day Quiz 2026',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                phone_number: e164,
                first_name: first,
                subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function klaviyoProfile(e164, first, props) {
    var payload = {
      data: {
        type: 'profile',
        attributes: { phone_number: e164, first_name: first, properties: props }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  /* v33 the Q7 capture. Email is the channel, phone optional. Subscribes
     her to list W8Unvq and writes the six quiz answers plus the route
     onto her profile so the follow up can name his actual character.
     Non-blocking, with one retry, so the reveal never waits on it. */
  function quizProps() {
    computeRoute();
    return {
      FathersDayQuiz_HisName: state.hisName || '',
      FathersDayQuiz_Stance: state.stance || '',
      FathersDayQuiz_Recipient: state.recipient || '',
      FathersDayQuiz_World: answerByKey('his_world') || '',
      FathersDayQuiz_Character: answerByKey('his_character') || '',
      FathersDayQuiz_Character_Name: state.characterName || '',
      FathersDayQuiz_Notice: answerByKey('the_notice') || (state.notesText || ''),
      FathersDayQuiz_Route: state.giftRoute || ''
    };
  }
  function klaviyoSubscribeEmail(email, phoneE) {
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: email };
    if (phoneE) { attrs.phone_number = phoneE; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    attrs.subscriptions = subs;
    var payload = {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'Fathers Day Quiz 2026', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function klaviyoProfileEmail(email, phoneE, props) {
    var attrs = { email: email, properties: props };
    if (phoneE) attrs.phone_number = phoneE;
    var payload = { data: { type: 'profile', attributes: attrs } };
    return klaviyoPost('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function submitQuizCapture() {
    var email = (state.email || '').trim();
    if (!email) return;
    var phoneE = phoneE164();
    var props = quizProps();
    try {
      fbTrack('Lead', { content_name: 'Fathers Day Quiz 2026', route: state.giftRoute || '' });
      gaTrack('quiz_lead', { route: state.giftRoute || '' });
    } catch (e) {}
    try {
      klaviyoSubscribeEmail(email, phoneE)
        .then(function (r) { return (r && r.ok) ? r : klaviyoSubscribeEmail(email, phoneE); })
        .then(function () { return klaviyoProfileEmail(email, phoneE, props); })
        .catch(function () {});
    } catch (e) {}
  }
  function buildProperties() {
    var now = new Date().toISOString();
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    var props = {
      FathersDayQuiz_Recipient: recipientObj().map,
      FathersDayQuiz_Headline_Variant: state.headlineVariant,
      FathersDayQuiz_Branch: state.branch,
      FathersDayQuiz_Hobby: answerByKey('hobby'),
      /* v17: timing moved off the quiz body and onto the SMS opt-in
         form as inline form data. Read from state.timing instead of
         the answers[] index. */
      FathersDayQuiz_Timing: state.timing || '',
      FathersDayQuiz_Hobby_Vibe: answerByKey('hobby_vibe'),
      /* v16: FathersDayQuiz_Personality removed. The personality
         question was cut entirely so the Klaviyo property is gone
         too — Klaviyo will not error on missing properties, but
         downstream flows that branched on Personality need updating
         on the Klaviyo side. */
      FathersDayQuiz_Moral_Signature: answerByKey('moral_signature'),
      /* v5 engagement-layer properties. Trait curation is now a
         single-select (was multi in v5.1), so it saves as a single
         string: the picked option's store value. Renamed to
         _Most_Him_Trait to reflect the new mechanic. Signature
         behavior and inside detail unchanged. */
      FathersDayQuiz_Most_Him_Trait: answerByKey('trait_curation'),
      FathersDayQuiz_Signature_Behavior: answerByKey('signature_behavior'),
      FathersDayQuiz_Inside_Detail: answerByKey('inside_detail'),
      FathersDayQuiz_Result_Archetype: a.name,
      FathersDayQuiz_Archetype_Scores: JSON.stringify(state.scores),
      FathersDayQuiz_First_Text_Template: firstTextTemplate(),
      FathersDayQuiz_Completed_At: now,
      FathersDayQuiz_Source: 'Fathers Day Quiz 2026',
      FathersDayQuiz_SMS_Consent_Text: TCPA_TEXT,
      FathersDayQuiz_SMS_Consent_At: now
    };
    if (state.hisName) props.FathersDayQuiz_Recipient_First_Name = state.hisName;
    return props;
  }

  function onOptInSuccess(isTest) {
    clearSaved();
    if (!isTest) {
      trackOnce('lead', function () {
        fbTrack('Lead', { value: 150, currency: 'USD', content_name: 'PfP Waitlist SMS', content_category: 'Fathers Day Quiz 2026' });
        gaTrack('generate_lead', { currency: 'USD', value: 150 });
      });
      /* v18 fallback_submit. Fires on a real successful Klaviyo
         submission only. Test names return earlier in submitOptIn so
         this branch only runs for live opt ins. */
      trackOnce('fallback_submit', function () {
        fbTrack('fallback_submit', {
          content_name: 'Fathers Day Quiz 2026',
          archetype: (ARCH[state.archetype] || {}).name || '',
          timing: state.timing || ''
        });
        gaTrack('fallback_submit', {
          archetype: state.archetype,
          timing: state.timing || ''
        });
      });
    }
    /* Marker class kept so CSS hooks that watched for the post submit
       state still apply. In v18 nothing is hidden on the page that
       this class needs to reveal, but downstream styles may key off
       it for muted post submit states. */
    var resultWrap = document.querySelector('.ffq-result');
    if (resultWrap) resultWrap.classList.add('ffq-result--saved');
    var optin = document.getElementById('ffq-optin');
    if (!optin) return;
    optin.innerHTML = confirmationHTML(isTest);
    bindConfirmation();
    try { optin.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }
  function onOptInError() {
    var submit = document.getElementById('ffq-submit');
    if (submit) {
      submit.disabled = false;
      submit.classList.remove('is-busy');
      submit.textContent = 'Have Jan text me';
    }
    removeFormError();
    var optin = document.getElementById('ffq-optin');
    if (!optin) return;
    var err = h('<div class="ffq-formerror" id="ffq-formerror">That did not go through. Tap here to try again.</div>');
    err.addEventListener('click', function () { removeFormError(); submitOptIn(); });
    optin.appendChild(err);
  }

  /* ============================================================
     CONFIRMATION  +  SHAREABLE CARD  (inline, same screen)
     ============================================================ */
  function confirmationHTML(isTest) {
    /* v14: cardModuleHTML() ("Want his name on the card?" + card
       preview + Save/Share buttons) removed from the post-submit
       confirmation. The buyer can already download the card via the
       "SAVE YOUR HUSBAND'S ARCHETYPE CARD" link further up the result
       page, so the second card here was redundant friction. The
       confirmation is now just the gold checkmark + reassurance copy. */
    /* v17 confirmation. Closes the SOKA frame ("you already know what
       to give him") and Jan signs off in first person to land the
       trust handoff the whole flow has been building toward. */
    var msg = 'You already know what to give him. I\'ll text in a day or two and we\'ll talk through the photo and his character. Keep an eye on your phone.';
    var signoff = 'Jan';
    if (isTest) msg += ' (Test mode, nothing was sent to Klaviyo.)';
    return '<div class="ffq-confirm">' +
      '<div class="ffq-confirm__mark"><svg viewBox="0 0 24 24" fill="none">' +
        '<path d="M5 13l4 4L19 6" stroke="#e8c674" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
      '<p class="ffq-confirm__head">Your spot is saved.</p>' +
      '<p class="ffq-confirm__text">' + esc(msg) + '</p>' +
      '<p class="ffq-confirm__signoff">' + esc(signoff) + '</p>' +
      '</div>';
  }
  function cardModuleHTML() {
    return '<div class="ffq-cardwrap">' +
      '<p class="ffq-cardwrap__head">A keepsake to share while you wait.</p>' +
      '<div class="ffq-cardname">' +
        '<label class="ffq-label" for="ffq-hisname">Want his name on the card?</label>' +
        '<input class="ffq-input" id="ffq-hisname" type="text" maxlength="20" autocomplete="off" placeholder="His first name (optional)">' +
      '</div>' +
      '<div class="ffq-cardpreview"><img id="ffq-card-img" alt="Your shareable result card"></div>' +
      '<div class="ffq-card-actions">' +
        '<button type="button" class="ffq-continue" id="ffq-card-save">Save image</button>' +
        '<button type="button" class="ffq-cardshare" id="ffq-card-share">Share</button>' +
      '</div>' +
    '</div>';
  }
  function bindConfirmation() {
    var screen = screenEl();
    var nameInput = screen.querySelector('#ffq-hisname');
    if (state.hisName && nameInput) nameInput.value = state.hisName;
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        state.hisName = nameInput.value.trim();
        updateCardPreview();
      });
    }
    /* The card is 4:5 only now (no aspect toggle), so cardAspect stays
       at its default and the renderer uses the post dimensions. */
    var saveBtn = screen.querySelector('#ffq-card-save');
    var shareBtn = screen.querySelector('#ffq-card-share');
    if (saveBtn) saveBtn.addEventListener('click', saveCard);
    if (shareBtn) shareBtn.addEventListener('click', shareCard);
    withFonts(updateCardPreview);
  }

  /* ---------- Card rendering ---------- */
  function withFonts(cb) {
    if (document.fonts && document.fonts.load) {
      var jobs = [
        document.fonts.load('900 80px Cinzel'),
        document.fonts.load('700 30px Cinzel'),
        document.fonts.load('600 26px Cinzel'),
        document.fonts.load('italic 500 52px "Cormorant Garamond"'),
        document.fonts.load('italic 500 40px "Cormorant Garamond"')
      ];
      Promise.all(jobs).then(cb, cb);
    } else { cb(); }
  }
  function wrapLines(ctx, text, maxWidth) {
    var words = String(text).split(' '), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = words[i];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    return lines;
  }
  function drawSpaced(ctx, text, cx, y, spacing) {
    text = String(text);
    var total = 0, i, w;
    for (i = 0; i < text.length; i++) {
      total += ctx.measureText(text.charAt(i)).width;
      if (i < text.length - 1) total += spacing;
    }
    var x = cx - total / 2;
    ctx.textAlign = 'left';
    for (i = 0; i < text.length; i++) {
      ctx.fillText(text.charAt(i), x, y);
      w = ctx.measureText(text.charAt(i)).width;
      x += w + spacing;
    }
    ctx.textAlign = 'center';
  }
  /* v9 card restyle. Portrait 1080x1350 (Instagram 4:5 post format).
     Now MATCHES the landing carousel card design from the homepage,
     plus includes the painted character image at the top.

     Layout (top to bottom):
       wordmark   FRAMEDFANTASY small cream caps
       painting   archetype painting, 670 tall, gold border
       eyebrow    HE IS THE small gold caps
       name       archetype name, large gold serif, auto-shrink to 2 lines
       tagline    italic cream Cormorant
       ornament   small gold diamond mark
       pull       italic gold-pale pull quote in curly quotes
       footer     TAKE THE QUIZ TO FIND HIS + URL

     Image loading is async, so renderCardCanvas takes a callback that
     receives the finished canvas. If the image fails to load (CORS,
     network, blank slot), the card renders without it and still
     calls back cleanly. */
  function renderCardCanvas(callback) {
    var d = revealData();
    var W = 1080;
    var H = 1350;
    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');

    /* Layout constants. Painted-image zone is fixed; the text block
       beneath flows from a single y cursor so font-size changes don't
       cause overlap. */
    var PAINTING = { x: 205, y: 145, w: 670, h: 670, radius: 14 };

    drawCardBackground(ctx, W, H);
    drawCardWordmark(ctx, W);

    var imgUrl = (IMG[state.archetype] && IMG[state.archetype].full) || '';
    function drawTextLayer() {
      drawCardTextBlock(ctx, d, W, H, PAINTING);
      callback(canvas);
    }
    if (imgUrl) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        drawCardPainting(ctx, img, PAINTING);
        drawTextLayer();
      };
      img.onerror = function () {
        /* Graceful fallback: dark placeholder so the layout still
           reads as a card, not an empty hole. */
        drawCardPaintingPlaceholder(ctx, PAINTING);
        drawTextLayer();
      };
      img.src = imgUrl;
    } else {
      drawCardPaintingPlaceholder(ctx, PAINTING);
      drawTextLayer();
    }
  }
  function drawCardBackground(ctx, W, H) {
    /* v34 the card body tint follows the chosen theme so the exported PNG
       matches the recolored on-screen card. These values mirror the
       per-theme --ffq-card-body values in the CSS. */
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var bg = {
      tavern: '#15100a', arcane: '#100b20', wilds: '#0a140e',
      hall: '#0a1020', ember: '#160a0c', love: '#160a18'
    }[themeKey] || '#0c1428';
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);
    /* Subtle gold inner frame, 1px. */
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.25)';
    ctx.lineWidth = 1;
    ctx.strokeRect(36, 36, W - 72, H - 72);
  }
  function drawCardWordmark(ctx, W) {
    ctx.textAlign = 'center';
    ctx.fillStyle = '#efe6d2';
    ctx.font = '600 22px Cinzel, Georgia, serif';
    drawSpaced(ctx, 'FRAMEDFANTASY', W / 2, 95, 8);
  }
  function roundRectPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y,     x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x,     y + h, r);
    ctx.arcTo(x,     y + h, x,     y,     r);
    ctx.arcTo(x,     y,     x + w, y,     r);
    ctx.closePath();
  }
  function drawCardPainting(ctx, img, P) {
    /* Cover-fit the image into the painting box (crop to fill), with
       rounded corners and a subtle gold border. */
    ctx.save();
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.clip();
    /* Cover-fit math. */
    var iw = img.width || img.naturalWidth || 1;
    var ih = img.height || img.naturalHeight || 1;
    var scale = Math.max(P.w / iw, P.h / ih);
    var dw = iw * scale;
    var dh = ih * scale;
    var dx = P.x + (P.w - dw) / 2;
    var dy = P.y + (P.h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
    ctx.restore();
    /* Border on top of the clipped image. */
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.55)';
    ctx.lineWidth = 1.5;
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.stroke();
  }
  function drawCardPaintingPlaceholder(ctx, P) {
    /* Dark plate with a faint "PORTRAIT" caption so the layout never
       looks broken on a missing image. */
    ctx.save();
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.fillStyle = '#14202f';
    ctx.fill();
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.4)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.fillStyle = 'rgba(201, 168, 76, 0.45)';
    ctx.font = '600 22px Cinzel, Georgia, serif';
    ctx.textAlign = 'center';
    drawSpaced(ctx, 'PORTRAIT', P.x + P.w / 2, P.y + P.h / 2 + 8, 6);
    ctx.restore();
  }
  function drawCardTextBlock(ctx, d, W, H, P) {
    var cx = W / 2;
    /* v15 spacing pass. The previous values opened a big air pocket
       between the "HE IS THE" eyebrow and the giant archetype name
       (label→name was 58) and another between the name and the
       tagline (50). With a 1-line tagline + 1-line quote the bottom
       half of the card felt cramped against the pinned footer while
       the top felt loose. Tightening label→name and name→tagline
       lifts the whole text block up and lets the ornament + quote
       breathe naturally above the footer. */
    /* v15.1 micro-tighten: lift the "HE IS THE" + giant-name pair
       closer to the painting (PAINT_TO_LABEL 48→36, LABEL_TO_NAME
       30→24), and add real breathing room between the headline and
       the tagline (NAME_TO_TAGLINE 38→58) so the italic line reads
       as its own beat instead of crowding the giant name. */
    var GAP_PAINT_TO_LABEL = 36;
    var GAP_LABEL_TO_NAME = 24;
    var GAP_NAME_TO_TAGLINE = 58;
    var GAP_TAGLINE_TO_ORNAMENT = 48;
    var GAP_ORNAMENT_TO_QUOTE = 58;
    var TAGLINE_LINE_H = 34;
    var QUOTE_LINE_H = 34;
    /* Footer is pinned near the canvas bottom (inside the 36px frame
       inset) so it never floats off-card no matter what font sizes
       above it computed to. */
    var FOOTER_HEADING_Y = H - 100;
    var FOOTER_URL_Y = H - 65;

    var y = P.y + P.h + GAP_PAINT_TO_LABEL;

    ctx.textAlign = 'center';

    /* Eyebrow: HE IS THE */
    ctx.fillStyle = '#c9a84c';
    ctx.font = '700 22px Cinzel, Georgia, serif';
    drawSpaced(ctx, d.cardLabel, cx, y, 5);

    /* Archetype name — large gold serif, auto-shrink to fit two lines. */
    var nameSize = 78;
    ctx.font = '900 ' + nameSize + 'px Cinzel, Georgia, serif';
    var nameLines = wrapLines(ctx, d.cardName, W - 240);
    while (nameLines.length > 2 && nameSize > 50) {
      nameSize -= 4;
      ctx.font = '900 ' + nameSize + 'px Cinzel, Georgia, serif';
      nameLines = wrapLines(ctx, d.cardName, W - 240);
    }
    ctx.fillStyle = '#f4d68a';
    var nameLineH = nameSize + 6;
    /* Move to the first name baseline: label baseline + gap + ascent
       of the giant name. */
    y += GAP_LABEL_TO_NAME + nameSize;
    for (var n = 0; n < nameLines.length; n++) {
      ctx.fillText(nameLines[n], cx, y);
      if (n < nameLines.length - 1) y += nameLineH;
    }

    /* Tagline — italic cream, just under the name. */
    y += GAP_NAME_TO_TAGLINE;
    ctx.fillStyle = '#efe6d2';
    ctx.font = 'italic 500 28px "Cormorant Garamond", Georgia, serif';
    var taglineText = d.cardTagline.replace(/\.\s*$/, '');
    var taglineLines = wrapLines(ctx, taglineText, W - 220);
    for (var tl = 0; tl < taglineLines.length; tl++) {
      ctx.fillText(taglineLines[tl], cx, y);
      if (tl < taglineLines.length - 1) y += TAGLINE_LINE_H;
    }

    /* Ornament between tagline and pull quote. */
    y += GAP_TAGLINE_TO_ORNAMENT;
    drawOrnament(ctx, cx, y);
    y += GAP_ORNAMENT_TO_QUOTE;

    /* Pull quote — italic gold-pale, wrapped in curly quotes.
       Fixed offset below the ornament (no longer dynamically centered
       against the footer): with the v15 upper-spacing tighten, the
       quote now sits naturally above the pinned footer with room to
       breathe, and a fixed offset keeps it visually anchored to the
       ornament instead of floating in the middle of the empty space. */
    ctx.fillStyle = '#e8c674';
    ctx.font = 'italic 500 26px "Cormorant Garamond", Georgia, serif';
    var quoteText = '“' + d.pull.replace(/^[“”"']+|[“”"']+$/g, '') + '”';
    var quoteLines = wrapLines(ctx, quoteText, W - 240);
    for (var q = 0; q < quoteLines.length; q++) {
      ctx.fillText(quoteLines[q], cx, y);
      if (q < quoteLines.length - 1) y += QUOTE_LINE_H;
    }

    /* Footer is always pinned to the same canvas-relative position.
       Pull-quote variable length doesn't move it. Worst-case (4-line
       quote) leaves about 16px between the last quote line and the
       footer — tight but still visually separated. */
    ctx.fillStyle = '#efe6d2';
    ctx.font = '600 17px Cinzel, Georgia, serif';
    drawSpaced(ctx, 'TAKE THE QUIZ TO FIND HIS', cx, FOOTER_HEADING_Y, 4);
    ctx.fillStyle = '#aa9f86';
    ctx.font = '400 15px "SF Mono", "Roboto Mono", Consolas, monospace';
    ctx.fillText('framedfantasy.com/fathersday', cx, FOOTER_URL_Y);
  }
  /* Small 4-point gold ornament. Heraldic, fantasy-rune feel without
     turning the card into a D&D logo. Two perpendicular slim diamonds
     plus a center dot. */
  function drawOrnament(ctx, cx, cy) {
    ctx.save();
    ctx.fillStyle = '#c9a84c';
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.6)';
    ctx.lineWidth = 1;
    var r = 9;
    var rl = 14; /* longer arm */
    /* Vertical diamond */
    ctx.beginPath();
    ctx.moveTo(cx, cy - rl);
    ctx.lineTo(cx + r * 0.55, cy);
    ctx.lineTo(cx, cy + rl);
    ctx.lineTo(cx - r * 0.55, cy);
    ctx.closePath();
    ctx.fill();
    /* Horizontal thin line */
    ctx.beginPath();
    ctx.moveTo(cx - 38, cy);
    ctx.lineTo(cx - 18, cy);
    ctx.moveTo(cx + 18, cy);
    ctx.lineTo(cx + 38, cy);
    ctx.stroke();
    /* Center dot */
    ctx.beginPath();
    ctx.arc(cx, cy, 2.2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
  function updateCardPreview() {
    var img = document.getElementById('ffq-card-img');
    if (!img) return;
    try {
      renderCardCanvas(function (canvas) {
        try { img.src = canvas.toDataURL('image/png'); } catch (e) {}
      });
    } catch (e) {}
  }
  function cardFilename() {
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    return 'framedfantasy-' + a.name.toLowerCase().replace(/[^a-z]+/g, '-') + '-' + state.cardAspect + '.png';
  }
  function _downloadCardBlob(blob) {
    if (!blob) return;
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = cardFilename();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }
  /* v25 invitation PNG. Draws the invitation she designed to a
     1080x1350 canvas for download. The free version always shows the
     locked panel and no code, so the downloaded artifact reads as an
     invitation missing his part, not a finished gift. An uploaded
     scene photo is used for the art band when present (Jan's art is
     the final look), otherwise a themed gradient. The code-bearing
     finished version is rendered after purchase in the paste-to-unlock
     step (next slice). Async because the photo loads cross-origin. */
  function renderInvitationCanvas(callback) {
    var W = 1080, cx = W / 2;
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    var sz = selectedSize();
    /* v37.8 the portrait side's image for the download (selected size, or the
       first size as the default shown before any pick). */
    var portraitUrl = sizePortraitUrl(currentPortraitSize());
    var character = state.giftRoute !== 'portrait';
    var themeGrad = {
      tavern: ['#4a3415', '#160d05'], arcane: ['#2c1f52', '#0a0714'],
      wilds: ['#16331f', '#060f09'], hall: ['#1c2c5a', '#070b18'],
      ember: ['#4a1a20', '#140507'], love: ['#3a1f44', '#140a18']
    }[themeKey] || ['#20264d', '#080a18'];
    var ABH = 372;
    var AB = { x: 80, y: 140, w: W - 160, h: ABH, r: 16 };

    /* v36.7 the claim block content, matching the on-screen card: a gift line,
       an eyebrow, and three steps. No code or disclaimer (the code is delivered
       to her separately). */
    /* v37.6 (Change 4) mirror the editable character value from the live card
       so the downloaded PNG carries his character's name when she set one. */
    var subject = character ? cardCharacterValue() : 'you as the hero';
    var giftLine = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of ' + subject + '.'
      : 'Your gift is a hand painted portrait of ' + subject + '.';
    /* v37.4 Jan: "Here is how to bring it to life." on its own line. */
    var bringLine = 'Here is how to bring it to life.';
    var claimSteps = [
      'Go to FramedFantasy.com/Gift.',
      (character ? 'Take the character quest and download your blueprint.' : 'Send your best photo so I have your likeness.'),
      'Check out with your code. I reach out, and about two weeks later you review your finished portrait.'
    ];

    /* Draw (or, when draw=false, only measure) the claim block content inside a
       box at [boxX, topY, boxW]. Returns the box height. Fonts are set in both
       modes so wrapLines wraps identically. */
    function renderClaim(ctx, boxX, boxW, topY, draw) {
      var pad = 30, innerW = boxW - 80, y = topY + pad;
      ctx.textAlign = 'center';
      /* v36.9 gold eyebrow on top, then the white subtext, then the steps. */
      if (draw) ctx.fillStyle = '#c9a84c';
      ctx.font = '700 21px Cinzel, Georgia, serif';
      if (draw) drawSpaced(ctx, 'HOW TO CLAIM YOUR PORTRAIT', cx, y, 5);
      y += 34;
      if (draw) ctx.fillStyle = '#efe6d2';
      ctx.font = 'italic 500 29px "Cormorant Garamond", Georgia, serif';
      var giftLines = wrapLines(ctx, giftLine, innerW);
      for (var gi = 0; gi < giftLines.length; gi++) { if (draw) ctx.fillText(giftLines[gi], cx, y); y += 37; }
      var bringLines = wrapLines(ctx, bringLine, innerW);
      for (var bi = 0; bi < bringLines.length; bi++) { if (draw) ctx.fillText(bringLines[bi], cx, y); y += 37; }
      y += 10;
      ctx.textAlign = 'left';
      var stepX = boxX + 46, textX = stepX + 40;
      for (var s = 0; s < claimSteps.length; s++) {
        ctx.font = '400 25px "Cormorant Garamond", Georgia, serif';
        var lines = wrapLines(ctx, claimSteps[s], boxW - (textX - boxX) - 30);
        if (draw) {
          var ccx = stepX, ccy = y - 9;
          ctx.beginPath(); ctx.arc(ccx, ccy, 15, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(201,168,76,0.6)'; ctx.lineWidth = 1.4; ctx.stroke();
          ctx.fillStyle = '#c9a84c'; ctx.font = '600 19px Cinzel, Georgia, serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(String(s + 1), ccx, ccy + 1);
          ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'left';
          ctx.fillStyle = '#cdbfa3'; ctx.font = '400 25px "Cormorant Garamond", Georgia, serif';
        }
        for (var j = 0; j < lines.length; j++) { if (draw) ctx.fillText(lines[j], textX, y); y += 32; }
        y += 11;
      }
      y += 2;
      return (y - topY); /* box bottom sits ~pad below the last step */
    }

    /* Draw (or measure) the whole flowing card below the band. Returns final y. */
    function layoutText(ctx, draw) {
      if (draw) {
        ctx.textAlign = 'center';
        ctx.fillStyle = '#c2b79f'; ctx.font = '600 26px Cinzel, Georgia, serif';
        drawSpaced(ctx, (occasionStamp() || '').toUpperCase(), cx, 88, 6);
        ctx.strokeStyle = 'rgba(201,168,76,0.18)'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(150, 120); ctx.lineTo(W - 150, 120); ctx.stroke();
      }
      ctx.textAlign = 'center';
      var y = AB.y + AB.h + 86;
      ctx.font = '900 52px Cinzel, Georgia, serif';
      if (draw) ctx.fillStyle = '#f4d68a';
      var greetVal = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
      var greetLines = wrapLines(ctx, greetVal, W - 160);
      for (var g = 0; g < greetLines.length; g++) { if (draw) ctx.fillText(greetLines[g], cx, y); y += 60; }
      y += 8;
      ctx.font = 'italic 500 36px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#efe6d2';
      var summonsVal = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : routeCopy().summons;
      var summonsLines = wrapLines(ctx, summonsVal, W - 200);
      for (var sg = 0; sg < summonsLines.length; sg++) { if (draw) ctx.fillText(summonsLines[sg], cx, y); y += 42; }
      y += 22;
      if (draw) { ctx.strokeStyle = 'rgba(201,168,76,0.22)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(170, y); ctx.lineTo(W - 170, y); ctx.stroke(); }
      y += 54;
      ctx.font = 'italic 500 38px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#efe6d2';
      var msgParas = (state.cardMessage || '').trim().split('\n');
      var msgLines = [];
      for (var mp = 0; mp < msgParas.length; mp++) {
        var seg = msgParas[mp].replace(/^\s+|\s+$/g, '');
        if (!seg) { msgLines.push(''); continue; }
        msgLines = msgLines.concat(wrapLines(ctx, seg, W - 230));
      }
      for (var i = 0; i < msgLines.length; i++) { if (draw) ctx.fillText(msgLines[i], cx, y); y += 48; }
      y += 8;
      if (draw) { ctx.strokeStyle = 'rgba(201,168,76,0.22)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(170, y); ctx.lineTo(W - 170, y); ctx.stroke(); }
      y += 56;
      ctx.font = 'italic 600 32px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#c2b79f';
      var signoffVal = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
      if (draw) ctx.fillText(signoffVal, cx, y);
      y += 44 + 28;
      var boxX = 120, boxW = W - 240;
      var boxH = renderClaim(ctx, boxX, boxW, y, false);
      if (draw) {
        ctx.save();
        ctx.fillStyle = 'rgba(201,168,76,0.05)';
        roundRectPath(ctx, boxX, y, boxW, boxH, 16); ctx.fill();
        ctx.strokeStyle = 'rgba(201,168,76,0.45)'; ctx.lineWidth = 1.5;
        roundRectPath(ctx, boxX, y, boxW, boxH, 16); ctx.stroke();
        ctx.restore();
        renderClaim(ctx, boxX, boxW, y, true);
      }
      y += boxH;
      return y;
    }

    /* Draw the art band (clip + theme gradient + photo/scene fill + frame), no
       text. Shared by the single- and double-sided paths. */
    function drawBandInner(ctx, img, isPhoto) {
      ctx.save();
      roundRectPath(ctx, AB.x, AB.y, AB.w, AB.h, AB.r); ctx.clip();
      var grd = ctx.createLinearGradient(AB.x, AB.y, AB.x, AB.y + AB.h);
      grd.addColorStop(0, themeGrad[0]); grd.addColorStop(1, themeGrad[1]);
      ctx.fillStyle = grd; ctx.fillRect(AB.x, AB.y, AB.w, AB.h);
      if (img && isPhoto) {
        var s = Math.max(AB.w / img.width, AB.h / img.height);
        var dw = img.width * s, dh = img.height * s;
        ctx.drawImage(img, AB.x + (AB.w - dw) / 2, AB.y + (AB.h - dh) / 2, dw, dh);
      } else if (img) {
        ctx.drawImage(img, AB.x, AB.y, AB.w, AB.h);
      }
      ctx.restore();
      ctx.strokeStyle = 'rgba(201,168,76,0.5)'; ctx.lineWidth = 1.5;
      roundRectPath(ctx, AB.x, AB.y, AB.w, AB.h, AB.r); ctx.stroke();
    }
    /* Draw the whole message card (background + band + flowing text) at vertical
       offset offY, loading the art (or scene fallback) first, then call done. */
    function drawMessageCard(ctx, H, offY, done) {
      ctx.save(); ctx.translate(0, offY);
      drawCardBackground(ctx, W, H);
      function finish(artImg, isPhoto) {
        drawBandInner(ctx, artImg, isPhoto);
        layoutText(ctx, true);
        ctx.restore();
        done();
      }
      function scene() {
        var sv = new Image();
        sv.onload = function () { finish(sv, false); };
        sv.onerror = function () { finish(null, false); };
        sv.src = inviteSceneDataUrl(themeKey);
      }
      if (artUrl) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { finish(im, true); };
        im.onerror = scene;
        im.src = artUrl;
      } else { scene(); }
    }
    /* Portrait side: full-bleed cover image (top anchor so the face stays in),
       bottom scrim, the sample label (kept in the download per decision 3), and
       the gold name near the bottom. No flip icon or tap hint (those are DOM
       affordances, never drawn here). */
    function drawPortraitRegion(ctx, img, x, y, w, h) {
      ctx.save();
      roundRectPath(ctx, x, y, w, h, 16); ctx.clip();
      ctx.fillStyle = '#0a0a12'; ctx.fillRect(x, y, w, h);
      if (img) {
        var s = Math.max(w / img.width, h / img.height);
        var dw = img.width * s, dh = img.height * s;
        ctx.drawImage(img, x + (w - dw) / 2, y, dw, dh); /* top-center anchor */
      }
      var sg = ctx.createLinearGradient(x, y + h, x, y + h * 0.54);
      sg.addColorStop(0, 'rgba(8,8,14,0.92)'); sg.addColorStop(1, 'rgba(8,8,14,0)');
      ctx.fillStyle = sg; ctx.fillRect(x, y + h * 0.54, w, h * 0.46);
      ctx.restore();
      ctx.strokeStyle = 'rgba(201,168,76,0.5)'; ctx.lineWidth = 1.5;
      roundRectPath(ctx, x, y, w, h, 16); ctx.stroke();
      ctx.textAlign = 'center';
      ctx.fillStyle = 'rgba(239,230,210,0.75)';
      ctx.font = 'italic 400 22px "Cormorant Garamond", Georgia, serif';
      ctx.fillText('example art, painted from your own description', x + w / 2, y + 40);
      var name = portraitDisplayName();
      if (name) {
        ctx.fillStyle = '#f4d68a';
        ctx.font = '700 56px Cinzel, Georgia, serif';
        ctx.fillText(name, x + w / 2, y + h - h * 0.09);
      }
    }
    function build() {
      var canvas = document.createElement('canvas');
      canvas.width = W; canvas.height = 10;
      var mctx = canvas.getContext('2d');
      if (!mctx) { callback(null); return; }
      var finalY = layoutText(mctx, false);
      var H = Math.ceil(finalY + 56);
      /* Message-only fallback (existing behavior) if the portrait can't load. */
      function buildSingle() {
        canvas.height = H;
        var ctx = canvas.getContext('2d');
        drawMessageCard(ctx, H, 0, function () { callback(canvas); });
      }
      /* Two sides stacked: portrait on top, message below, each at card height. */
      function buildDouble(pimg) {
        canvas.height = H + H;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#08080e'; ctx.fillRect(0, 0, W, canvas.height);
        drawPortraitRegion(ctx, pimg, 0, 0, W, H);
        drawMessageCard(ctx, H, H, function () { callback(canvas); });
      }
      /* v38.5 the download is the CARD only (the message side). Per Jan, the
         portrait/example-art side is no longer stacked into the PNG. buildDouble
         is kept for reference but no longer called. */
      buildSingle();
    }
    build();
  }
  function inviteFilename() {
    var nm = (state.hisName || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return 'framedfantasy-card' + (nm ? '-' + nm : '') + '.png';
  }
  function downloadInvitation() {
    try {
      fbTrack('invitation_download', { content_name: 'Fathers Day Quiz 2026' });
      gaTrack('invitation_download', {});
    } catch (e) {}
    try {
      withFonts(function () {
        renderInvitationCanvas(function (canvas) {
          if (!canvas) return;
          try {
            canvas.toBlob(function (blob) {
              if (!blob) return;
              var url = URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url; a.download = inviteFilename();
              document.body.appendChild(a); a.click(); document.body.removeChild(a);
              setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
            }, 'image/png');
          } catch (e) {}
        });
      });
    } catch (e) {}
  }
  function saveCard() {
    /* Reverted to single-page render (the two-page version with
       answers + commission CTA was rolled back per Jan's request).
       Both saveCard and shareCard now use the same 1080×1350 canvas. */
    try {
      renderCardCanvas(function (canvas) {
        try {
          canvas.toBlob(function (blob) { _downloadCardBlob(blob); }, 'image/png');
          fireCardEvent('save');
        } catch (e) {}
      });
    } catch (e) {}
  }
  function shareCard() {
    try {
      renderCardCanvas(function (canvas) {
        try {
          canvas.toBlob(function (blob) {
            if (!blob) { saveCard(); return; }
            var file = new File([blob], cardFilename(), { type: 'image/png' });
            if (navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
              navigator.share({ files: [file], title: 'My FramedFantasy result' }).catch(function () {});
            } else {
              _downloadCardBlob(blob);
            }
          }, 'image/png');
          fireCardEvent('share');
        } catch (e) {}
      });
    } catch (e) {}
  }
  function fireCardEvent(kind) {
    /* Keep the legacy ShareableCardDownload event name for continuity
       with the prior pixel rules, and fire the v18 card_download
       event alongside it. */
    fbTrack('ShareableCardDownload', {
      content_name: 'Fathers Day Quiz 2026',
      archetype: (ARCH[state.archetype] || {}).name || '',
      format: state.cardAspect,
      method: kind
    });
    gaTrack('shareable_card_download', { format: state.cardAspect, method: kind });
    fbTrack('card_download', {
      content_name: 'Fathers Day Quiz 2026',
      archetype: (ARCH[state.archetype] || {}).name || '',
      method: kind
    });
    gaTrack('card_download', {
      archetype: state.archetype,
      method: kind
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function pickHeadline() {
    /* A/B retired. Always serve variant A. The function and the
       state.headlineVariant field are kept so analytics still tag the
       headline name in case the test is ever revived. */
    return 'A';
  }
  /* Clear saved progress and send her back to the intro, a fresh run. */
  function resetQuiz() {
    clearSaved();
    clearBreathTimer();
    tracked = {};
    preloaded = false;
    qImgPreloaded = false;
    state.step = 0;
    state.recipient = '';
    state.stance = '';
    state.email = '';
    state.branch = 'Standard';
    state.answers = [null, null, null, null, null, null];
    state.archetype = '';
    state.scores = {};
    state.firstName = '';
    state.phone = '';
    state.country = 'US';
    state.hisName = '';
    state.fromName = '';
    state.cardAspect = '4x5';
    state.cardMessage = '';
    state.cardGreeting = '';
    state.cardSummons = '';
    state.cardSignoff = '';
    state.characterName = '';
    state.cardCharacter = '';
    state.stepsSeen = false;
    state.presentPromptSeen = false;
    state.sizeKey = '';
    state.cardMsgPreset = '';
    state.cardTheme = '';
    state.giftRoute = '';
    state.unlockCode = '';
    state.notesText = "";
    state.headlineVariant = pickHeadline();
    state.breathShown = { hinge: false };
    state.timing = '';
    goToIntro(false);
  }
  function start() {
    buildShell();
    goToIntro(true);
  }
  function resume(saved) {
    state.recipient = saved.recipient || '';
    state.stance = saved.stance || '';
    state.email = saved.email || '';
    state.phone = saved.phone || '';
    state.branch = saved.branch || 'Standard';
    state.timing = saved.timing || '';
    /* v23 builder fields restored so a refresh inside the builder keeps
       her name, message, and theme picks. */
    state.hisName = saved.hisName || '';
    state.fromName = saved.fromName || '';
    state.cardMessage = saved.cardMessage || '';
    state.cardGreeting = saved.cardGreeting || '';
    state.cardSummons = saved.cardSummons || '';
    state.cardSignoff = saved.cardSignoff || '';
    state.characterName = saved.characterName || '';
    state.cardCharacter = saved.cardCharacter || '';
    state.stepsSeen = !!saved.stepsSeen;
    state.presentPromptSeen = !!saved.presentPromptSeen;
    state.sizeKey = saved.sizeKey || '';
    state.cardMsgPreset = saved.cardMsgPreset || '';
    state.cardTheme = saved.cardTheme || '';
    state.unlockCode = saved.unlockCode || '';
    state.notesText = saved.notesText || "";
    state.answers = (saved.answers && saved.answers.length === QUESTIONS.length) ? saved.answers : new Array(QUESTIONS.length);
    buildShell();
    if (saved.view === 'quiz') {
      state.view = 'quiz';
      state.step = Math.min(saved.step || 0, QUESTIONS.length - 1);
      preloadQuestionImages();
      paintQuestion(true);
      return;
    }
    /* v24: once the four questions are done, the only end screen is the
       builder. Resume there whether she refreshed on it or had finished
       the quiz. Route and card seed are recomputed from her saved
       answers. */
    if (answersComplete()) {
      state.giftRoute = saved.giftRoute || '';
      computeRoute();
      seedCardFromAnswers();
      renderBuilder();
      return;
    }
    goToIntro(true);
  }
  function init() {
    var saved = loadSaved();
    state.headlineVariant = (saved && saved.headlineVariant) || pickHeadline();
    if (saved && (saved.recipient || (saved.answers && saved.answers.some && saved.answers.some(function (x) { return x != null; })))) {
      resume(saved);
      return;
    }
    start();
  }

  /* ---------- Shopify theme editor support ----------
     The editor does not reload the page when a merchant changes a
     section setting. It re renders the section markup in place and
     does not re run this file. So re read the fresh config block and
     rebuild the quiz on every section reload, that way the editor
     preview always matches the image and text settings just saved. */
  function readConfigFromDom() {
    try {
      var el = document.getElementById('ffq-config');
      if (!el) return;
      CONFIG = JSON.parse(el.textContent);
      CONFIG_OK = true;
    } catch (e) { CONFIG_OK = false; return; }
    IMG = CONFIG.images || {};
    Q_IMAGES = CONFIG.questionImages || {};
    GALLERY = computeGallery();
    TRUST = CONFIG.trust || {};
    INTRO_PROOF = CONFIG.introProof || 'I am Jan. I have painted over 1,000 of these by hand since 2022. More than 500 five star reviews.';
    FD_CUTOFF = CONFIG.fathersDayCutoff || '2026-06-07';
    KL = CONFIG.klaviyo || {};
    KL_COMPANY = KL.companyId || 'UeMxA4';
    KL_LIST = KL.listId || 'W8Unvq';
    KL_REVISION = KL.revision || '2025-10-15';
    PRODUCT_URL = CONFIG.productUrl || '/products/fathers-day-portrait-from-photo';
    BREATH = mergeBreathConfig(CONFIG.breath);
    EYEBROW_LABEL = CONFIG.eyebrowLabel || 'FATHER\'S DAY 2026';
  }
  function rebootForEditor() {
    var fresh = document.getElementById('ffq-root');
    if (!fresh) return;
    root = fresh;
    readConfigFromDom();
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e && e.target;
    if (t && (t.id === 'ffq-root' || (t.querySelector && t.querySelector('#ffq-root')))) {
      rebootForEditor();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
